//Lession 3 - Nutrition for Living

export const questions = {
  "1. Introduction to Nutrition": [
    {
      id: 90001,
      question: "Which of the following best describes the relationship between diet, nutrition, and the oral cavity?",
      options: [
        "Diet and nutrition affect and are affected by the condition of the oral cavity",
        "Oral cavity problems are entirely independent of dietary habits and nutritional status",
        "Poor nutrition affects only general health and has no direct impact on the oral cavity",
        "The oral cavity influences nutrition only during childhood development, not in adults"
      ],
      correctAnswer: 0
    },
    {
      id: 90002,
      question: "Which of the following is the BEST definition of \"diet\" in a nutritional context?",
      options: [
        "A temporary eating plan designed to achieve rapid weight loss in overweight individuals",
        "The pattern of an individual's food intake, eating habits, and kinds and amounts of foods eaten",
        "A standardized calorie-controlled meal plan approved by a government health authority",
        "A medical prescription provided by a registered dietician to manage a diagnosed condition"
      ],
      correctAnswer: 1
    },
    {
      id: 90003,
      question: "Why is the oral cavity described as the \"gatekeeper to nutrition\"?",
      options: [
        "The oral cavity determines how many calories are absorbed from each meal consumed daily",
        "The mouth produces bile needed to digest dietary fats and fat-soluble vitamins effectively",
        "The earliest clinical signs of most nutritional deficiencies and toxicities appear in or around the mouth",
        "The mouth controls the speed of digestion occurring throughout the small intestine"
      ],
      correctAnswer: 2
    },
    {
      id: 90004,
      question: "How quickly do oral soft tissues turn over compared to other tissues in the body?",
      options: [
        "Every 7 days, twice as fast as most other body tissues in the human body",
        "Every 30 days, at the same rate as skin found elsewhere on the body surface",
        "Every 21 days, slightly faster than most other body tissues in the human body",
        "Every 14 days, making them especially sensitive to nutritional deficits and changes"
      ],
      correctAnswer: 3
    },
    {
      id: 90005,
      question: "Which of the following is NOT listed as a leading cause of death where poor diet is a known risk factor?",
      options: [
        "Osteoporosis",
        "Heart disease",
        "Stroke",
        "Diabetes"
      ],
      correctAnswer: 0
    },
    {
      id: 90006,
      question: "What is the definition of \"nutrients\" as used in this unit?",
      options: [
        "Any substance in food that provides energy for physical activity and exercise",
        "Biochemical substances that can be supplied only in adequate amounts from an outside source, usually food",
        "Chemical compounds produced by the liver to regulate metabolism and cellular energy production",
        "Supplements manufactured in a laboratory and added to processed food to prevent deficiencies"
      ],
      correctAnswer: 1
    },
    {
      id: 90007,
      question: "Which category of dietary reference standard applies to nutrients for which insufficient data currently exist?",
      options: [
        "Recommended Dietary Allowance (RDA)",
        "Tolerable Upper Level (UL)",
        "Adequate Intake (AI)",
        "Estimated Average Requirement (EAR)"
      ],
      correctAnswer: 2
    },
    {
      id: 90008,
      question: "What does the Estimated Average Requirement (EAR) represent?",
      options: [
        "The maximum daily amount that can be consumed without causing harmful side effects in most people",
        "The minimum nutrient intake required to prevent clinical deficiency symptoms in all age groups",
        "The recommended daily intake needed to meet the requirements of nearly all healthy individuals",
        "The average intake level estimated to meet the requirements of 50% of people within a specific group"
      ],
      correctAnswer: 3
    },
    {
      id: 90009,
      question: "The Tolerable Upper Level (UL) was introduced as a dietary reference category because:",
      options: [
        "High nutrient intakes were shown to cause detrimental health effects in certain population groups",
        "Government agencies required new documentation to update food labeling regulations for packaged foods",
        "Many people were not consuming enough nutrients to meet their daily recommended requirements",
        "Registered dieticians needed standardized guidelines for creating therapeutic nutrition care plans"
      ],
      correctAnswer: 0
    },
    {
      id: 90010,
      question: "The Dietary Reference Intakes (DRIs) are listed for how many groups, and when do gender-based separations begin?",
      options: [
        "20 groups, with gender separation beginning after 12 years of age",
        "16 groups, with gender separation beginning after 10 years of age",
        "12 groups, with gender separation beginning after 8 years of age",
        "18 groups, with gender separation beginning after 14 years of age"
      ],
      correctAnswer: 1
    },
    {
      id: 90011,
      question: "Which of the following statements about Dietary Reference Intakes (DRIs) is correct?",
      options: [
        "DRIs are the same for pregnant and non-pregnant women within the same age group",
        "DRIs apply to all individuals regardless of health status, including those with chronic disease",
        "DRIs are guidelines for healthy people, with separate levels for pregnant and lactating women",
        "DRIs replace Recommended Dietary Allowances and no longer include tolerable upper limit values"
      ],
      correctAnswer: 2
    },
    {
      id: 90012,
      question: "For an individual to maintain a stable body weight, which of the following must be true?",
      options: [
        "Caloric intake from food and beverages must be less than caloric expenditure from all daily functions",
        "Total fat and sugar intake must be restricted regardless of total caloric intake and physical activity",
        "Caloric intake from food must exceed caloric expenditure from physical activity each day",
        "Energy consumed from foods and beverages must equal calories expended in physiologic functions and activity"
      ],
      correctAnswer: 3
    },
    {
      id: 90013,
      question: "Which tool is used to evaluate body weight relative to height in adult men and women?",
      options: [
        "Body Mass Index (BMI), calculated using the individual's height and weight measurements",
        "Skinfold caliper measurement to estimate subcutaneous body fat at multiple body sites",
        "Bioelectrical impedance analysis to measure body fat and lean mass composition ratios",
        "Waist-to-hip ratio to assess central adiposity and cardiovascular disease risk in adults"
      ],
      correctAnswer: 0
    },
    {
      id: 90014,
      question: "Which of the following is a known limitation of BMI as a measure of body composition?",
      options: [
        "BMI is only valid for people under the age of 40 and loses accuracy in older adult populations",
        "BMI does not account for muscle mass, bone density, or overall body composition differences",
        "BMI is too complex a calculation for most healthcare providers to use in clinical practice",
        "BMI only applies to women and cannot be used to evaluate body weight in adult men"
      ],
      correctAnswer: 1
    },
    {
      id: 90015,
      question: "What does the term \"malnutrition\" broadly encompass beyond just undernutrition?",
      options: [
        "Only conditions caused by insufficient caloric intake in developing nations and food-insecure regions",
        "Exclusively deficiencies of specific vitamins and minerals in otherwise well-nourished individuals",
        "Any deviation from optimal nutritional status, including obesity, nutrient excess, and deficiency anemias",
        "Medical conditions caused solely by food allergies and intolerances that limit dietary variety"
      ],
      correctAnswer: 2
    },
    {
      id: 90016,
      question: "Primary malnutrition is MOST commonly caused by which of the following?",
      options: [
        "Drug-nutrient interactions that deplete specific vitamins and minerals despite adequate food intake",
        "Digestive disorders that prevent adequate nutrient absorption from an otherwise adequate diet",
        "Genetic conditions that impair the body's ability to metabolize certain essential macronutrients",
        "Inadequate food intake, typically with a socioeconomic etiology such as food unavailability or cost"
      ],
      correctAnswer: 3
    },
    {
      id: 90017,
      question: "How does secondary (conditioned) malnutrition differ from primary malnutrition?",
      options: [
        "It occurs when physiological factors such as malabsorption syndromes interfere with nutrient utilization despite an adequate diet",
        "It results from an individual choosing to follow extreme elimination or restrictive diet plans",
        "It only affects elderly individuals who experience age-related declines in appetite and intake",
        "It is caused by overconsumption of one nutrient that depletes the stores of competing nutrients"
      ],
      correctAnswer: 0
    },
    {
      id: 90018,
      question: "Which of the following is an example of secondary (conditioned) malnutrition?",
      options: [
        "A child in a food-insecure household who does not have reliable access to adequate daily meals",
        "An individual with a malabsorption syndrome who fails to adequately absorb nutrients from food",
        "A student who consistently skips meals due to time constraints and makes poor dietary choices",
        "An elderly person who cannot afford to buy nutritious food due to limited retirement income"
      ],
      correctAnswer: 1
    },
    {
      id: 90019,
      question: "According to the \"Process of Nutritional Deficiency or Toxicity\" iceberg model, which stage is deepest and least visible?",
      options: [
        "Overt clinical signs such as anatomical lesions that are visible during oral examination",
        "Biochemical abnormalities detectable through laboratory blood and tissue testing",
        "Inappropriate nutrient intake identified through diet history and dietary evaluation methods",
        "Gradual changes in tissue saturation resulting from prolonged suboptimal nutrient intake"
      ],
      correctAnswer: 2
    },
    {
      id: 90020,
      question: "Which of the following is a nonobservable sign of nutritional deficiency according to the iceberg model?",
      options: [
        "Anatomical lesions visible during a routine clinical oral examination of oral soft tissues",
        "Overt deficiency or toxicity symptoms detectable without the use of laboratory testing",
        "Noticeable changes in hair, skin, and nail texture that are visible to the naked eye",
        "Impaired immune function, impaired healing, and changes in cell function or enzyme action"
      ],
      correctAnswer: 3
    },
    {
      id: 90021,
      question: "What role does salivary amylase play during oral digestion?",
      options: [
        "It breaks down large-molecule starches into fermentable carbohydrates in the oral cavity",
        "It neutralizes acids produced by bacteria to protect enamel from demineralization during eating",
        "It lubricates the food bolus to facilitate safe swallowing and prevent choking during meals",
        "It activates pepsinogen in the stomach to initiate protein digestion and breakdown"
      ],
      correctAnswer: 0
    },
    {
      id: 90022,
      question: "Which cells in the stomach are responsible for releasing HCl and secreting intrinsic factor?",
      options: [
        "Goblet cells, which also produce a protective mucus lining for the stomach wall tissue",
        "Parietal cells, which make the stomach contents acidic and produce intrinsic factor",
        "Enteroendocrine cells, which regulate gastric emptying and digestive hormone secretion",
        "Chief cells, which convert inactive pepsinogen into active pepsin for protein digestion"
      ],
      correctAnswer: 1
    },
    {
      id: 90023,
      question: "What is chyme?",
      options: [
        "The enzyme produced by the pancreas that breaks down carbohydrates in the small intestine",
        "The alkaline fluid secreted by the gallbladder to emulsify dietary fats for efficient digestion",
        "The acidic food mass formed in the stomach that then moves into the small intestine",
        "The mixture of bile and digestive enzymes that combines in the duodenum for nutrient breakdown"
      ],
      correctAnswer: 2
    },
    {
      id: 90024,
      question: "Where does the majority of food digestion take place in the human body?",
      options: [
        "In the stomach, where HCl and pepsin break down most nutrients into absorbable units",
        "In the oral cavity, where mechanical and chemical digestion begins with chewing and amylase",
        "In the large intestine, where bacteria further break down undigested residues for absorption",
        "In the small intestine, where carbohydrases, lipases, proteases, and bile act on nutrients"
      ],
      correctAnswer: 3
    },
    {
      id: 90025,
      question: "Which of the following nutrients provides the MOST energy per gram consumed?",
      options: [
        "Fat, which provides 9 kcal per gram of consumed dietary fat",
        "Alcohol, which provides 7 kcal per gram of consumed ethanol",
        "Carbohydrates, which provide 4 kcal per gram of consumed carbohydrate",
        "Protein, which provides 4 kcal per gram of consumed dietary protein"
      ],
      correctAnswer: 0
    },
    {
      id: 90026,
      question: "How many kilocalories per gram does alcohol provide?",
      options: [
        "4 kcal/gram, the same energy density as carbohydrates and protein per gram consumed",
        "7 kcal/gram, more than carbohydrates and protein but less than fat per gram",
        "9 kcal/gram, the same energy density as dietary fat per gram consumed",
        "5 kcal/gram, slightly more than carbohydrates and protein per gram consumed"
      ],
      correctAnswer: 1
    },
    {
      id: 90027,
      question: "Where is energy from food stored in the body over the intermediate term?",
      options: [
        "As triglycerides in adipose tissue distributed throughout the subcutaneous layer",
        "As phosphocreatine in skeletal muscle for rapid energy release during short physical bursts",
        "As glycogen in the liver for intermediate-term storage and release during fasting periods",
        "As amino acids in muscle tissue, which are mobilized during periods of energy deficit"
      ],
      correctAnswer: 2
    },
    {
      id: 90028,
      question: "Where are fat-soluble vitamins primarily stored in the body?",
      options: [
        "In the kidneys, where they are filtered and reabsorbed based on the body's current needs",
        "In the liver, along with protein, iron, and vitamin A reserves for metabolic functions",
        "In bone tissue, along with calcium, phosphorus, and other essential structural minerals",
        "In the adipose tissue, where they can accumulate and become toxic at high intake levels"
      ],
      correctAnswer: 3
    },
    {
      id: 90029,
      question: "Which of the following correctly describes what happens in the large intestine?",
      options: [
        "No digestive activity takes place here; bacteria act on undigested residues and feces are formed",
        "The majority of nutrient digestion occurs here, aided by enzymes secreted by the intestinal lining",
        "Active and passive absorption of most vitamins and minerals occurs across the intestinal wall",
        "Bile from the gallbladder mixes with chyme to facilitate fat digestion and absorption here"
      ],
      correctAnswer: 0
    },
    {
      id: 90030,
      question: "Which organ eliminates most nitrogenous waste, excess water-soluble vitamins, and detoxified substances?",
      options: [
        "The liver, which filters metabolic by-products from the bloodstream during detoxification",
        "The kidneys, which filter and excrete nitrogenous waste, excess vitamins, and other substances",
        "The skin, which eliminates water and small amounts of minerals through the process of perspiration",
        "The lungs, which remove carbon dioxide and water vapor through the process of respiration"
      ],
      correctAnswer: 1
    },
    {
      id: 90031,
      question: "Which of the following is a biological factor that can influence food habits and choices?",
      options: [
        "Limited financial resources that reduce an individual's access to fresh or nutritious food options",
        "Social occasions and celebrations that traditionally include specific culturally significant foods",
        "Genetically determined differences in the ability to taste sweet, sour, and bitter flavors",
        "Religious dietary restrictions that prohibit certain foods at specific times throughout the year"
      ],
      correctAnswer: 2
    },
    {
      id: 90032,
      question: "Which of the following BEST describes a socioeconomic factor influencing dietary habits?",
      options: [
        "A genetic predisposition to prefer certain tastes such as sweet or savory food flavors",
        "A gastrointestinal condition such as lactose intolerance that limits the range of foods tolerated",
        "A religious practice that prohibits eating certain animal products or specific food combinations",
        "Limited economic resources that make purchasing fresh foods difficult because processed foods last longer"
      ],
      correctAnswer: 3
    },
    {
      id: 90033,
      question: "Which of the following is an example of a psychological factor that influences food habits?",
      options: [
        "Using food as a way to cope with emotions or to exert a sense of personal control over one's life",
        "Lactose intolerance, which causes gastrointestinal discomfort after consuming dairy-based products",
        "Cultural food traditions passed down through generations in a specific ethnic community",
        "Structural changes in the oral cavity with age that alter preference for highly flavored foods"
      ],
      correctAnswer: 0
    },
    {
      id: 90034,
      question: "Which of the following is a cultural, experiential, or religious factor that shapes food habits?",
      options: [
        "A reduced ability to taste food due to age-related changes in the oral cavity and taste receptors",
        "Most religions have specific foods that are eaten at certain times or are entirely prohibited",
        "Food availability in local grocery stores, which limits the variety of foods accessible to purchase",
        "Emotional eating patterns developed in response to chronic stress or anxiety throughout life"
      ],
      correctAnswer: 1
    },
    {
      id: 90035,
      question: "Which dietary habit is cited as an example of social and lifestyle factors influencing food choices?",
      options: [
        "Avoiding dairy products because of genetically determined lactose malabsorption conditions",
        "Preferring sweet foods because of a genetic variation in individual taste receptor sensitivity",
        "Choosing not to eat breakfast because of not being a \"morning person\"",
        "Eating comfort foods such as chicken soup in response to emotional distress or illness"
      ],
      correctAnswer: 2
    },
    {
      id: 90036,
      question: "What is the stated significance of frequent family meals, according to this unit?",
      options: [
        "Family meals reduce overall caloric intake because portions tend to be smaller in a group setting",
        "Family meals lower healthcare costs by reducing the incidence of obesity-related chronic disease",
        "Family meals increase nutrient diversity by exposing children to a wider range of world cuisines",
        "Family meals have been shown to improve the eating habits of children over time"
      ],
      correctAnswer: 3
    },
    {
      id: 90037,
      question: "What proportion of all deaths in North America is accounted for by diet-related diseases?",
      options: [
        "Two-thirds of all deaths in North America",
        "One-quarter of all deaths in North America",
        "One-half of all deaths in North America",
        "Three-quarters of all deaths in North America"
      ],
      correctAnswer: 0
    },
    {
      id: 90038,
      question: "According to this unit, what is a key goal of today's nutritional research?",
      options: [
        "To develop synthetic nutrient supplements that can fully replace whole food consumption",
        "To determine how nutrition can help prevent chronic diseases and prolong healthy life",
        "To identify new food additives that enhance palatability without increasing caloric density",
        "To establish universal caloric intake guidelines that apply equally to all demographic populations"
      ],
      correctAnswer: 1
    },
    {
      id: 90039,
      question: "Which of the following BEST describes the role of the dental hygienist in relation to nutrition?",
      options: [
        "To prescribe therapeutic diets for clients with complex nutritional needs related to oral health",
        "To conduct laboratory-based nutritional assessments to independently diagnose nutrient deficiencies",
        "To identify harmful dietary habits, promote wellness, support other professionals, and refer clients with complex nutrition needs to a registered dietician",
        "To independently manage all nutrition-related health concerns without referral to other professionals"
      ],
      correctAnswer: 2
    },
    {
      id: 90040,
      question: "Which of the following correctly describes \"good nutrition\" as it is evaluated in a clinical context?",
      options: [
        "Good nutrition is defined solely by total caloric intake and is the same for all individuals",
        "Good nutrition is determined exclusively by comparing an individual's diet to the RDA values",
        "Good nutrition considers only a client's physiologic needs for macronutrients, excluding cultural factors",
        "Good nutrition must be evaluated in context, including physiologic needs, nutrient content, cultural circumstances, and personal preferences"
      ],
      correctAnswer: 3
    },
    {
      id: 90041,
      question: "The oral cavity is the pathway to the rest of the body, meaning oral problems can profoundly affect appetite, diet, and nutritional status.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90042,
      question: "Dental hygienists may see clients more regularly than many other health professionals, giving them a unique opportunity to support nutrition-related health interventions.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90043,
      question: "The Recommended Dietary Allowance (RDA) is designed to meet the nutritional needs of exactly 50% of the population within a specific age and gender group.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90044,
      question: "Overweight and obesity are described in this unit as problems of epidemic proportions in today's society.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90045,
      question: "No digestive activity occurs in either the esophagus or the large intestine.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
  ],
  "2. Nutritional Aspects of Dental Caries": [
    {
      id: 90101,
      question: "Which of the following best describes dental caries as an oral disease?",
      options: [
        "A non-infectious condition caused only by poor brushing habits",
        "A multifactorial, transmissible, and bacterially-originated infectious disease",
        "A systemic disease unrelated to dietary intake or microbial factors",
        "A congenital condition caused by enamel defects present at birth"
      ],
      correctAnswer: 1
    },
    {
      id: 90102,
      question: "Which combination of factors is required for dental caries to develop?",
      options: [
        "Susceptible tooth, cariogenic bacteria, fermentable carbohydrates, and specific saliva conditions",
        "Acidic foods, poor fluoride exposure, genetic predisposition, and age over 40",
        "Plaque biofilm, high protein diet, reduced salivary pH, and enamel hypoplasia",
        "Sugar alcohols, low salivary flow, vitamin C deficiency, and tooth crowding"
      ],
      correctAnswer: 0
    },
    {
      id: 90103,
      question: "What is the primary oral health goal of Healthy People 2030?",
      options: [
        "To eliminate all processed sugars from the diets of children under 5 years",
        "To improve oral health by increasing access to oral health care",
        "To mandate fluoride supplementation for all citizens over age 2",
        "To promote water fluoridation in all communities across the United States"
      ],
      correctAnswer: 1
    },
    {
      id: 90104,
      question: "Which nutrients, when adequate during the pre-eruptive phase, help teeth resist demineralization?",
      options: [
        "Iron, zinc, vitamin B12, magnesium, and omega-3 fatty acids",
        "Sodium, potassium, vitamin E, folate, and selenium",
        "Calcium, phosphorus, vitamins A, C, and D, fluoride, and protein",
        "Biotin, riboflavin, vitamin K, copper, and manganese"
      ],
      correctAnswer: 2
    },
    {
      id: 90105,
      question: "Which structural characteristic of teeth increases their susceptibility to caries?",
      options: [
        "Smooth interproximal surfaces with broad contact areas",
        "Thin enamel layer caused by aging and normal wear",
        "Macrodontia, or abnormally large tooth crowns",
        "Deep pits and fissures on the occlusal surface"
      ],
      correctAnswer: 3
    },
    {
      id: 90106,
      question: "Which of the following is a host factor that can influence caries susceptibility?",
      options: [
        "Concentration of fluoride in local water supply",
        "Type and frequency of professional dental treatments received",
        "Socioeconomic status, genetics, age, and oral hygiene habits",
        "Number of cariogenic bacteria present in the patient's diet"
      ],
      correctAnswer: 2
    },
    {
      id: 90107,
      question: "How does saliva help protect teeth from dental caries?",
      options: [
        "It deposits fluoride ions directly into the enamel surface",
        "It contains bicarbonate, phosphate, and protein that buffer plaque acids",
        "It kills Streptococcus mutans through enzymatic breakdown of glucans",
        "It prevents food particles from adhering to the tooth surface entirely"
      ],
      correctAnswer: 1
    },
    {
      id: 90108,
      question: "How does diet influence the composition of plaque biofilm?",
      options: [
        "High-fat foods increase plaque density but reduce bacterial activity",
        "Proteins in plaque biofilm neutralize carbohydrate fermentation products",
        "Sucrose and glucose metabolism produce acids that lower pH and encourage bacterial growth",
        "Dietary fiber clears the mouth and prevents any biofilm from forming"
      ],
      correctAnswer: 2
    },
    {
      id: 90109,
      question: "After a carbohydrate is ingested, how quickly does metabolism by salivary amylase begin?",
      options: [
        "Within 10 to 15 minutes and persists for about 30 minutes",
        "Within 2 to 3 minutes and can persist for several hours",
        "Within 5 to 8 minutes and resolves within the same meal",
        "Within 20 to 30 minutes and stops when saliva flow normalizes"
      ],
      correctAnswer: 1
    },
    {
      id: 90110,
      question: "What role does sucrose play in the caries process beyond providing fermentable substrate?",
      options: [
        "It breaks down enamel proteins and initiates root surface decay directly",
        "It neutralizes saliva buffering agents, reducing their protective capacity",
        "It is used to produce glucans that help S. mutans adhere to the dental pellicle",
        "It causes rapid salivary gland suppression during chewing and swallowing"
      ],
      correctAnswer: 2
    },
    {
      id: 90111,
      question: "Why are processed starches considered more cariogenic than their unprocessed counterparts?",
      options: [
        "They contain added sugars that significantly increase fermentation rates",
        "They require more chewing, creating more surface contact with enamel",
        "They are partially hydrolyzed or reduced in particle size, making them more fermentable",
        "They contain less water, allowing them to stick to teeth for longer periods"
      ],
      correctAnswer: 2
    },
    {
      id: 90112,
      question: "Which property makes nonnutritive sweeteners such as aspartame and saccharin cariostatic?",
      options: [
        "They actively raise the pH of plaque above the critical demineralization threshold",
        "They are not metabolized by oral microorganisms and do not promote caries",
        "They stimulate high salivary flow rates that clear fermentable sugars quickly",
        "They bind to enamel surfaces and form a protective layer against acid attack"
      ],
      correctAnswer: 1
    },
    {
      id: 90113,
      question: "Why are foods high in protein and fat (such as meat, eggs, and nuts) considered cariostatic?",
      options: [
        "They contain natural antimicrobial compounds that kill S. mutans directly",
        "They dissolve slowly in saliva and provide a sustained buffering effect",
        "They do not lower plaque pH when consumed and thus do not promote caries",
        "They coat tooth surfaces with a protective film that blocks acid penetration"
      ],
      correctAnswer: 2
    },
    {
      id: 90114,
      question: "Why are sugar alcohols considered to have anticariogenic potential?",
      options: [
        "They contain no calories and therefore produce no metabolic by-products",
        "They are fermented more slowly, allowing saliva to neutralize any acids produced",
        "They are completely insoluble in water and pass through the mouth without contact",
        "They directly inhibit salivary amylase and prevent starch from being broken down"
      ],
      correctAnswer: 1
    },
    {
      id: 90115,
      question: "Which of the following best explains why xylitol is specifically beneficial in caries prevention?",
      options: [
        "It increases salivary pH directly by releasing alkaline ions during digestion",
        "It bonds with calcium in enamel to reverse early demineralization lesions",
        "Oral flora lack the enzymes needed to ferment xylitol, so S. mutans is inhibited",
        "It increases the viscosity of saliva, preventing bacteria from adhering to teeth"
      ],
      correctAnswer: 2
    },
    {
      id: 90116,
      question: "Which food component found in chocolate demonstrated anticariogenic properties in the Vipeholm study?",
      options: [
        "Cocoa butter, which coats teeth and reduces acid contact time",
        "Theobromine, a bitter alkaloid that neutralizes plaque acids",
        "The cocoa factor, a constituent with demonstrated anticariogenic effects",
        "Flavonoids, which kill oral bacteria by disrupting their cell membranes"
      ],
      correctAnswer: 2
    },
    {
      id: 90117,
      question: "What is glycyrrhiza and why is it relevant to dental caries?",
      options: [
        "A preservative used in candy that contributes to tooth decay over time",
        "The active ingredient in licorice, which has shown anticariogenic properties",
        "A form of fermentable sugar found in natural licorice root extract",
        "A salivary enzyme that helps break down sucrose during chewing"
      ],
      correctAnswer: 1
    },
    {
      id: 90118,
      question: "Which of the following is a key dental hygiene consideration for high-risk caries patients?",
      options: [
        "Recommend a low-fluoride toothpaste to reduce sensitivity issues",
        "Advise patients to consume fermentable carbohydrates at night before sleep",
        "Encourage use of a chlorhexidine, fluoride, and xylitol protocol",
        "Suggest increasing the frequency of sugary snacks spread evenly through the day"
      ],
      correctAnswer: 2
    },
    {
      id: 90119,
      question: "Which dietary factor directly relates to the frequency of acid attacks on enamel?",
      options: [
        "The total amount of protein consumed per day",
        "The number of meals and snacks containing carbohydrates consumed daily",
        "The ratio of saturated fats to unsaturated fats in the daily diet",
        "The level of vitamin D absorbed through dietary and supplemental sources"
      ],
      correctAnswer: 1
    },
    {
      id: 90120,
      question: "How long does salivary pH remain below the critical level after consuming a carbohydrate-containing food?",
      options: [
        "Approximately 10 minutes, then slowly returns to baseline",
        "Approximately 20 minutes before salivary buffering restores pH",
        "Approximately 40 minutes, during which enamel demineralization can occur",
        "Approximately 60 minutes, particularly after highly sticky foods"
      ],
      correctAnswer: 2
    },
    {
      id: 90121,
      question: "Why is eating fermentable carbohydrates close to bedtime particularly harmful to teeth?",
      options: [
        "Nighttime hormones increase acidity in the mouth during sleep cycles",
        "Salivary flow is reduced during sleep, limiting the buffering and clearance of acids",
        "Fermentation by oral bacteria accelerates significantly in the absence of light",
        "The body's immune response is suppressed during sleep, allowing bacteria to thrive"
      ],
      correctAnswer: 1
    },
    {
      id: 90122,
      question: "How does eating cheese at the end of a meal benefit dental health?",
      options: [
        "Cheese contains xylitol which directly inhibits S. mutans from adhering to teeth",
        "Cheese raises salivary pH quickly by releasing bicarbonate into the oral cavity",
        "Dairy products like cheese reduce demineralization and help buffer bacterial acids",
        "Cheese stimulates rapid salivary flow that mechanically removes food debris"
      ],
      correctAnswer: 2
    },
    {
      id: 90123,
      question: "Which type of food is classified as a \"retentive carbohydrate\" that increases caries risk?",
      options: [
        "Raw carrots, celery, and other fibrous vegetables consumed as snacks",
        "Low-fat yogurt, aged cheeses, and unsweetened milk products",
        "Bakery items, crackers, potato chips, and pretzels",
        "Whole fresh fruits like apples and pears eaten at meals"
      ],
      correctAnswer: 2
    },
    {
      id: 90124,
      question: "Why are diet soft drinks still considered harmful to teeth despite having no sugar?",
      options: [
        "Artificial sweeteners in diet sodas promote acid production by oral bacteria",
        "Diet soft drinks contain added citric and phosphoric acids that demineralize enamel",
        "The carbonation in diet sodas erodes tooth enamel through a fizzing reaction",
        "Caramel coloring in diet sodas stains enamel and weakens the surface layer"
      ],
      correctAnswer: 1
    },
    {
      id: 90125,
      question: "What does a sialagogue do and how does it benefit oral health?",
      options: [
        "It kills oral bacteria directly by releasing antimicrobial agents into saliva",
        "It coats tooth surfaces with a thin protective layer of calcium phosphate",
        "It stimulates salivary flow, promoting acid buffering and oral clearance of food",
        "It deposits fluoride ions into enamel to reverse early demineralization lesions"
      ],
      correctAnswer: 2
    },
    {
      id: 90126,
      question: "Which of the following snacks is considered noncariogenic and appropriate to recommend to a caries-risk patient?",
      options: [
        "Granola bars, dried apricots, and juice-based beverages",
        "Breath mints, hard candy, and flavored antacid tablets",
        "Crackers, pretzels, and instant oatmeal with brown sugar",
        "Raw vegetables, low-fat cheese, nuts, seeds, and yogurt"
      ],
      correctAnswer: 3
    },
    {
      id: 90127,
      question: "What is the first step in the Caries Management by Risk Assessment (CaMBRA) process?",
      options: [
        "Implementing a customized fluoride and chlorhexidine treatment protocol",
        "Identifying disease indicators, caries risk factors, and caries protective factors through clinical evaluation",
        "Providing the patient with a 3-day food diary and reviewing their dietary patterns",
        "Scheduling a follow-up appointment to evaluate the effectiveness of dietary changes"
      ],
      correctAnswer: 1
    },
    {
      id: 90128,
      question: "Which tool is recommended for assessing a patient's adequacy of food intake during a dental hygiene care plan?",
      options: [
        "The DASH diet framework adjusted for oral health considerations",
        "A body mass index calculator combined with a salivary pH test",
        "The CaMBRA scoring system applied to laboratory nutritional data",
        "MyPlate, used as a guide in cooperation with the patient"
      ],
      correctAnswer: 3
    },
    {
      id: 90129,
      question: "According to the CaMBRA scoring system, what score range indicates a HIGH caries risk level?",
      options: [
        "-8 to -2",
        "-1 to +2",
        "+3 to +17",
        "+18 to +30"
      ],
      correctAnswer: 2
    },
    {
      id: 90130,
      question: "Which of the following scores qualifies a client for nutritional counseling eligibility based on the 24-hour food diet?",
      options: [
        "A caries risk score of 3 or more from the food diary alone",
        "A caries risk score of 7 or more from the 24-hour food diet",
        "A caries risk score of 5 or more from the food diary alone",
        "A caries risk score of 10 or more based on the food diary"
      ],
      correctAnswer: 1
    },
    {
      id: 90131,
      question: "Which of the following is listed as a caries risk factor in the clinical CaMBRA assessment form?",
      options: [
        "Daily use of 0.05% sodium fluoride mouth rinse",
        "Living in a community with fluoridated water supply",
        "Frequent snacking more than 3 times per day between meals",
        "Regular use of calcium phosphate toothpaste (MI paste)"
      ],
      correctAnswer: 2
    },
    {
      id: 90132,
      question: "Which of the following correctly describes an \"extreme\" caries risk classification?",
      options: [
        "A score of +3 to +17 with no evidence of active disease indicators",
        "A score of -1 to +2 with moderate plaque presence and one cavity",
        "A score of +18 to +30 and/or high risk level with observed hyposalivation",
        "A score of -8 to -2 with very few protective factors documented"
      ],
      correctAnswer: 2
    },
    {
      id: 90133,
      question: "Why does the dental hygiene care plan emphasize that education alone is insufficient for behavioral change?",
      options: [
        "Patients are often unable to understand dietary recommendations given verbally",
        "Assessment and individualized goals are necessary as the basis for effective recommendations",
        "Educational materials must be supplemented with mandatory follow-up testing",
        "Behavioral change requires pharmacological intervention in addition to counseling"
      ],
      correctAnswer: 1
    },
    {
      id: 90134,
      question: "Which of the following is a protective factor included in the CaMBRA caries risk assessment form?",
      options: [
        "Presence of orthodontic appliances or removable partial dentures",
        "Recession noted on clinical exam with exposed root surfaces",
        "Adequate salivary flow greater than 1 mL/min when stimulated",
        "Moderate plaque presence on teeth as noted on clinical exam"
      ],
      correctAnswer: 2
    },
    {
      id: 90135,
      question: "What is the Healthy People 2030 recommendation specifically related to sugar consumption?",
      options: [
        "Eliminate all added sugars from the diets of people under 18 years of age",
        "Reduce consumption of added sugars by people aged 2 years and over",
        "Replace all refined sugars with sugar alcohols in processed food products",
        "Limit total carbohydrate intake to less than 45% of total daily caloric intake"
      ],
      correctAnswer: 1
    },
    {
      id: 90136,
      question: "Which of the following physical forms of carbohydrates poses the greatest sustained caries risk due to slow clearance from the oral cavity?",
      options: [
        "Fresh fruit juices consumed quickly through a straw during a meal",
        "Cooked vegetables served at the end of a balanced dinner",
        "Slowly dissolving items such as hard candy, cough drops, and breath mints",
        "Whole grain bread eaten at mealtime with protein-rich accompaniments"
      ],
      correctAnswer: 2
    },
    {
      id: 90137,
      question: "Dental caries is considered a non-transmissible disease that cannot be passed between individuals.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90138,
      question: "Saliva acts as a buffer by neutralizing acids produced by plaque biofilm, and normal saliva contains bicarbonate, phosphate, and protein.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90139,
      question: "Processed starches such as instant oatmeal are less cariogenic than their unprocessed counterparts because processing removes fermentable sugars.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90140,
      question: "Xylitol is anticariogenic because oral flora do not possess the enzymes necessary to ferment it, thereby inhibiting S. mutans.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90141,
      question: "Diet soft drinks are safe for teeth because they contain no sugar and therefore cause no demineralization of enamel.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
  ],
  "3. Carbohydrates": [
    {
      id: 90201,
      question: "What is the primary basis used to classify carbohydrates?",
      options: [
        "The speed at which they are digested and absorbed into the bloodstream",
        "The number of carbon atoms present in the molecule",
        "Whether they are derived from plant or animal food sources",
        "Their glycemic index value and impact on blood sugar levels"
      ],
      correctAnswer: 1
    },
    {
      id: 90202,
      question: "Which of the following best describes why carbohydrates are considered the most economical form of energy?",
      options: [
        "They are the densest source of energy per gram compared to proteins and fats",
        "They can be stored in unlimited quantities in the liver without health consequences",
        "They add variety and palatability to the diet and have historically been widely available",
        "They require no digestion before being absorbed directly into the bloodstream"
      ],
      correctAnswer: 2
    },
    {
      id: 90203,
      question: "Which statement correctly describes a monosaccharide?",
      options: [
        "It requires enzymatic breakdown before it can be utilized by the body",
        "It is composed of two simple sugars linked together by a glycosidic bond",
        "It is absorbed without further digestion and represents the simplest sugar unit",
        "It contains at least ten simple sugar units and provides long-lasting energy"
      ],
      correctAnswer: 2
    },
    {
      id: 90204,
      question: "Which monosaccharide is naturally abundant in grapes, oranges, dates, and corn?",
      options: [
        "Fructose, the primary sugar found in most tropical and stone fruits",
        "Galactose, a monosaccharide that is rarely found free in nature",
        "Maltose, a disaccharide commonly produced during starch digestion",
        "Glucose, a simple sugar naturally occurring in many fruits and vegetables"
      ],
      correctAnswer: 3
    },
    {
      id: 90205,
      question: "Where is fructose naturally found as a monosaccharide?",
      options: [
        "Primarily in dairy products such as milk, cheese, and yogurt",
        "In honey and fruits as a naturally occurring simple sugar",
        "Almost exclusively in refined table sugar and processed beverages",
        "In cereal grains and root vegetables as a stored energy form"
      ],
      correctAnswer: 1
    },
    {
      id: 90206,
      question: "Which monosaccharide is described as being rarely found free in nature?",
      options: [
        "Glucose, which circulates freely in the blood at all times",
        "Fructose, which is released from sucrose during digestion",
        "Galactose, which is typically bound in the disaccharide lactose",
        "Maltose, which appears only during fermentation and malting processes"
      ],
      correctAnswer: 2
    },
    {
      id: 90207,
      question: "What is a disaccharide and how does it behave in the body?",
      options: [
        "A simple sugar absorbed instantly without enzymatic processing",
        "A carbohydrate of at least 10 sugar units that is slowly digested",
        "Two simple sugars joined together that must be digested before contributing to body functions",
        "A storage form of glucose found primarily in liver and muscle tissue"
      ],
      correctAnswer: 2
    },
    {
      id: 90208,
      question: "Which disaccharide is most commonly recognized as granulated table sugar?",
      options: [
        "Lactose, which is produced naturally in mammalian milk",
        "Maltose, which contains two glucose molecules linked together",
        "Sucrose, the most widely used form of refined dietary sugar",
        "Fructose, a simple sugar found in processed food and beverages"
      ],
      correctAnswer: 2
    },
    {
      id: 90209,
      question: "Which disaccharide is known as the sugar found in milk?",
      options: [
        "Sucrose, a combination of glucose and galactose in equal parts",
        "Lactose, the naturally occurring sugar in all types of milk",
        "Maltose, which is formed during the breakdown of starch",
        "Galactose, a monosaccharide that is bonded with fructose in milk"
      ],
      correctAnswer: 1
    },
    {
      id: 90210,
      question: "What is unique about maltose compared to other disaccharides?",
      options: [
        "It is composed of one glucose and one fructose molecule bonded together",
        "It is found naturally in honey and is the sweetest of all disaccharides",
        "It consists of two glucose molecules linked together by an alpha bond",
        "It cannot be broken down by human digestive enzymes in the small intestine"
      ],
      correctAnswer: 2
    },
    {
      id: 90211,
      question: "What is the minimum number of monosaccharide units that classifies a carbohydrate as a polysaccharide?",
      options: [
        "3 monosaccharide units linked in a branching chain structure",
        "5 monosaccharide units forming a cyclic ring configuration",
        "8 monosaccharide units connected in a straight-chain polymer",
        "10 monosaccharide units of various simple sugars joined together"
      ],
      correctAnswer: 3
    },
    {
      id: 90212,
      question: "Which food sources are considered major dietary sources of starch as a complex carbohydrate?",
      options: [
        "Dairy products, red meat, eggs, and processed cheese products",
        "Roots, vegetables, cereal grains, and legumes as whole food sources",
        "Honey, table sugar, fruit juices, and refined syrup products",
        "Nuts, seeds, plant oils, and high-fat animal protein sources"
      ],
      correctAnswer: 1
    },
    {
      id: 90213,
      question: "What is glycogen and where is it found in the body?",
      options: [
        "A digestive enzyme that breaks down complex starches in the small intestine",
        "A structural protein that supports the integrity of muscle and connective tissue",
        "The carbohydrate storage form of energy found in the liver and muscles",
        "A type of soluble dietary fiber that feeds beneficial bacteria in the colon"
      ],
      correctAnswer: 2
    },
    {
      id: 90214,
      question: "What is meant by \"resistant starch\" in the context of dietary fiber?",
      options: [
        "Starch that has been chemically modified to slow digestion in the stomach",
        "A form of dietary fiber that cannot be digested by human enzymes",
        "Starch found in raw vegetables that resists cooking and softening",
        "A type of industrial fiber added to processed foods during manufacturing"
      ],
      correctAnswer: 1
    },
    {
      id: 90215,
      question: "What is \"functional fiber\" as defined in carbohydrate nutrition?",
      options: [
        "Natural dietary fiber that is inherent to whole plant-based food sources",
        "Soluble fiber that becomes viscous and slows gastric emptying after meals",
        "Fiber that is added to food products during the manufacturing process",
        "Fiber that functions to support immune health and reduce inflammation"
      ],
      correctAnswer: 2
    },
    {
      id: 90216,
      question: "Which of the following correctly describes the AMDR for carbohydrates?",
      options: [
        "No less than 30% and no more than 50% of total daily caloric intake",
        "No less than 45% and no more than 65% of total daily caloric intake",
        "No less than 55% and no more than 75% of total daily caloric intake",
        "No less than 20% and no more than 40% of total daily caloric intake"
      ],
      correctAnswer: 1
    },
    {
      id: 90217,
      question: "What is the primary rationale behind the carbohydrate AMDR?",
      options: [
        "To regulate body weight by limiting fermentable sugar intake",
        "To prevent dental caries by reducing overall sugar consumption",
        "To provide energy for the body, particularly for brain cell function",
        "To ensure adequate fiber intake for gastrointestinal health"
      ],
      correctAnswer: 2
    },
    {
      id: 90218,
      question: "According to the slides, approximately what percentage of total caloric intake comes from naturally occurring sugars in fruits and vegetables?",
      options: [
        "About 5% of total caloric intake from natural food sources",
        "About 10% of total caloric intake from plant-based foods",
        "About 18% of total caloric intake from fruits and vegetables",
        "About 25% of total caloric intake from unprocessed plant foods"
      ],
      correctAnswer: 2
    },
    {
      id: 90219,
      question: "What blood glucose level defines hyperglycemia before meals?",
      options: [
        "Greater than 100 mg/dL when measured in a fasting state",
        "Greater than 115 mg/dL before consuming any food or beverage",
        "Greater than 130 mg/dL before meals or over 180 mg/dL two hours after eating",
        "Greater than 150 mg/dL when tested in the early morning hours"
      ],
      correctAnswer: 2
    },
    {
      id: 90220,
      question: "What blood glucose level is used to define hypoglycemia?",
      options: [
        "A blood glucose level less than 70 mg/dL",
        "A blood glucose level less than 90 mg/dL",
        "A blood glucose level less than 50 mg/dL",
        "A blood glucose level less than 110 mg/dL"
      ],
      correctAnswer: 0
    },
    {
      id: 90221,
      question: "What is a potential nutritional consequence of consuming a diet high in added sugars?",
      options: [
        "Increased intake of fat-soluble vitamins due to energy-dense food choices",
        "Elevated protein intake that can lead to excess nitrogen in the bloodstream",
        "Inadequate intake of foods containing essential micronutrients",
        "Reduced fiber intake combined with excessive mineral absorption rates"
      ],
      correctAnswer: 2
    },
    {
      id: 90222,
      question: "What is the predominant dietary issue identified in North American diets related to carbohydrates?",
      options: [
        "Insufficient total carbohydrate intake leading to widespread ketosis",
        "Overconsumption of dietary fiber causing gastrointestinal complications",
        "Low quality food choices combined with an overall high-energy diet",
        "Excessive starch consumption replacing protein in most daily meals"
      ],
      correctAnswer: 2
    },
    {
      id: 90223,
      question: "What have four leading scientific and health organizations concluded about dietary sugars and obesity?",
      options: [
        "Dietary sugars are the primary and direct cause of obesity and chronic disease",
        "Dietary sugars in any form are associated with at least moderate chronic disease risk",
        "Dietary sugars are not independently associated with causing illness or chronic disease",
        "Dietary sugars must be completely eliminated from the diet to prevent obesity"
      ],
      correctAnswer: 2
    },
    {
      id: 90224,
      question: "Which dietary pattern has been associated with healthier body weights and fat stores according to some studies?",
      options: [
        "A high-protein, low-carbohydrate diet that limits grain consumption entirely",
        "A higher intake of whole grains associated with healthier weight outcomes",
        "A moderate-fat Mediterranean diet emphasizing olive oil and legumes",
        "A calorie-restricted diet that eliminates all added sugars and refined starches"
      ],
      correctAnswer: 1
    },
    {
      id: 90225,
      question: "What does current research suggest regarding the relationship between added sugars and cardiovascular disease?",
      options: [
        "All studies conclusively confirm that any added sugar directly causes heart disease",
        "There is no research linking dietary sugar intake to any cardiovascular risk factors",
        "Studies show mixed findings, with some linking high sugar diets to CVD risk factors while controlled trials using moderate amounts show no correlation",
        "Only naturally occurring sugars have been linked to cardiovascular disease risk"
      ],
      correctAnswer: 2
    },
    {
      id: 90226,
      question: "Why are sugar-sweetened beverages (SSBs) considered a limited measure of total sugar intake in research?",
      options: [
        "SSBs contain only naturally occurring sugars and no added sugar content",
        "The sugar in SSBs is fully absorbed before reaching the large intestine",
        "Although the most prevalent form, SSBs may not fully represent an individual's total sugar intake",
        "Research has shown that SSBs contain less sugar than solid food sources"
      ],
      correctAnswer: 2
    },
    {
      id: 90227,
      question: "What is a potential consequence of following an extremely low-carbohydrate diet?",
      options: [
        "Excessive accumulation of glycogen in the liver and skeletal muscle",
        "Development of ketosis due to insufficient carbohydrate availability",
        "Hypoglycemic episodes caused by overconsumption of dietary protein",
        "Elevated blood glucose levels from increased fat metabolism processes"
      ],
      correctAnswer: 1
    },
    {
      id: 90228,
      question: "Which nutrients may become deficient when complex carbohydrates are eliminated from the diet?",
      options: [
        "Vitamins A, C, and D along with calcium and essential fatty acids",
        "B vitamins, iron, and dietary fiber from whole grain and legume sources",
        "Zinc, selenium, and vitamin K from plant-based food elimination",
        "Sodium, potassium, and magnesium from reduced carbohydrate foods"
      ],
      correctAnswer: 1
    },
    {
      id: 90229,
      question: "According to the ADA, what is the relationship between carbohydrates and optimal nutrition?",
      options: [
        "Carbohydrates should be minimized because they contribute to dental caries",
        "Carbohydrates provide the energy required for optimal nutritional health",
        "Carbohydrates are nonessential because protein can replace their energy function",
        "Carbohydrates serve only structural roles and do not contribute significantly to energy"
      ],
      correctAnswer: 1
    },
    {
      id: 90230,
      question: "Which beverages cause the greatest enamel erosion, ranked from most to least erosive?",
      options: [
        "Diet soda, regular soda, sports drinks, and energy drinks in that order",
        "Regular soda, diet soda, energy drinks, and sports drinks in that order",
        "Energy drinks, sports drinks, regular soda, and diet soda in that order",
        "Sports drinks, energy drinks, diet soda, and regular soda in that order"
      ],
      correctAnswer: 2
    },
    {
      id: 90231,
      question: "At what pH level does dental erosion become a concern with frequent liquid consumption?",
      options: [
        "Any liquid with a pH lower than 6.0 causes progressive enamel loss",
        "Any liquid with a pH lower than 5.5 begins to demineralize enamel surfaces",
        "Any liquid with a pH lower than 4.2 can cause dental erosion with repeated exposure",
        "Any liquid with a pH lower than 3.0 is considered erosive to tooth structure"
      ],
      correctAnswer: 2
    },
    {
      id: 90232,
      question: "What is the effect of substituting glucose or fructose for sucrose in terms of caries prevention?",
      options: [
        "Replacing sucrose with glucose eliminates cariogenic activity completely",
        "Substituting fructose for sucrose is highly effective in preventing dental caries",
        "Replacing sucrose with either glucose or fructose is not significantly effective in reducing caries",
        "Both glucose and fructose are entirely noncariogenic alternatives to table sugar"
      ],
      correctAnswer: 2
    },
    {
      id: 90233,
      question: "What has research shown about the relationship between total carbohydrate consumption and dental caries?",
      options: [
        "Total carbohydrate consumption is the single strongest predictor of caries development",
        "No definite relationship has been shown between total carbohydrate intake and caries",
        "Reducing total carbohydrates by 50% guarantees a significant reduction in caries risk",
        "Total carbohydrates directly cause caries regardless of food form or frequency of intake"
      ],
      correctAnswer: 1
    },
    {
      id: 90234,
      question: "How does an anticariogenic substance reduce the risk of dental caries?",
      options: [
        "It raises plaque pH above the critical threshold to prevent demineralization",
        "It physically removes bacteria from tooth surfaces through mechanical action",
        "It prevents bacteria from recognizing and metabolizing a cariogenic food",
        "It strengthens enamel by depositing calcium and phosphate ions directly"
      ],
      correctAnswer: 2
    },
    {
      id: 90235,
      question: "Which statement best describes the origin of most nonnutritive sweeteners?",
      options: [
        "They are entirely petroleum-based compounds with no natural precursors",
        "They are synthesized compounds derived from fruits, herbs, or sugar itself",
        "They are extracted directly from plant roots without any chemical modification",
        "They are fermented sugar alcohols produced through microbial processes"
      ],
      correctAnswer: 1
    },
    {
      id: 90236,
      question: "What trend has been observed regarding nonnutritive sweetener consumption and American BMI?",
      options: [
        "American BMIs have decreased steadily as nonnutritive sweetener use has grown",
        "BMI trends and nonnutritive sweetener use show no observable relationship",
        "American BMIs have remained stable despite rising nonnutritive sweetener consumption",
        "Americans' BMIs have risen in parallel with the increased use of nonnutritive sweeteners"
      ],
      correctAnswer: 3
    },
    {
      id: 90237,
      question: "Monosaccharides require enzymatic breakdown before they can be absorbed by the body.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90238,
      question: "Glycogen is the carbohydrate storage form of energy in humans, stored in the liver and muscles.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90239,
      question: "Substituting glucose or fructose for sucrose is highly effective in significantly reducing dental caries risk.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90240,
      question: "Extremely low-carbohydrate diets may lead to a condition called ketosis due to insufficient carbohydrate availability.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90241,
      question: "The Acceptable Macronutrient Distribution Range (AMDR) for carbohydrates allows intake of up to 75% of total daily calories.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
  ],
  "4. Protein": [
    {
      id: 90301,
      question: "How many amino acids are used to build all proteins in the human body?",
      options: [
        "12 amino acids arranged in branching chain configurations",
        "15 amino acids of varying molecular weights and structures",
        "20 amino acids combined in varying sequences and arrangements",
        "25 amino acids including both essential and nonessential types"
      ],
      correctAnswer: 2
    },
    {
      id: 90302,
      question: "Where does digestion of dietary protein primarily take place, and what is its end result?",
      options: [
        "In the stomach, where proteins are converted to glucose for energy",
        "In the large intestine, where bacterial enzymes break down protein chains",
        "In the mouth, where salivary enzymes begin protein hydrolysis into peptides",
        "In the small intestine, where enzymes hydrolyze proteins into individual amino acids"
      ],
      correctAnswer: 3
    },
    {
      id: 90303,
      question: "What is the distinguishing structural feature of all amino acids?",
      options: [
        "A carbon ring structure that differentiates them from lipids and carbohydrates",
        "A sulfur-containing side chain that links amino acids during protein synthesis",
        "The presence of an amino group that characterizes their chemical identity",
        "A double-bond oxygen group that determines their solubility in blood plasma"
      ],
      correctAnswer: 2
    },
    {
      id: 90304,
      question: "What is a dipeptide?",
      options: [
        "A short-chain fatty acid produced during amino acid catabolism",
        "Two amino acids joined together forming a small protein unit",
        "A large protein molecule containing more than 100 amino acid chains",
        "A type of enzyme that catalyzes the breakdown of dietary protein"
      ],
      correctAnswer: 1
    },
    {
      id: 90305,
      question: "How many indispensable amino acids must be obtained from the diet?",
      options: [
        "Five indispensable amino acids required from dietary sources daily",
        "Seven indispensable amino acids required from dietary sources daily",
        "Nine indispensable amino acids required from dietary sources daily",
        "Twelve indispensable amino acids required from dietary sources daily"
      ],
      correctAnswer: 2
    },
    {
      id: 90306,
      question: "What defines a \"dispensable\" amino acid?",
      options: [
        "An amino acid that the body does not need in any significant quantity",
        "An amino acid the body can produce from available indispensable amino acids",
        "An amino acid that can only be obtained from animal-based food sources",
        "An amino acid that becomes toxic when consumed in excessive amounts"
      ],
      correctAnswer: 1
    },
    {
      id: 90307,
      question: "What is meant by a \"conditionally indispensable\" amino acid?",
      options: [
        "An amino acid that varies in chemical structure based on the food source consumed",
        "An amino acid required only by athletes and individuals with high physical demands",
        "A dispensable amino acid that becomes essential during certain disease states or developmental stages",
        "An amino acid produced by intestinal bacteria and therefore conditionally absorbed"
      ],
      correctAnswer: 2
    },
    {
      id: 90308,
      question: "What makes a food source classified as providing \"high-quality protein\"?",
      options: [
        "It contains more than 30 grams of protein per serving with minimal fat",
        "It is derived exclusively from animal sources and is fully absorbed by the body",
        "It provides all nine indispensable amino acids in amounts sufficient for nitrogen balance and growth",
        "It contains no antinutritional factors that could interfere with amino acid absorption"
      ],
      correctAnswer: 2
    },
    {
      id: 90309,
      question: "What characterizes a food that is classified as a \"low-quality protein\" source?",
      options: [
        "It is high in total protein content but contains significant amounts of saturated fat",
        "It provides less than 10 grams of protein per 100-gram serving of food",
        "It is poorly digested and passes through the digestive system without absorption",
        "It lacks adequate amounts of one or more indispensable amino acids for optimal protein synthesis"
      ],
      correctAnswer: 3
    },
    {
      id: 90310,
      question: "Which of the following best describes nitrogen balance in a healthy adult?",
      options: [
        "The body retains more nitrogen than it excretes due to ongoing tissue building",
        "Nitrogen intake from food equals the amount excreted in feces, urine, and skin",
        "Nitrogen excretion exceeds intake due to the body's high metabolic rate",
        "Nitrogen balance fluctuates daily based on carbohydrate and fat intake levels"
      ],
      correctAnswer: 1
    },
    {
      id: 90311,
      question: "In which situation would a person be expected to show positive nitrogen balance?",
      options: [
        "During recovery from a severe burn injury causing accelerated protein breakdown",
        "During childhood growth or pregnancy when more protein is retained than lost",
        "During starvation when the body catabolizes muscle tissue for energy production",
        "During aging when sarcopenia causes progressive decline in muscle protein stores"
      ],
      correctAnswer: 1
    },
    {
      id: 90312,
      question: "Which condition would most likely result in negative nitrogen balance?",
      options: [
        "During normal adult maintenance phase when protein intake meets requirements",
        "During infancy when growth demands exceed available protein from breast milk",
        "During illness or burn injury when nitrogen losses exceed dietary nitrogen intake",
        "During aerobic exercise training when muscle protein synthesis is elevated"
      ],
      correctAnswer: 2
    },
    {
      id: 90313,
      question: "Which of the following is a physiologic role of protein related to immunity?",
      options: [
        "Protein forms the structural matrix of dental enamel and cementum",
        "Protein synthesizes red blood cells that carry oxygen to all body tissues",
        "Antibodies (immunoglobins) are protein-based and serve as the body's main disease protection",
        "Protein regulates blood pressure by controlling the renin-angiotensin pathway"
      ],
      correctAnswer: 2
    },
    {
      id: 90314,
      question: "What is the RDA for protein for an average healthy adult?",
      options: [
        "0.4 g/kg of body weight or 5% to 15% of total caloric intake",
        "0.6 g/kg of body weight or 8% to 25% of total caloric intake",
        "1.2 g/kg of body weight or 20% to 40% of total caloric intake",
        "0.8 g/kg of body weight or 10% to 35% of total caloric intake (AMDR)"
      ],
      correctAnswer: 3
    },
    {
      id: 90315,
      question: "Approximately how much protein per day is recommended for a patient weighing 150 pounds?",
      options: [
        "Approximately 30 g of protein per day for basic metabolic needs",
        "Approximately 45 g of protein per day based on standard weight ratios",
        "Approximately 56 g of protein per day based on RDA calculations",
        "Approximately 75 g of protein per day to support muscle maintenance"
      ],
      correctAnswer: 2
    },
    {
      id: 90316,
      question: "What potential health benefit is associated with protein intakes higher than the minimum RDA?",
      options: [
        "Higher intakes may reduce the risk of type 2 diabetes, coronary heart disease, osteoporosis, and sarcopenia",
        "Higher intakes may prevent all forms of cancer by supporting immune cell production",
        "Higher intakes may eliminate the need for carbohydrates as an energy source",
        "Higher intakes may directly improve oral health by strengthening enamel structure"
      ],
      correctAnswer: 0
    },
    {
      id: 90317,
      question: "According to the Dietary Guidelines, what proportion of the US/Canada population is meeting or exceeding protein recommendations?",
      options: [
        "Fewer than 25% of adults are meeting or exceeding protein recommendations",
        "More than half of the United States and Canada is meeting or exceeding recommendations",
        "Approximately 30% of the population meets the minimum protein requirements",
        "Nearly all adults fall below the recommended dietary allowance for protein"
      ],
      correctAnswer: 1
    },
    {
      id: 90318,
      question: "Why is protein intake a concern for patients with liver or kidney disease?",
      options: [
        "The liver and kidneys produce all indispensable amino acids needed by the body",
        "Protein digestion begins in these organs and disease impairs initial breakdown",
        "Diseased liver and kidneys cannot properly handle excessive protein, causing further organ damage",
        "Protein intake triggers inflammation in diseased organs regardless of the amount consumed"
      ],
      correctAnswer: 2
    },
    {
      id: 90319,
      question: "How much protein does one cup of milk provide?",
      options: [
        "3 to 4 g of protein per cup of whole or skim milk",
        "8 to 9 g of protein per cup of milk",
        "12 to 14 g of protein per cup of milk",
        "5 to 6 g of protein per cup of milk"
      ],
      correctAnswer: 1
    },
    {
      id: 90320,
      question: "Which plant-based protein sources are emphasized in the Canadian dietary approach?",
      options: [
        "Processed soy protein, refined wheat gluten, and commercial protein supplements",
        "White rice, cooked oatmeal, enriched pasta, and fortified breakfast cereals",
        "Legumes, tofu and other soy products, nuts, seeds, and fortified plant-based beverages",
        "Fruit juices with added protein, vegetable oils, and fermented grain products"
      ],
      correctAnswer: 2
    },
    {
      id: 90321,
      question: "What proportion of the plate should protein foods make up at each meal according to recommendations?",
      options: [
        "One-half of the plate should consist of protein foods at each meal",
        "One-third of the plate should be protein-rich foods to ensure adequate intake",
        "One-quarter of the plate should be protein foods at each meal",
        "Two-thirds of the plate should include high-quality animal protein sources"
      ],
      correctAnswer: 2
    },
    {
      id: 90322,
      question: "Which group is listed as being at particular risk for protein deficiency?",
      options: [
        "Middle-aged adults who consume regular balanced meals each day",
        "Athletes engaged in moderate aerobic exercise four days per week",
        "Healthy adults who consume the standard North American diet",
        "Older adults, those with low income, and chronically ill or hospitalized individuals"
      ],
      correctAnswer: 3
    },
    {
      id: 90323,
      question: "What is sarcopenia and how is it related to protein nutrition?",
      options: [
        "A condition of excessive protein storage in muscle tissue causing inflammation",
        "A kidney disease caused by chronic overconsumption of dietary protein",
        "Progressive loss of muscle mass and strength associated with aging and low protein",
        "A form of acute protein-energy malnutrition causing rapid weight loss in children"
      ],
      correctAnswer: 2
    },
    {
      id: 90324,
      question: "What oral health effect is associated with poor nutrition and protein deficiency in children?",
      options: [
        "Premature eruption of permanent teeth causing early enamel wear patterns",
        "Excessive calculus formation due to altered salivary protein composition",
        "Delayed eruption and exfoliation of deciduous teeth from poor nutritional status",
        "Increased fluoride uptake in enamel causing fluorosis-like surface changes"
      ],
      correctAnswer: 2
    },
    {
      id: 90325,
      question: "What happens to sIgA levels in malnourished children and why is this clinically significant?",
      options: [
        "sIgA levels increase, causing autoimmune reactions in the oral soft tissues",
        "sIgA levels are depressed, reducing oral immune defense and increasing disease risk",
        "sIgA levels remain stable but shift composition, impairing enzymatic salivary function",
        "sIgA levels fluctuate unpredictably, making caries risk assessment unreliable"
      ],
      correctAnswer: 1
    },
    {
      id: 90326,
      question: "What oral conditions are associated with protein-energy malnutrition (PEM) in children?",
      options: [
        "Increased caries and fluorosis due to disrupted enamel mineralization pathways",
        "Gingival recession and root caries caused by insufficient collagen production",
        "Increased incidence of noma and necrotizing ulcerative gingivitis (NUG)",
        "Accelerated tooth wear and dentinal hypersensitivity from altered salivary buffering"
      ],
      correctAnswer: 2
    },
    {
      id: 90327,
      question: "What is kwashiorkor and what distinguishes it from other forms of malnutrition?",
      options: [
        "A chronic deficiency of all macronutrients causing stunted growth over many years",
        "An acute form of PEM occurring when high-quality protein is lacking despite adequate calories",
        "A condition of protein excess causing fatty infiltration of the liver and joint pain",
        "A mild form of protein deficiency seen primarily in elderly populations in developed countries"
      ],
      correctAnswer: 1
    },
    {
      id: 90328,
      question: "Which age group is specifically identified as being most at risk for kwashiorkor?",
      options: [
        "Adolescents aged 13 to 18 years during the period of rapid growth",
        "Elderly adults over age 75 experiencing decreased appetite and activity",
        "Children aged 18 to 24 months during the transition from breast milk",
        "Infants under 6 months of age being introduced to complementary foods"
      ],
      correctAnswer: 2
    },
    {
      id: 90329,
      question: "Which of the following is a recognized symptom of kwashiorkor?",
      options: [
        "Bone fractures, joint pain, excessive thirst, and elevated blood glucose",
        "Rapid weight gain, excessive muscle mass, high blood pressure, and kidney stones",
        "Edema of the extremities and face, fatty liver, hair color changes, and anemia",
        "Accelerated wound healing, dense hair growth, and unusual skin pigmentation"
      ],
      correctAnswer: 2
    },
    {
      id: 90330,
      question: "What is currently known about the upper safe limit for protein intake in healthy adults?",
      options: [
        "The safe upper limit is firmly established at 2.5 g/kg of body weight per day",
        "An upper limit for safe protein intake has not been definitively determined",
        "The safe upper limit is set at 120 g per day for all adults regardless of body weight",
        "The safe upper limit is defined as twice the RDA value for each age and sex group"
      ],
      correctAnswer: 1
    },
    {
      id: 90331,
      question: "Which age group is particularly vulnerable to fluid imbalances caused by excessive protein intake?",
      options: [
        "Elderly adults over 65 who have declining renal function and reduced hydration",
        "Adolescent athletes who consume large amounts of protein supplements regularly",
        "Infants, who are most susceptible to fluid imbalances from excessive protein",
        "Pregnant women in the third trimester due to altered fluid retention mechanisms"
      ],
      correctAnswer: 2
    },
    {
      id: 90332,
      question: "Through which mechanisms does dietary protein aid in weight loss and body composition?",
      options: [
        "By directly stimulating fat oxidation in adipose tissue and reducing leptin secretion",
        "By slowing gastric emptying and reducing absorption of dietary carbohydrates",
        "By increasing satiation, muscle mass, thermogenesis, and decreasing energy efficiency",
        "By elevating basal metabolic rate through increased thyroid hormone production"
      ],
      correctAnswer: 2
    },
    {
      id: 90333,
      question: "What are the cardiovascular risks associated with a diet where the principal protein source is red meat and regular dairy?",
      options: [
        "Red meat and dairy increase LDL but simultaneously reduce triglyceride levels",
        "Risk of cardiovascular disease and stroke rises when red meat and full-fat dairy dominate",
        "Saturated fat in red meat only affects cardiovascular risk in individuals over age 60",
        "Red meat consumption lowers HDL while dairy raises it, producing a neutral net effect"
      ],
      correctAnswer: 1
    },
    {
      id: 90334,
      question: "For which type of patient are high-protein diets specifically identified as potentially harmful?",
      options: [
        "Healthy adults who exceed the AMDR for protein on a consistent daily basis",
        "Athletes who combine high protein intake with resistance training programs",
        "Individuals with preexisting metabolic renal dysfunction or kidney disease",
        "Vegetarians who rely on plant-based proteins without complementary pairing"
      ],
      correctAnswer: 2
    },
    {
      id: 90335,
      question: "What goal is recommended for daily protein intake when using a high-protein diet to maximize weight loss?",
      options: [
        "60 g of high-quality protein per day consumed primarily at the evening meal",
        "90 g of protein per day concentrated in breakfast and lunch to optimize satiation",
        "150 g of protein per day from mixed animal and plant-based food sources",
        "120 g of high-protein daily, distributed evenly throughout the day"
      ],
      correctAnswer: 3
    },
    {
      id: 90336,
      question: "All proteins in the human body are made from combinations of 20 amino acids.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90337,
      question: "Dispensable amino acids do not need to be consumed in the diet because they are completely unnecessary for body function.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90338,
      question: "Positive nitrogen balance occurs during periods of growth such as childhood and pregnancy, when more protein is retained than lost.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90339,
      question: "Kwashiorkor is caused by both a severe deficiency of total calories and total protein simultaneously.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90340,
      question: "High-protein diets may be harmful for individuals with preexisting metabolic renal dysfunction.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
  ],
  "5. Lipids": [
    {
      id: 90341,
      question: "What three chemical elements do lipids share with carbohydrates?",
      options: [
        "Carbon, hydrogen, and oxygen",
        "Nitrogen, sulfur, and phosphorus",
        "Calcium, iron, and carbon",
        "Sodium, potassium, and oxygen"
      ],
      correctAnswer: 0
    },
    {
      id: 90342,
      question: "Which class of lipids occurs in food and in the body and is also known as triglycerides?",
      options: [
        "Structural lipids",
        "Simple lipids",
        "Derived lipids",
        "Compound lipids"
      ],
      correctAnswer: 1
    },
    {
      id: 90343,
      question: "A triglyceride consists of glycerol combined with how many fatty acids?",
      options: [
        "One fatty acid attached to the glycerol backbone",
        "Two fatty acids attached to the glycerol backbone",
        "Three fatty acids attached to the glycerol backbone",
        "Four fatty acids attached to the glycerol backbone"
      ],
      correctAnswer: 2
    },
    {
      id: 90344,
      question: "How many carbon atoms do medium-chain fatty acids contain?",
      options: [
        "Fewer than 6 carbon atoms in the chain",
        "Between 6 and 10 carbon atoms in the chain",
        "12 or more carbon atoms in the chain",
        "Between 11 and 14 carbon atoms in the chain"
      ],
      correctAnswer: 1
    },
    {
      id: 90345,
      question: "Saturated fatty acids (SFAs) are characterized by which of the following?",
      options: [
        "Multiple double bonds between carbon atoms",
        "Only single bonds between carbon atoms",
        "Alternating double and single bonds in the chain",
        "One double bond between adjacent carbons"
      ],
      correctAnswer: 1
    },
    {
      id: 90346,
      question: "What term describes a fatty acid that contains only one double bond?",
      options: [
        "Polyunsaturated fatty acid (PUFA)",
        "Saturated fatty acid (SFA)",
        "Monounsaturated fatty acid (MUFA)",
        "Trans fatty acid from hydrogenation"
      ],
      correctAnswer: 2
    },
    {
      id: 90347,
      question: "Hydrogenation is a commercial process that converts vegetable oil into which product?",
      options: [
        "A refined oil high in omega-3 fatty acids",
        "A solid margarine with altered fatty acid structure",
        "A liquid emulsion used in salad dressings",
        "A powdered fat supplement for food products"
      ],
      correctAnswer: 1
    },
    {
      id: 90348,
      question: "Polyunsaturated fatty acids (PUFAs) include which two major types?",
      options: [
        "Omega-3 and omega-6 fatty acids",
        "Short-chain and long-chain fatty acids",
        "Lecithin and cephalin fatty acids",
        "Trans fats and saturated fatty acids"
      ],
      correctAnswer: 0
    },
    {
      id: 90349,
      question: "Which of the following best describes the physical state of most saturated fatty acids at room temperature?",
      options: [
        "They are solid at room temperature",
        "They are liquid and flow freely at room temperature",
        "They exist as gases under normal conditions",
        "They dissolve completely in water at room temperature"
      ],
      correctAnswer: 0
    },
    {
      id: 90350,
      question: "Fats with a high proportion of unsaturated fatty acids are most susceptible to which problem?",
      options: [
        "Rapid crystallization and hardening in cold storage",
        "Forming harmful trans fats during normal digestion",
        "Losing all nutritional value when refrigerated properly",
        "Becoming rancid when exposed to high temperatures and light"
      ],
      correctAnswer: 3
    },
    {
      id: 90351,
      question: "Which phospholipid is the most widely distributed in the body and has been marketed in supplement form to reduce atherosclerosis risk?",
      options: [
        "Lecithin, the most widely distributed phospholipid",
        "Cephalin, found primarily in thromboplastin",
        "Cholesterol, a sterol-derived structural compound",
        "Linoleic acid, an essential omega-6 fatty acid"
      ],
      correctAnswer: 0
    },
    {
      id: 90352,
      question: "The phospholipid cephalin is found in thromboplastin. What is thromboplastin's primary role?",
      options: [
        "Transporting fat-soluble vitamins through the bloodstream",
        "Regulating blood glucose levels after a high-fat meal",
        "Emulsifying dietary fats during intestinal digestion",
        "It is necessary for the process of blood clotting"
      ],
      correctAnswer: 3
    },
    {
      id: 90353,
      question: "Which lipoprotein is commonly referred to as \"bad cholesterol\" because it stores cholesterol in the bloodstream?",
      options: [
        "High-density lipoprotein (HDL)",
        "Very-low-density lipoprotein (VLDL)",
        "Low-density lipoprotein (LDL)",
        "Chylomicron, the largest lipoprotein particle"
      ],
      correctAnswer: 2
    },
    {
      id: 90354,
      question: "What is the primary role of high-density lipoproteins (HDLs) in the body?",
      options: [
        "Delivering dietary cholesterol to peripheral tissues",
        "They regulate LDL storage and promote its excretion",
        "Transporting triglycerides from liver to muscle tissue",
        "Storing excess energy from dietary carbohydrates"
      ],
      correctAnswer: 1
    },
    {
      id: 90355,
      question: "Lipoproteins are compound lipids composed of which combination of substances?",
      options: [
        "Glycerol, fatty acids, and simple sugars",
        "Essential amino acids, vitamins, and fatty acids",
        "Saturated fats, water, and mineral compounds",
        "Triglycerides, phospholipids, and cholesterol combined with protein"
      ],
      correctAnswer: 3
    },
    {
      id: 90356,
      question: "Cholesterol is classified chemically as which type of compound?",
      options: [
        "A simple triglyceride with three fatty acid chains",
        "A sterol derivative with a complex ring structure",
        "A short-chain saturated fatty acid found in dairy",
        "A water-soluble phospholipid with a nitrogenous base"
      ],
      correctAnswer: 1
    },
    {
      id: 90357,
      question: "Which of the following is NOT listed as an important function of cholesterol?",
      options: [
        "Serving as a structural component of cell membranes and teeth",
        "Acting as a precursor to vitamin D and steroid hormones",
        "Providing the primary source of dietary energy for the brain",
        "Being a constituent of the brain, nervous tissue, and bile salts"
      ],
      correctAnswer: 2
    },
    {
      id: 90358,
      question: "Why do dietary fats have a higher satiety value compared to carbohydrates or protein?",
      options: [
        "Fats stimulate more insulin release than other macronutrients",
        "Fats bind to hunger receptors in the stomach lining directly",
        "Fat molecules are smaller and absorbed more rapidly by cells",
        "Digestion of high-fat meals is slower than other energy-containing nutrients"
      ],
      correctAnswer: 3
    },
    {
      id: 90359,
      question: "Which of the following describes a physiologic role of adipose tissue?",
      options: [
        "Producing digestive enzymes needed to break down lipids",
        "Filtering toxins from dietary fat before systemic absorption",
        "Serving as an energy source, protecting organs, and maintaining body temperature",
        "Regulating the production of fat-soluble vitamins in the gut"
      ],
      correctAnswer: 2
    },
    {
      id: 90360,
      question: "Linoleic acid is classified as an essential fatty acid because of which reason?",
      options: [
        "It cannot be synthesized by the body and must come from diet",
        "It is synthesized in excess by the liver under normal conditions",
        "It can be made from saturated fatty acids through desaturation",
        "It is only required in trace amounts similar to a micronutrient"
      ],
      correctAnswer: 0
    },
    {
      id: 90361,
      question: "According to the chapter, how do dietary fats likely influence oral health?",
      options: [
        "Systemic effects on enamel remineralization from vitamin absorption",
        "Increasing salivary pH, which neutralizes acids in the oral cavity",
        "Stimulating bone remodeling in alveolar tissue through hormones",
        "Probably through local rather than systemic influences on oral tissues"
      ],
      correctAnswer: 3
    },
    {
      id: 90362,
      question: "Long-chain fatty acids in the diet may benefit dental health by doing which of the following?",
      options: [
        "Directly killing cariogenic bacteria in the dental plaque biofilm",
        "Reducing dissolution of hydroxyapatite by acids in the mouth",
        "Increasing remineralization of enamel through calcium binding",
        "Stimulating salivary gland secretion to buffer oral acids"
      ],
      correctAnswer: 1
    },
    {
      id: 90363,
      question: "What role do bacteria from dental plaque biofilm play in relation to cardiovascular disease?",
      options: [
        "They produce toxins that lower HDL levels in the bloodstream",
        "They destroy arterial walls directly through enzymatic activity",
        "They can cause blood clots, linking periodontal and heart disease",
        "They raise triglyceride levels by metabolizing dietary saturated fat"
      ],
      correctAnswer: 2
    },
    {
      id: 90364,
      question: "What is the Acceptable Macronutrient Distribution Range (AMDR) for fat intake in adults?",
      options: [
        "20% to 35% of total daily energy intake",
        "Less than 10% of total daily energy intake",
        "35% to 45% of total daily energy intake",
        "10% to 20% of total daily energy intake"
      ],
      correctAnswer: 0
    },
    {
      id: 90365,
      question: "What is the Adequate Intake (AI) for linoleic acid for men aged 19 to 50 years?",
      options: [
        "11 grams per day for men in this age group",
        "14 grams per day for men in this age group",
        "12 grams per day for men in this age group",
        "17 grams per day for men in this age group"
      ],
      correctAnswer: 3
    },
    {
      id: 90366,
      question: "According to the Dietary Guidelines described in the chapter, what should be the focus regarding dietary fat?",
      options: [
        "Fewer overall calories and reduced saturated fat intake",
        "Eliminating all saturated fats and replacing with trans fats",
        "Reducing total fat intake to below 20% of calories consumed",
        "Increasing vegetable oil consumption to replace animal fats"
      ],
      correctAnswer: 0
    },
    {
      id: 90367,
      question: "Which vegetable oil accounts for more than 65% of all vegetable oil consumed in the United States?",
      options: [
        "Canola oil, which is dominant in the American market",
        "Corn oil, commonly used in snack food manufacturing",
        "Soybean oil, which dominates US vegetable oil consumption",
        "Cottonseed oil, used widely in processed food products"
      ],
      correctAnswer: 2
    },
    {
      id: 90368,
      question: "Which food sources provide the most polyunsaturated fatty acids (PUFAs)?",
      options: [
        "Cottonseed, soybean, and corn oils, as well as nuts and seeds",
        "Butter, cream, and whole-milk dairy products",
        "Egg yolks, liver, and other high-cholesterol animal products",
        "Red meats, processed deli meats, and poultry skin"
      ],
      correctAnswer: 0
    },
    {
      id: 90369,
      question: "Cholesterol is found exclusively in animal products. Which food sources have the highest cholesterol content?",
      options: [
        "Whole grains, legumes, and fortified plant-based milks",
        "Egg yolks, liver, and organ meats",
        "Vegetable oils, margarine, and plant sterols",
        "Nuts, seeds, and avocados with healthy fats"
      ],
      correctAnswer: 1
    },
    {
      id: 90370,
      question: "What is the average cholesterol intake reported for individuals in the U.S. and Canada?",
      options: [
        "Approximately 150 mg of dietary cholesterol per day",
        "Between 500 and 600 mg of dietary cholesterol per day",
        "Slightly above 300 mg of dietary cholesterol per day",
        "Approximately 450 mg of dietary cholesterol per day"
      ],
      correctAnswer: 2
    },
    {
      id: 90371,
      question: "Why is the percentage of fat by weight on food labels considered misleading?",
      options: [
        "It does not account for the total caloric content per serving",
        "It uses grams instead of the recommended percentage format",
        "It ignores whether the fat content includes trans or saturated types",
        "It overstates the saturated fat content of the food product"
      ],
      correctAnswer: 0
    },
    {
      id: 90372,
      question: "Which statement about omega-3 fatty acids and cardiovascular health is supported by the chapter?",
      options: [
        "Omega-3 supplements are more effective than dietary sources",
        "Omega-3 from fatty fish is more effective than supplements",
        "Omega-3 from plant oils equals omega-3 from fatty fish",
        "Omega-3 supplements and fish sources are equally effective"
      ],
      correctAnswer: 1
    },
    {
      id: 90373,
      question: "What is the strongest dietary determinant of blood cholesterol levels according to the chapter?",
      options: [
        "Total daily caloric intake regardless of macronutrient source",
        "Amount of dietary cholesterol consumed from animal products",
        "Dietary saturated fat intake from food sources",
        "Trans fat consumption from processed and packaged foods"
      ],
      correctAnswer: 2
    },
    {
      id: 90374,
      question: "Essential fatty acid (EFA) deficiency produces which set of clinical consequences?",
      options: [
        "Poor growth, dermatitis, reduced resistance to infection, and poor reproductive capacity",
        "Anemia, muscle wasting, and impaired bone mineralization",
        "Dental caries, enamel hypoplasia, and gingival recession",
        "Elevated blood pressure, edema, and poor kidney function"
      ],
      correctAnswer: 0
    },
    {
      id: 90375,
      question: "In which patient population are clinical symptoms of fat deficiency most likely to occur?",
      options: [
        "Elderly patients following calorie-restricted low-fat diets",
        "Athletes consuming high-carbohydrate performance diets",
        "Adolescents following vegetarian or vegan eating patterns",
        "Patients with malabsorption syndromes such as cystic fibrosis"
      ],
      correctAnswer: 3
    },
    {
      id: 90376,
      question: "Most fat replacers used in manufactured low-fat foods are based on which substances?",
      options: [
        "Synthetic lipid compounds engineered to mimic fat's texture",
        "Mineral-based emulsifiers and fat-soluble vitamin blends",
        "Carbohydrate and protein-based formulations",
        "Artificial sweeteners combined with modified fatty acids"
      ],
      correctAnswer: 2
    },
    {
      id: 90377,
      question: "Which of the following foods is made using modified starches and gums to reduce fat content?",
      options: [
        "Whole milk, yogurt with active cultures, and aged cheese",
        "Peanut butter, almond milk, and sunflower seed spreads",
        "Lean ground beef, skinless chicken, and baked white fish",
        "Low-calorie salad dressing, fat-free yogurt, and imitation margarine"
      ],
      correctAnswer: 3
    },
    {
      id: 90378,
      question: "Which food group provides the most calories from added fats and oils in the average North American diet?",
      options: [
        "Dairy products such as cheese, milk, and butter",
        "Grain products including breads, pasta, and cereals",
        "Red meats, poultry, and processed meat products",
        "Added fats and oils exceed all other food groups in caloric contribution"
      ],
      correctAnswer: 3
    },
    {
      id: 90379,
      question: "Milk fat is notable for containing a large number of which type of fatty acids?",
      options: [
        "Long-chain polyunsaturated omega-3 fatty acids",
        "Trans fatty acids produced through natural hydrogenation",
        "Monounsaturated fatty acids similar to those in olive oil",
        "Short-chain saturated fatty acids"
      ],
      correctAnswer: 3
    },
    {
      id: 90380,
      question: "Phospholipids play an important role in which two processes within the body?",
      options: [
        "Hormone production and regulation of blood glucose levels",
        "Fat absorption and transport of fats in the blood",
        "Immune response modulation and red blood cell production",
        "Bone mineralization and vitamin D activation in the kidney"
      ],
      correctAnswer: 1
    },
    {
      id: 90381,
      question: "According to the chapter, which statement about red meat consumption is most accurate?",
      options: [
        "A decrease in red meat consumption is desirable, but complete elimination is unnecessary",
        "Red meat should be replaced entirely with fish and poultry",
        "Complete elimination of red meat is recommended for all adults",
        "Red meat intake has no meaningful impact on cardiovascular risk"
      ],
      correctAnswer: 0
    },
    {
      id: 90382,
      question: "Lipids contain the same three chemical elements — carbon, hydrogen, and oxygen — as carbohydrates.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90383,
      question: "Cholesterol is considered an essential nutrient, meaning it must be obtained from dietary sources because the body cannot produce it.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90384,
      question: "Fats have a higher satiety value than carbohydrates or protein because high-fat meals are digested more slowly.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90385,
      question: "Dietary fats are incorporated into tooth structure and are considered essential for oral health.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90386,
      question: "Bacteria from dental plaque biofilm have been linked to the formation of blood clots, connecting periodontal disease to cardiovascular disease.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    }
  ],
  "6. Vitamins & Minerals": [
    {
      id: 90387,
      question: "Which statement best describes the general role of vitamins in the body?",
      options: [
        "They provide the body with 4% of its total weight in inorganic form",
        "They act as catalysts for metabolic reactions using proteins, fats, and carbohydrates for energy, growth, and cell maintenance",
        "They are stored exclusively in the liver and are released only during periods of stress",
        "They function only as antioxidants and are destroyed by heat during cooking"
      ],
      correctAnswer: 1
    },
    {
      id: 90388,
      question: "Which of the following groups of vitamins is required specifically for calcified structures?",
      options: [
        "Fat-soluble vitamins A, D, E, K and water-soluble vitamin B12",
        "Water-soluble vitamins B1, B2, B6, B12 and fat-soluble vitamin D only",
        "Fat-soluble vitamins A, D, E, K and water-soluble vitamin C",
        "Fat-soluble vitamins A and D only, plus water-soluble vitamins B and C"
      ],
      correctAnswer: 2
    },
    {
      id: 90389,
      question: "A nutritional deficiency caused by decreased intake is classified as which type?",
      options: [
        "Secondary deficiency, caused by malabsorption or inadequate use of available nutrients",
        "Tertiary deficiency, caused by an underlying metabolic disorder affecting nutrient use",
        "Conditional deficiency, triggered only during periods of elevated physiological stress",
        "Primary deficiency, caused by insufficient amounts of a nutrient in the diet"
      ],
      correctAnswer: 3
    },
    {
      id: 90390,
      question: "Which of the following patient groups is considered at risk for vitamin deficiencies?",
      options: [
        "Patients with rapid growth, medically compromised patients, substance abusers, and vegans",
        "Adults over age 50, patients on low-fat diets, and those with high iron intake",
        "Patients with high calcium intake, children on balanced diets, and non-smokers",
        "Athletes with high caloric intake, office workers, and patients on multivitamins"
      ],
      correctAnswer: 0
    },
    {
      id: 90391,
      question: "Which of the following correctly describes a characteristic of fat-soluble vitamins?",
      options: [
        "They act as coenzymes, require daily intake, and are readily absorbed in the jejunum",
        "They are stored in the liver and adipose tissues, require bile for absorption, and are transported via the lymphatic system",
        "They dissolve in water, contain nitrogen, and are excreted rapidly if consumed in excess",
        "They are destroyed easily by heat during cooking and must be replenished daily through diet"
      ],
      correctAnswer: 1
    },
    {
      id: 90392,
      question: "Water-soluble vitamins differ from fat-soluble vitamins in that they:",
      options: [
        "Are stored in large amounts in adipose tissue and released slowly over time",
        "Require bile salts for absorption and are transported via the lymphatic system",
        "Are only found in animal products and are stable at high cooking temperatures",
        "Are readily absorbed in the jejunum, stored in small amounts, and require daily intake"
      ],
      correctAnswer: 3
    },
    {
      id: 90393,
      question: "Which of the following are the two main classes of Vitamin A?",
      options: [
        "Phylloquinone found in green plants and menaquinone formed by intestinal bacteria",
        "Cholecalciferol synthesized from sunlight and ergocalciferol found in fortified foods",
        "Tocopherols found in plant oils and retinols found in fortified foods only",
        "Retinoids found in animal products and carotenoids found in fruits and vegetables"
      ],
      correctAnswer: 3
    },
    {
      id: 90394,
      question: "Which of the following is NOT listed as a physiologic role of Vitamin A?",
      options: [
        "Cell differentiation, DNA/RNA synthesis, and bone and tooth development",
        "Vision in dim light and maintenance of immune function",
        "Catalyzing synthesis of blood-clotting factors and bone crystal formation",
        "Integrity of skin and mucous membranes and cancer prevention"
      ],
      correctAnswer: 2
    },
    {
      id: 90395,
      question: "Which of the following is a food source of Vitamin A?",
      options: [
        "Milk, cheese, liver, butter, eggs, cod liver oil, and yellow/orange/green leafy vegetables",
        "Fish liver oils, fatty fish, fortified cereals, and orange juice only",
        "Sunlight exposure, fortified milk, fatty fish, and fish liver oils",
        "Nuts, seeds, wheat germ, and soybean oil"
      ],
      correctAnswer: 0
    },
    {
      id: 90396,
      question: "Hypervitaminosis A refers to which of the following conditions?",
      options: [
        "Skin turning deep yellow on palms and soles due to carotenoid excess from supplements",
        "Low levels of Vitamin A causing growth restriction and susceptibility to infections",
        "High levels of Vitamin A in the body causing diplopia, alopecia, reddened gingiva, and cracked lips",
        "Enamel hypoplasia, night blindness, and keratinization of lung and urinary tract epithelia"
      ],
      correctAnswer: 2
    },
    {
      id: 90397,
      question: "Maternal overconsumption of Vitamin A supplements before conception or during the first trimester is associated with:",
      options: [
        "Increased risk of periodontal disease and reddened gingiva in the mother",
        "Fragility of alveolar bone and gingival hypertrophy in the infant after birth",
        "Decreased bone mineralization and osteomalacia in the developing fetus",
        "Fetal birth defects due to excessive retinoid levels during early development"
      ],
      correctAnswer: 3
    },
    {
      id: 90398,
      question: "Which of the following is a hypo state (deficiency) effect of Vitamin A?",
      options: [
        "Growth restriction, night blindness, enamel hypoplasia, and xerophthalmia in advanced cases",
        "Diplopia, alopecia, dry rough skin, and reddened gingiva from excess supplementation",
        "Skin turning deep yellow, especially on palms and soles, due to carotene accumulation",
        "Nausea, vomiting, tingling sensations in the mouth, and kidney stone formation"
      ],
      correctAnswer: 0
    },
    {
      id: 90399,
      question: "Vitamin D is more appropriately classified as a hormone because it:",
      options: [
        "Is only obtained through food sources such as fatty fish and fortified dairy products",
        "Functions primarily as an antioxidant protecting cell membranes from oxidative damage",
        "Is produced in the body in response to sunlight and acts on distant target tissues",
        "Cannot be synthesized in the body and must be entirely obtained through dietary intake"
      ],
      correctAnswer: 2
    },
    {
      id: 90400,
      question: "Which of the following best describes the physiologic role of Vitamin D?",
      options: [
        "It acts as a coenzyme for proline hydroxylation and promotes capillary integrity in tissues",
        "It enhances intestinal calcium and phosphorus absorption and may be involved in hematopoiesis and immune response",
        "It functions as an antioxidant, protects polyunsaturated fats, and acts as an anticoagulant",
        "It supports collagen synthesis, enhances iron absorption, and aids in folic acid utilization"
      ],
      correctAnswer: 1
    },
    {
      id: 90401,
      question: "Which dietary factor can reduce the absorption of Vitamin D?",
      options: [
        "Diets high in fiber, which can result in decreased vitamin D absorption",
        "High intake of vitamin C, which competes with vitamin D for the same receptor sites",
        "Excessive calcium intake, which blocks conversion of vitamin D to its active form",
        "High consumption of phosphorus-rich foods, which inhibits the transport of vitamin D"
      ],
      correctAnswer: 0
    },
    {
      id: 90402,
      question: "Which of the following is a hyper state (toxicity) sign of Vitamin D?",
      options: [
        "Rickets, enamel hypoplasia, dental decay, and periodontitis in growing children",
        "Night blindness, follicular hyperkeratosis of the skin, and susceptibility to infection",
        "Nausea, vomiting, weight loss, constipation, weakness, and tingling sensations in the mouth",
        "Osteomalacia, loss of lamina dura, skeletal pain, and muscle weakness in adults"
      ],
      correctAnswer: 2
    },
    {
      id: 90403,
      question: "Which of the following dental/oral manifestations is associated with Vitamin D deficiency?",
      options: [
        "Reddened gingiva, sore mouth, gingival friability, and increased candidiasis risk",
        "Dry rough mucosa, alopecia, cracked lips, and thinning of the oral epithelium",
        "Malformed enamel, inadequate dentin, periodontal destruction, and tooth mobility",
        "Enamel hypoplasia, dental decay, periodontitis, and loss of the lamina dura"
      ],
      correctAnswer: 3
    },
    {
      id: 90404,
      question: "Vitamin E functions primarily as:",
      options: [
        "A hormone that enhances intestinal calcium and phosphorus absorption systemically",
        "A coenzyme for blood clotting factor synthesis and bone crystal formation",
        "A catalyst for collagen synthesis, promoting capillary integrity and iron absorption",
        "An antioxidant that protects polyunsaturated fats and acts as an anticoagulant"
      ],
      correctAnswer: 3
    },
    {
      id: 90405,
      question: "Which of the following are food sources of Vitamin E?",
      options: [
        "Milk, cheese, liver, butter, eggs, cod liver oil, and fortified cereals",
        "Fish liver oils, fatty fish, fortified orange juice, and sunlight exposure",
        "Yellow, orange, and green leafy vegetables, cod liver oil, and fortified soy milk",
        "Vegetable oils, unprocessed cereal grains, nuts, seeds, wheat germ, and green leafy vegetables"
      ],
      correctAnswer: 3
    },
    {
      id: 90406,
      question: "Which individuals may benefit from Vitamin E supplementation?",
      options: [
        "Premature infants, children, and adults who cannot absorb fats and oils",
        "Healthy adults on high-fat diets, smokers, and patients with kidney disease",
        "Vegans, patients with substance abuse issues, and those with rapid growth periods",
        "Adults over age 65 on calcium supplements and patients with periodontal disease"
      ],
      correctAnswer: 0
    },
    {
      id: 90407,
      question: "High doses of Vitamin E are potentially problematic because they:",
      options: [
        "Exceed liver storage capacity and cause nausea, vomiting, and tingling in the mouth",
        "May disturb the balance of beneficial, naturally occurring antioxidants in the body",
        "Cause hypervitaminosis leading to diplopia, alopecia, and reddened gingiva in the mouth",
        "Block the synthesis of blood-clotting factors, causing severe hemorrhagic complications"
      ],
      correctAnswer: 1
    },
    {
      id: 90408,
      question: "The naturally occurring forms of Vitamin K are:",
      options: [
        "Tocopherol from plant oils and tocotrienol from animal liver and fatty fish",
        "Cholecalciferol from sunlight and ergocalciferol from fortified foods and supplements",
        "K1 (phylloquinone) from green plants and K2 (menaquinone) formed by E. coli bacteria",
        "Retinol from animal products and beta-carotene from fruits and vegetables"
      ],
      correctAnswer: 2
    },
    {
      id: 90409,
      question: "Vitamin K absorption is decreased by:",
      options: [
        "High dietary fiber intake, which binds the vitamin before it can be absorbed",
        "Excessive calcium intake, which competes with Vitamin K at intestinal receptor sites",
        "Low dietary fat intake, which reduces bile production needed for vitamin transport",
        "High levels of Vitamin E supplementation, which interferes with Vitamin K absorption"
      ],
      correctAnswer: 3
    },
    {
      id: 90410,
      question: "Which of the following conditions or drugs may cause Vitamin K deficiency?",
      options: [
        "Celiac disease, ulcerative colitis, anticonvulsants, anticoagulants, and megadoses of vitamin A or E",
        "High protein diet, excessive zinc intake, and long-term use of calcium supplements",
        "Vitamin C megadosing, hyperthyroidism, and high dietary fiber consumption",
        "Veganism, excessive exercise, and chronic use of proton pump inhibitors only"
      ],
      correctAnswer: 0
    },
    {
      id: 90411,
      question: "What is the primary physiologic role of Vitamin C related to calcified structures?",
      options: [
        "Enhancing intestinal calcium absorption and stimulating osteoblast proliferation",
        "Acting as coenzyme in hydroxylation of proline for hydroxyproline in collagen synthesis",
        "Functioning as a catalyst for synthesis of blood-clotting factors and bone crystal formation",
        "Replacing hydroxyl ions in hydroxyapatite to make enamel more resistant to caries"
      ],
      correctAnswer: 1
    },
    {
      id: 90412,
      question: "Which of the following is an oral manifestation of Vitamin C deficiency (scurvy)?",
      options: [
        "Enamel hypoplasia, loss of lamina dura, periodontitis, and xerostomia",
        "Alopecia, diplopia, dry rough mucosa, and tingling sensations in the mouth",
        "Red swollen gingiva, sore burning mouth, gingival friability, periodontal destruction, and malformed enamel",
        "Night blindness, xerophthalmia, Bitot spots, and keratomalacia of oral tissues"
      ],
      correctAnswer: 2
    },
    {
      id: 90413,
      question: "Marginal Vitamin C intake in smokers results in:",
      options: [
        "A 2.4 times greater risk of periodontal disease compared to non-smokers",
        "An equal risk of periodontal disease regardless of smoking status",
        "A 1.2 times greater risk of periodontal disease compared to adequate intake",
        "A 1.6 times greater risk of periodontal disease compared to adequate intake"
      ],
      correctAnswer: 3
    },
    {
      id: 90414,
      question: "Which statement about Vitamin C deficiency and periodontal disease is most accurate?",
      options: [
        "Vitamin C deficiency does not cause gingivitis or periodontal disease but may be a contributing factor",
        "Vitamin C deficiency causes enamel hypoplasia and is the sole factor in periodontal destruction",
        "Vitamin C deficiency only affects periodontal tissues in patients who also smoke tobacco",
        "Vitamin C deficiency directly causes gingivitis and periodontal disease in all patients"
      ],
      correctAnswer: 0
    },
    {
      id: 90415,
      question: "Which of the following correctly describes the organic matrix of bone?",
      options: [
        "It is composed of 90-95% fluorapatite crystals that resist demineralization",
        "It consists of 90-95% collagen fibers, and collagen formation requires protein, vitamin C, iron, copper, and zinc",
        "It is made up of 85% hydroxyapatite and requires calcium, phosphorus, and magnesium",
        "It is formed entirely from inorganic minerals including calcium, phosphorus, and fluoride"
      ],
      correctAnswer: 1
    },
    {
      id: 90416,
      question: "Which statement about the composition of teeth is correct?",
      options: [
        "Teeth are composed of two calcified tissues — enamel and dentin — with cementum being non-calcified",
        "Enamel contains the same constituents as bone but is denser, while cementum is identical in composition to bone",
        "Dentin is softer than cementum because it contains fewer minerals than any other dental tissue",
        "Teeth are composed of enamel, dentin, and cementum; dentin is denser than bone and cementum is softer than bone"
      ],
      correctAnswer: 3
    },
    {
      id: 90417,
      question: "Calcium is considered the most abundant mineral in the body. What percentage of the body's calcium is found in the skeleton and teeth?",
      options: [
        "99% in the skeleton and teeth, with only 1% in blood, fluids, and soft tissues",
        "85% in skeletal tissue and the remaining 15% in blood and soft tissues",
        "50% in the skeleton and 50% distributed throughout blood and body fluids",
        "75% in the skeleton and teeth and 25% in soft tissue, blood, and extracellular fluid"
      ],
      correctAnswer: 0
    },
    {
      id: 90418,
      question: "Which of the following is NOT a function of calcium in the body?",
      options: [
        "Blood clotting, transmitting nerve impulses, and muscle contraction and relaxation",
        "Salivary calcium acting as a buffer and activating certain enzymes",
        "Functioning as a cofactor for more than 300 enzymes and facilitating PTH secretion",
        "Bone health, membrane permeability, and activating certain enzymes"
      ],
      correctAnswer: 2
    },
    {
      id: 90419,
      question: "The relationship between serum calcium and phosphorus levels is best described as:",
      options: [
        "Directly proportional — when calcium increases, phosphorus increases equally",
        "Synergistic — both minerals must rise together for effective bone mineralization to occur",
        "Independent — serum calcium and phosphorus levels do not affect each other",
        "Inversely related — when calcium increases, phosphorus decreases and vice versa"
      ],
      correctAnswer: 3
    },
    {
      id: 90420,
      question: "Which of the following hormones helps regulate calcium absorption?",
      options: [
        "Parathyroid hormone (PTH), estrogen, glucocorticoids, and thyroid hormone regulate calcium absorption",
        "Insulin, glucagon, cortisol, and growth hormone are the primary regulators of calcium",
        "Thyroxine, epinephrine, aldosterone, and progesterone are the main calcium regulators",
        "Calcitonin, leptin, adrenaline, and testosterone are responsible for calcium balance"
      ],
      correctAnswer: 0
    },
    {
      id: 90421,
      question: "Under normal conditions, approximately how much of consumed calcium is absorbed?",
      options: [
        "More than two-thirds of consumed calcium is absorbed under normal conditions",
        "Less than one-third of consumed calcium is absorbed under normal conditions",
        "Exactly half of consumed calcium is absorbed when Vitamin D levels are adequate",
        "Nearly all consumed calcium is absorbed provided intake is spread throughout the day"
      ],
      correctAnswer: 1
    },
    {
      id: 90422,
      question: "How is maximum calcium absorption best achieved?",
      options: [
        "Consuming large amounts of calcium twice daily with high-fat meals for best uptake",
        "Taking calcium supplements on an empty stomach to maximize gastric acid interaction",
        "Combining calcium with high-fiber foods to slow digestion and improve absorption rate",
        "Consuming calcium in small amounts ingested several times throughout the day"
      ],
      correctAnswer: 3
    },
    {
      id: 90423,
      question: "Which of the following calcium supplement forms have the highest absorption rates?",
      options: [
        "Calcium carbonate and calcium phosphate have the highest absorption rates of all forms",
        "Calcium gluconate and calcium oxide have the highest bioavailability of supplement forms",
        "Calcium citrate malate, calcium lactate, calcium citrate, and calcium sulfate have high absorption rates",
        "Calcium orotate and calcium aspartate have the highest absorption among all supplement types"
      ],
      correctAnswer: 2
    },
    {
      id: 90424,
      question: "Excessive calcium intake (hypercalcemia) may result in:",
      options: [
        "Fragility of alveolar bone, gingival hypertrophy, cardiac dysrhythmias, and neuromuscular hyperexcitability",
        "Diplopia, alopecia, reddened gingiva, cracked lips, and thinning of the epithelium in soft tissues",
        "Night blindness, enamel hypoplasia, growth restriction, and susceptibility to infections",
        "Dizziness, kidney stone formation, irregular heartbeat, xerostomia, and inhibited iron and zinc absorption"
      ],
      correctAnswer: 3
    },
    {
      id: 90425,
      question: "Phosphorus is the second most abundant mineral in the body. What percentage is found in the skeleton and teeth?",
      options: [
        "99% of body phosphorus is located in the skeleton and teeth",
        "75% in the skeleton and the remaining 25% in cell membranes, DNA, and RNA",
        "85% in the skeleton and teeth, with the remainder in soft tissue and body fluids",
        "50% in skeletal tissue and the remaining 50% distributed in soft tissues and blood"
      ],
      correctAnswer: 2
    },
    {
      id: 90426,
      question: "Which of the following is a function of phosphorus?",
      options: [
        "Replacing hydroxyl ions in hydroxyapatite crystal lattice to resist demineralization",
        "Acting as a cofactor for over 300 enzymes and facilitating PTH secretion and blood clotting",
        "Enhancing iron absorption, supporting collagen synthesis, and acting as a systemic antioxidant",
        "Formation of bones and teeth, energy metabolism (ADP), component of DNA/RNA, and buffer for the body"
      ],
      correctAnswer: 3
    },
    {
      id: 90427,
      question: "Hypophosphatemia may occur as a result of:",
      options: [
        "Hypoparathyroidism, renal insufficiency, and excessive Vitamin C supplementation",
        "Long-term use of aluminum hydroxide antacids, stress conditions, or intestinal malabsorption disorders",
        "Excessive calcium intake, long-term use of diuretics, and chronic alcohol consumption",
        "High dietary fiber intake, megadoses of Vitamin D supplements, and low protein diet"
      ],
      correctAnswer: 1
    },
    {
      id: 90428,
      question: "Which of the following best describes a physiologic role of magnesium?",
      options: [
        "It forms fluorapatite in teeth, inhibits Streptococcus mutans, and stimulates osteoblast activity",
        "It is the most abundant mineral in the body, composing 99% of skeletal and dental tissue",
        "It is a cofactor for over 300 enzymes, necessary for DNA/RNA synthesis, and associated with Vitamin D conversion in the liver",
        "It enhances intestinal calcium absorption, acts as anticoagulant, and protects polyunsaturated fats"
      ],
      correctAnswer: 2
    },
    {
      id: 90429,
      question: "A deficiency in magnesium may produce which of the following oral manifestation?",
      options: [
        "Fragility of alveolar bone and gingival hypertrophy as symptoms of deficiency",
        "Reddened gingiva, sore burning mouth, and malformed enamel due to scurvy-like effects",
        "Enamel hypoplasia, dental caries, periodontitis, and loss of the lamina dura",
        "Dental fluorosis with white flecks, brown staining, and enamel pitting on tooth surfaces"
      ],
      correctAnswer: 0
    },
    {
      id: 90430,
      question: "Magnesium toxicity from supplementation may cause:",
      options: [
        "Diplopia, alopecia, reddened gingiva, and cracked lips similar to Vitamin A toxicity",
        "Diarrhea, nausea, cramping, and potentially kidney failure due to excess magnesium",
        "Nausea, vomiting, tingling sensations in the mouth, and kidney stone formation",
        "Enamel hypoplasia, periodontitis, dental caries, and loss of the lamina dura in adults"
      ],
      correctAnswer: 1
    },
    {
      id: 90431,
      question: "Fluoride is considered a desirable element for humans, not a true essential nutrient, because it:",
      options: [
        "Can only be obtained through water fluoridation and has no natural food sources",
        "Is found exclusively in fluorapatite crystal and cannot be incorporated into bone tissue",
        "Has no known metabolic function but provides significant benefits to dental and bone health",
        "Is toxic at all concentrations and therefore cannot be classified as nutritionally essential"
      ],
      correctAnswer: 2
    },
    {
      id: 90432,
      question: "How does fluoride protect against dental caries?",
      options: [
        "It inhibits Streptococcus mutans by lowering salivary pH and increasing buffer capacity",
        "It increases collagen synthesis in the periodontal ligament, strengthening tooth attachment",
        "It enhances calcium absorption from saliva, remineralizing enamel after acid exposure",
        "Fluoride ions replace hydroxyl ions in the hydroxyapatite crystal lattice forming fluorapatite, which is more caries resistant"
      ],
      correctAnswer: 3
    },
    {
      id: 90433,
      question: "Higher concentrations of fluoride have been shown to inhibit which of the following microorganisms?",
      options: [
        "Candida albicans, Porphyromonas gingivalis, and Treponema denticola",
        "Streptococcus mutans, Streptococcus sobrinus, and Lactobacillus species",
        "Actinomyces viscosus, Fusobacterium nucleatum, and Prevotella intermedia",
        "Staphylococcus aureus, Escherichia coli, and Streptococcus pyogenes"
      ],
      correctAnswer: 1
    },
    {
      id: 90434,
      question: "Dental fluorosis is caused by which of the following?",
      options: [
        "Low fluoride levels during tooth formation causing enamel hypoplasia and caries susceptibility",
        "Excessive fluoride exposure after tooth eruption causing enamel softening and decay",
        "Fluoride deficiency in adult life causing loss of lamina dura and periodontal deterioration",
        "Fluoride exposure during tooth development causing hypomineralization of enamel, ranging from white flecks to brown staining and pitting"
      ],
      correctAnswer: 3
    },
    {
      id: 90435,
      question: "Which statement about fluoride and dental caries is most accurate?",
      options: [
        "The protective effect of fluoride against caries is greatest after tooth eruption in adults only",
        "Fluoride only protects against caries when applied topically and has no benefit systemically",
        "The protective effect against caries is greatest during tooth formation, and continued fluoridated water use by adults is also beneficial",
        "Fluoride provides no cariostatic benefit once the permanent dentition has fully erupted"
      ],
      correctAnswer: 2
    },
    {
      id: 90436,
      question: "Vitamin K functions as which of the following in the body?",
      options: [
        "A coenzyme for proteins involved in bone crystalline formation and a catalyst for synthesis of blood-clotting factors",
        "An antioxidant protecting polyunsaturated fats in phospholipid cell membranes from oxidation",
        "A hormone that enhances intestinal calcium and phosphorus absorption systemically",
        "A coenzyme in hydroxylation of proline for hydroxyproline synthesis in collagen formation"
      ],
      correctAnswer: 0
    },
    {
      id: 90437,
      question: "Vitamin requirements can vary based on age, gender, tobacco and alcohol use, stress, and health status.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90438,
      question: "Fat-soluble vitamins are readily absorbed in the jejunum, stored in small amounts, and require daily intake.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90439,
      question: "A secondary vitamin deficiency is caused by inadequate absorption or use, increased requirements, excretion, or destruction of a nutrient.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90440,
      question: "Vitamin D is more appropriately classified as a hormone than a vitamin.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90441,
      question: "High dietary fiber intake can result in decreased Vitamin D absorption.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90442,
      question: "Vitamin E deficiency is common in the general population and rarely requires supplementation.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90443,
      question: "Vitamin K1 (phylloquinone) is found in green plants, while Vitamin K2 (menaquinone) is formed by E. coli bacteria in the large intestine.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90444,
      question: "Vitamin C deficiency directly causes gingivitis and periodontal disease as a primary etiology.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90445,
      question: "Phosphorus increases the uptake of calcium by bone, and its serum level is inversely related to serum calcium.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90446,
      question: "Fluoride is classified as an essential nutrient because it has a known metabolic function in the body.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90447,
      question: "Systemic fluoride results in changes to tooth morphology and increases the tooth's resistance to adherence of plaque biofilm.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90448,
      question: "The organic matrix of bone is 90% to 95% collagen fibers, and its formation requires protein, Vitamin C, iron, copper, and zinc.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90449,
      question: "Magnesium deficiency is common in healthy individuals and frequently occurs without any underlying medical condition or medication use.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90450,
      question: "Cementum is softer than bone because it contains fewer minerals, while dentin has the same constituents as bone but with a denser structure.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90451,
      question: "Maximum calcium absorption is achieved by consuming large single doses of calcium once daily rather than spreading intake throughout the day.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    }
  ],
  "7. Fluids (Part 1)": [
    {
      id: 90452,
      question: "What percentage of body weight does water constitute in a newborn infant?",
      options: [
        "75% to 80%",
        "50% to 60%",
        "40% to 50%",
        "60% to 70%"
      ],
      correctAnswer: 0
    },
    {
      id: 90453,
      question: "Which of the following best describes the role of osmotic pressure in body fluid regulation?",
      options: [
        "It increases the total volume of intracellular fluid by producing new water molecules",
        "It destroys electrolytes in the extracellular fluid to maintain concentration gradients",
        "It equalizes the solute concentration between intracellular fluid (ICF) and extracellular fluid (ECF)",
        "It converts extracellular fluid into intracellular fluid to maintain organ function"
      ],
      correctAnswer: 2
    },
    {
      id: 90454,
      question: "Which physiologic role of water involves enabling chemical reactions such as hydrolysis?",
      options: [
        "Temperature regulation through evaporation from the skin surface",
        "Transport of nutrients to cells and removal of metabolic waste products",
        "Acting as a solvent that participates directly in certain chemical reactions",
        "Lubricant function between cells to reduce friction during movement"
      ],
      correctAnswer: 2
    },
    {
      id: 90455,
      question: "How does water help regulate body temperature?",
      options: [
        "It activates the hypothalamus to trigger shivering and raise core body temperature",
        "It evaporates as perspiration from the skin and as vapor from the mouth and nose",
        "It increases metabolic rate in fat cells to generate additional heat as needed",
        "It stores excess heat in the bloodstream until the body reaches a safe temperature"
      ],
      correctAnswer: 1
    },
    {
      id: 90456,
      question: "What is the adequate intake (AI) for total fluid per day for adult men?",
      options: [
        "3.7 L (15 to 16 cups)",
        "2.7 L (11 to 12 cups)",
        "4.5 L (18 to 19 cups)",
        "3.0 L (12 to 13 cups)"
      ],
      correctAnswer: 0
    },
    {
      id: 90457,
      question: "When does the body trigger a physiological desire to drink liquids?",
      options: [
        "When blood pressure drops by at least 15% due to dehydration effects",
        "When as little as 2% of body water is lost and osmoreceptors are stimulated",
        "When 10% or more of total body water has been lost through urination",
        "When 5% of body water is lost and the kidneys reduce urine production"
      ],
      correctAnswer: 1
    },
    {
      id: 90458,
      question: "How is water absorbed in the gastrointestinal tract?",
      options: [
        "It is transported easily in both directions across the intestinal mucosa by osmosis",
        "It is absorbed only in the large intestine through active transport mechanisms",
        "It requires enzymatic digestion before it can pass through the intestinal wall",
        "It must be combined with electrolytes before absorption can occur in the stomach"
      ],
      correctAnswer: 0
    },
    {
      id: 90459,
      question: "Approximately how much water can the small intestine absorb within one hour?",
      options: [
        "500 mL",
        "250 mL",
        "1 L",
        "2 L"
      ],
      correctAnswer: 2
    },
    {
      id: 90460,
      question: "What percentage of total fluid intake typically comes from drinking plain water?",
      options: [
        "50% to 60%",
        "30% to 34%",
        "10% to 15%",
        "20% to 25%"
      ],
      correctAnswer: 1
    },
    {
      id: 90461,
      question: "Which U.S. agency regulates contaminant levels allowed in public drinking water systems?",
      options: [
        "Centers for Disease Control and Prevention (CDC)",
        "Environmental Protection Agency (EPA)",
        "U.S. Food and Drug Administration (FDA)",
        "U.S. Department of Agriculture (USDA)"
      ],
      correctAnswer: 1
    },
    {
      id: 90462,
      question: "Coffee and tea are notable as beverage sources because they are:",
      options: [
        "The number one beverage consumed at home in the United States",
        "The leading source of added sugar in the American diet",
        "Regulated by the USDA for maximum caffeine concentration limits",
        "The primary contributor to dental erosion due to their high acidity"
      ],
      correctAnswer: 0
    },
    {
      id: 90463,
      question: "Sugar-sweetened beverages account for what proportion of added sugar intake?",
      options: [
        "Up to 75%",
        "Up to 50%",
        "Up to 25%",
        "Up to 10%"
      ],
      correctAnswer: 1
    },
    {
      id: 90464,
      question: "Energy drinks are marketed primarily as ergogenics because they are claimed to:",
      options: [
        "Replace lost electrolytes after intense exercise better than sports drinks",
        "Improve hydration status more effectively than plain water or sports drinks",
        "Delay fatigue during physical activity and enhance athletic performance",
        "Provide essential vitamins and minerals lacking in the average American diet"
      ],
      correctAnswer: 2
    },
    {
      id: 90465,
      question: "Which ingredients are commonly found in energy drinks?",
      options: [
        "Glucose, fructose, and sucrose as primary carbohydrate energy sources",
        "Caffeine, guarana, and taurine as active stimulant ingredients",
        "Sodium, potassium, and magnesium electrolyte compounds",
        "Vitamin C, zinc, and iron as immune-boosting nutritional supplements"
      ],
      correctAnswer: 1
    },
    {
      id: 90466,
      question: "What pH range is associated with most sports and energy drinks, and why is this clinically significant?",
      options: [
        "pH below 4 (acidic range), which contributes to dental erosion of tooth enamel",
        "pH above 7, which promotes remineralization of enamel and reduces caries risk",
        "pH of exactly 7 (neutral), which has no significant effect on oral hard tissues",
        "pH between 5 and 6, which mildly irritates soft tissues but does not erode enamel"
      ],
      correctAnswer: 0
    },
    {
      id: 90467,
      question: "Which modification to sports drinks has been shown to reduce their erosive potential to teeth?",
      options: [
        "Adding calcium to sports drinks to lessen the erosive potential to tooth enamel",
        "Reducing the caffeine content so salivary flow is not inhibited during exercise",
        "Replacing sugar with artificial sweeteners to lower the overall acidity of the beverage",
        "Increasing the fluoride concentration to promote enamel remineralization after exposure"
      ],
      correctAnswer: 0
    },
    {
      id: 90468,
      question: "Fluid volume excess (FVE) occurs in extracellular fluid compartments secondary to:",
      options: [
        "Decreased kidney filtration caused by insufficient dietary protein consumption",
        "An increase in total body sodium that draws and retains fluid in ECF spaces",
        "Inadequate fluid intake that triggers aldosterone release and fluid conservation",
        "Excessive loss of water through perspiration and prolonged physical exercise"
      ],
      correctAnswer: 1
    },
    {
      id: 90469,
      question: "Which of the following is NOT listed as a classic sign of fluid volume deficit (FVD)?",
      options: [
        "Dry tongue with longitudinal fissures",
        "Elevated blood pressure and puffy eyelids",
        "Xerostomia (dry mouth)",
        "Decreased urinary output"
      ],
      correctAnswer: 1
    },
    {
      id: 90470,
      question: "Longitudinal fissures on the tongue are defined as:",
      options: [
        "Slits or wrinkles that extend lengthwise along the surface of the tongue",
        "Deep red lesions caused by fungal infection of the dorsal tongue surface",
        "Small ulcerations on the lateral borders caused by trauma from sharp teeth",
        "Horizontal cracks across the tongue resulting from vitamin B12 deficiency"
      ],
      correctAnswer: 0
    },
    {
      id: 90471,
      question: "Which of the following correctly identifies the principal cation and principal anion found in plasma and interstitial fluid?",
      options: [
        "Calcium is the principal cation; bicarbonate is the principal anion",
        "Magnesium is the principal cation; chloride is the principal anion",
        "Potassium is the principal cation; phosphate is the principal anion",
        "Sodium is the principal cation; chloride is the principal anion"
      ],
      correctAnswer: 3
    },
    {
      id: 90472,
      question: "What is the adequate intake (AI) for sodium for adults, and what is the established upper limit?",
      options: [
        "AI of 1500 mg/day with an upper limit of 2300 mg/day for healthy adults",
        "AI of 1000 mg/day with an upper limit of 2000 mg/day for healthy adults",
        "AI of 2300 mg/day with an upper limit of 3400 mg/day for healthy adults",
        "AI of 500 mg/day with an upper limit of 1500 mg/day for healthy adults"
      ],
      correctAnswer: 0
    },
    {
      id: 90473,
      question: "What is the average daily sodium consumption among Americans, and why is this concerning?",
      options: [
        "2300 mg/day, which is exactly at the upper tolerable intake level for sodium",
        "4500 mg/day, which greatly exceeds all guidelines due to high processed food intake",
        "1500 mg/day, which is below the recommended minimum safe intake threshold",
        "3400 mg/day, which exceeds the upper intake limit and is linked to hypertension"
      ],
      correctAnswer: 3
    },
    {
      id: 90474,
      question: "Which of the following is a sign of hypernatremia (elevated serum sodium)?",
      options: [
        "Rapid weight gain, distended neck veins, and significantly elevated blood pressure",
        "Nausea, abdominal cramps, confusion, and progressive lethargy or coma",
        "Angular cheilosis, pallor of the lips and gingiva, and glossitis with burning sensation",
        "Extreme thirst, dry sticky tongue, dry oral mucous membranes, and convulsions"
      ],
      correctAnswer: 3
    },
    {
      id: 90475,
      question: "Hyponatremia can result from which of the following conditions?",
      options: [
        "Water intoxication from drinking too much water, which dilutes serum sodium levels",
        "Excessive intake of sodium from processed foods over an extended period of time",
        "Dehydration from inadequate fluid intake that concentrates sodium in the bloodstream",
        "Congestive heart failure causing fluid retention and elevated serum sodium levels"
      ],
      correctAnswer: 0
    },
    {
      id: 90476,
      question: "Which of the following is a primary physiologic role of sodium in the body?",
      options: [
        "It catalyzes enzymatic reactions involved in DNA and RNA synthesis in cells",
        "It functions as an antioxidant by neutralizing free radicals in the bloodstream",
        "It facilitates impulse transmission in nerve and muscle fibers throughout the body",
        "It serves as a structural component of bone and contributes to skeletal density"
      ],
      correctAnswer: 2
    },
    {
      id: 90477,
      question: "What is the physiologic role of chloride in the body?",
      options: [
        "It serves as a coenzyme for over 300 enzymes involved in cellular replication",
        "It promotes collagen synthesis and aids in wound healing of oral soft tissues",
        "It regulates cardiac muscle contraction and electrical conductivity of the heart",
        "It maintains ECF balance, osmotic equilibrium, and overall electrolyte balance"
      ],
      correctAnswer: 3
    },
    {
      id: 90478,
      question: "What is the adequate intake (AI) for chloride for adults?",
      options: [
        "500 mg/day",
        "3400 mg/day",
        "2300 mg/day",
        "1500 mg/day"
      ],
      correctAnswer: 2
    },
    {
      id: 90479,
      question: "Which of the following conditions can cause chloride toxicity?",
      options: [
        "Long-term use of diuretic medications that increase chloride retention in the kidney",
        "Inadequate dietary salt intake combined with heavy physical activity and sweating",
        "Excessive intakes of salt, dehydration, renal failure, diarrhea, and Cushing syndrome",
        "Excessive alcohol consumption that impairs chloride absorption in the intestine"
      ],
      correctAnswer: 2
    },
    {
      id: 90480,
      question: "Potassium plays a critical role in which of the following physiologic processes?",
      options: [
        "Production of thyroxine and regulation of thyroid gland metabolic activity",
        "Directly affecting muscle contraction (especially cardiac) and electrical conductivity of the heart",
        "Synthesis of collagen and promotion of wound healing in periodontal tissues",
        "Maintaining extracellular fluid concentration and regulating sodium excretion"
      ],
      correctAnswer: 1
    },
    {
      id: 90481,
      question: "What is the adequate intake (AI) for potassium for adult women and men respectively?",
      options: [
        "3400 mg/day for women and 4700 mg/day for men",
        "2000 mg/day for women and 2600 mg/day for men",
        "1500 mg/day for women and 2000 mg/day for men",
        "2600 mg/day for women and 3400 mg/day for men"
      ],
      correctAnswer: 3
    },
    {
      id: 90482,
      question: "Which of the following is a cause of hypokalemia (low serum potassium)?",
      options: [
        "Impaired renal excretion due to chronic kidney disease and reduced filtration",
        "Increased dietary intake of potassium-rich foods such as bananas and potatoes",
        "Use of diuretics such as furosemide and hydrochlorothiazide that increase potassium loss",
        "Excessive potassium supplementation beyond the upper tolerable intake level"
      ],
      correctAnswer: 2
    },
    {
      id: 90483,
      question: "Hyperkalemia (elevated serum potassium) is considered life threatening primarily because it:",
      options: [
        "Leads to extreme dehydration by disrupting fluid balance in the kidneys",
        "Causes irreversible liver damage and cirrhosis from potassium accumulation",
        "Severely disrupts thyroid hormone production and metabolic regulation",
        "Critically affects cardiac muscle function and the electrical conductivity of the heart"
      ],
      correctAnswer: 3
    },
    {
      id: 90484,
      question: "Which of the following is a food source of potassium?",
      options: [
        "Iodized table salt and sea salt used in cooking and food preparation",
        "Seafood, molasses, and plants grown near coastal ocean environments",
        "Organ meats and saltwater fish primarily consumed as dietary protein",
        "Dairy products, meat, grains, fruits, vegetables, and processed foods"
      ],
      correctAnswer: 3
    },
    {
      id: 90485,
      question: "Which of the following is a physiologic role of iron in the body?",
      options: [
        "Component of hemoglobin and catalyst for oxidative reactions within cells",
        "Maintenance of cardiac electrical conductivity and nerve impulse transmission",
        "Maintenance of extracellular fluid balance and osmotic pressure regulation",
        "Production of thyroxine for thyroid regulation and metabolic rate control"
      ],
      correctAnswer: 0
    },
    {
      id: 90486,
      question: "Iron is involved in which of the following vitamin-related metabolic conversions?",
      options: [
        "Conversion of tryptophan to niacin (vitamin B3) in the liver tissues",
        "Conversion of beta-carotene to vitamin A in the intestinal cells",
        "Conversion of folic acid to its bioavailable form for DNA synthesis",
        "Conversion of vitamin D to its active form in the liver and kidneys"
      ],
      correctAnswer: 1
    },
    {
      id: 90487,
      question: "What is the RDA for iron for women aged 19 to 50 years?",
      options: [
        "8 mg/day",
        "27 mg/day",
        "45 mg/day",
        "18 mg/day"
      ],
      correctAnswer: 3
    },
    {
      id: 90488,
      question: "What is the upper intake level (UL) for iron in adults?",
      options: [
        "27 mg/day",
        "45 mg/day",
        "8 mg/day",
        "18 mg/day"
      ],
      correctAnswer: 1
    },
    {
      id: 90489,
      question: "How is iron transported through the body after absorption?",
      options: [
        "It dissolves freely in plasma and is filtered and redistributed by the kidneys",
        "It attaches to red blood cell membranes and is delivered directly to bone marrow",
        "It binds to the serum protein transferrin, which continuously transports and recycles iron",
        "It binds to albumin and is carried through the lymphatic system to the liver"
      ],
      correctAnswer: 2
    },
    {
      id: 90490,
      question: "Which type of iron has absorption that is most closely regulated by the body's physiologic need?",
      options: [
        "Non-heme iron from plant-based and fortified food sources",
        "Heme iron from animal-based sources such as meat, fish, and poultry",
        "Ferrous iron from fortified cereals and enriched grain products",
        "Supplemental iron from over-the-counter iron tablets and multivitamins"
      ],
      correctAnswer: 1
    },
    {
      id: 90491,
      question: "Which of the following is a heme iron food source?",
      options: [
        "Organ meats, meat, fish, and poultry as animal protein sources",
        "Green vegetables, dried fruit, and whole grain bread products",
        "Legumes, tofu, and fortified plant-based milk alternatives",
        "Eggs, milk, and enriched cereals commonly consumed at breakfast"
      ],
      correctAnswer: 0
    },
    {
      id: 90492,
      question: "Which oral manifestation is associated with iron deficiency?",
      options: [
        "Dry sticky tongue, convulsions, and shrinkage of oral mucous membranes",
        "Flattened filiform papillae and increased susceptibility to periodontal disease",
        "Delayed eruption of primary and secondary teeth and enlarged tongue",
        "Angular cheilosis, pallor of lips and gingiva, and glossitis with burning tongue"
      ],
      correctAnswer: 3
    },
    {
      id: 90493,
      question: "Hemochromatosis is associated with which mineral's excess in the body?",
      options: [
        "Sodium excess triggering fluid accumulation in the extracellular spaces",
        "Zinc excess causing accumulation in the liver and pancreatic tissues",
        "Iodine excess causing disruption of thyroid hormone regulation",
        "Iron excess causing organ damage, skin pigmentation, and liver cirrhosis"
      ],
      correctAnswer: 3
    },
    {
      id: 90494,
      question: "Zinc functions as a component in more than how many enzymes in the human body?",
      options: [
        "100 enzymes involved in energy metabolism and ATP production",
        "50 enzymes primarily affecting immune function and antibody production",
        "300 enzymes affecting cell growth and replication including DNA/RNA synthesis",
        "200 enzymes regulating hormone synthesis and endocrine gland function"
      ],
      correctAnswer: 2
    },
    {
      id: 90495,
      question: "Which oral health condition is associated with zinc deficiency?",
      options: [
        "Hemochromatosis with skin pigmentation and cirrhosis of the liver",
        "Dental erosion from the acidic environment created by low zinc saliva",
        "Delayed eruption of primary and secondary teeth and an enlarged tongue",
        "Increased susceptibility to periodontal disease and flattened filiform papillae"
      ],
      correctAnswer: 3
    },
    {
      id: 90496,
      question: "What are the RDA values for zinc in adult men and women respectively?",
      options: [
        "11 mg/day for men and 8 mg/day for women",
        "15 mg/day for men and 12 mg/day for women",
        "10 mg/day for men and 10 mg/day for women",
        "8 mg/day for men and 11 mg/day for women"
      ],
      correctAnswer: 0
    },
    {
      id: 90497,
      question: "Which of the following is the best dietary source of zinc?",
      options: [
        "Iodized salt, seafood near coasts, and molasses from sugarcane processing",
        "Green leafy vegetables, dried fruit, and whole grain enriched cereal products",
        "Oysters and other crustaceans, along with lamb, beef, eggs, and peanuts",
        "Dairy products, potatoes, and bananas as commonly consumed daily foods"
      ],
      correctAnswer: 2
    },
    {
      id: 90498,
      question: "Excessive zinc intake can lead to which of the following adverse effects?",
      options: [
        "Reduced copper status and decreased high-density lipoprotein (HDL) cholesterol",
        "Goiter formation from thyroid suppression and iodine-zinc metabolic interference",
        "Water retention, elevated blood pressure, and distension of the neck veins",
        "Microcytic anemia, angular cheilosis, and pallor of the oral mucous membranes"
      ],
      correctAnswer: 0
    },
    {
      id: 90499,
      question: "What percentage of dietary zinc is typically absorbed by the body?",
      options: [
        "60% to 80% of dietary zinc with excess stored in skeletal muscle tissue",
        "Approximately 25% to 40% of dietary zinc with excess lost in the feces",
        "50% to 70% of dietary zinc depending on the presence of vitamin C cofactors",
        "Less than 10% of dietary zinc due to poor bioavailability in all food forms"
      ],
      correctAnswer: 1
    },
    {
      id: 90500,
      question: "What is the upper intake level (UL) for zinc in adults?",
      options: [
        "11 mg/day",
        "25 mg/day",
        "100 mg/day",
        "40 mg/day"
      ],
      correctAnswer: 3
    },
    {
      id: 90501,
      question: "What is the primary physiologic role of iodine in the body?",
      options: [
        "It is required for production of thyroxine by the thyroid gland",
        "It contributes to the structural matrix of bone and tooth enamel during development",
        "It serves as an antioxidant cofactor for enzymes that protect cells from oxidative damage",
        "It regulates fluid balance in the extracellular compartment alongside sodium and chloride"
      ],
      correctAnswer: 0
    },
    {
      id: 90502,
      question: "What is the RDA for iodine for adults, and what is the established upper limit?",
      options: [
        "RDA of 200 µg/day; UL of 2000 µg/day for adults based on thyroid tolerance",
        "RDA of 150 µg/day; UL of 1100 µg/day for adults with higher needs in pregnancy",
        "RDA of 75 µg/day; UL of 800 µg/day based on risk of thyroiditis from excess",
        "RDA of 50 µg/day; UL of 500 µg/day for all adults including pregnant women"
      ],
      correctAnswer: 1
    },
    {
      id: 90503,
      question: "Which of the following is a food source of iodine?",
      options: [
        "Lamb, beef, oysters, and crustaceans as primary animal protein sources",
        "Organ meats, poultry, fish, and whole grain enriched cereal products",
        "Seafood, plants grown near the ocean, yogurt, milk, and iodized salt",
        "Dried fruit, green vegetables, eggs, and milk as non-heme dietary sources"
      ],
      correctAnswer: 2
    },
    {
      id: 90504,
      question: "Which of the following is a dental manifestation of iodine deficiency?",
      options: [
        "Angular cheilosis and pallor of the lips and gingiva from anemia",
        "Flattened filiform papillae and increased susceptibility to periodontal disease",
        "Increased erosion of enamel and sensitivity due to acidic saliva",
        "Delayed eruption of both primary and secondary dentition"
      ],
      correctAnswer: 3
    },
    {
      id: 90505,
      question: "What condition results from iodine deficiency that involves enlargement of the thyroid gland?",
      options: [
        "Hyperaldosteronism from adrenal gland overstimulation due to iodine deficiency",
        "Hemochromatosis from excessive iron accumulation in the glandular tissue",
        "Goiter, which is the enlargement of the thyroid gland due to insufficient iodine",
        "Cushing syndrome caused by elevated cortisol from chronic iodine deprivation"
      ],
      correctAnswer: 2
    },
    {
      id: 90506,
      question: "Excessive iodine intake can result in which of the following conditions?",
      options: [
        "Goiter, delayed tooth eruption, enlarged tongue, and endemic cretinism",
        "Hemochromatosis, skin pigmentation, coronary heart disease, and liver cirrhosis",
        "Microcytic anemia, angular cheilosis, and pallor of the oral tissues",
        "Thyroiditis, hypothyroidism, hyperthyroidism, and sensitivity reactions"
      ],
      correctAnswer: 3
    },
    {
      id: 90507,
      question: "Which of the following conditions is associated with iodine deficiency in pregnant women?",
      options: [
        "Severe anemia and iron depletion from competing mineral absorption pathways",
        "Gestational diabetes due to thyroid dysfunction and insulin resistance changes",
        "Spontaneous abortions and congenital anomalies in the developing fetus",
        "Gestational hypertension and increased risk of pre-eclampsia in late pregnancy"
      ],
      correctAnswer: 2
    },
    {
      id: 90508,
      question: "A patient presents with a dry tongue showing longitudinal fissures, xerostomia, and shrunken oral mucous membranes. These findings are most consistent with which condition?",
      options: [
        "Fluid volume deficit (FVD) caused by excessive loss of fluids from the body",
        "Fluid volume excess (FVE) secondary to an increase in total body sodium levels",
        "Hypernatremia with elevated serum sodium causing extreme thirst and dry membranes",
        "Hyponatremia from excessive water intake leading to sodium dilution in the blood"
      ],
      correctAnswer: 0
    },
    {
      id: 90509,
      question: "A patient with congestive heart failure develops rapid weight gain, puffy eyelids, and elevated blood pressure. These findings are most consistent with which condition?",
      options: [
        "Hyperkalemia from impaired renal excretion of potassium due to heart failure",
        "Hyponatremia caused by dilution of serum sodium from excessive fluid retention",
        "Fluid volume excess (FVE) secondary to an increase in total body sodium levels",
        "Fluid volume deficit from decreased cardiac output and reduced kidney perfusion"
      ],
      correctAnswer: 2
    },
    {
      id: 90510,
      question: "Which mineral deficiency is associated with atrophy of filiform papillae and possible increased susceptibility to dental caries?",
      options: [
        "Iodine deficiency disrupting thyroid function and salivary gland secretion rates",
        "Potassium deficiency altering fluid distribution within oral mucosal tissues",
        "Zinc deficiency affecting taste, smell, and oral epithelial keratinization processes",
        "Iron deficiency presenting with oral signs including glossitis and mucosal pallor"
      ],
      correctAnswer: 3
    },
    {
      id: 90511,
      question: "Which of the following best describes the relationship between zinc deficiency and oral health?",
      options: [
        "Zinc deficiency causes delayed tooth eruption, enlarged tongue, and goiter formation",
        "Zinc deficiency promotes dental erosion by lowering the pH of saliva in the oral cavity",
        "Zinc deficiency results in thickening of epithelium, impaired keratinization, and increased periodontal disease risk",
        "Zinc deficiency leads to angular cheilosis, pallor of the gingiva, and candidiasis risk"
      ],
      correctAnswer: 2
    },
    {
      id: 90512,
      question: "In which fluid compartment does potassium primarily maintain its concentration?",
      options: [
        "Transcellular fluid compartment found in cerebrospinal and synovial fluids",
        "Intracellular fluid compartment (ICF) within the cells of body tissues",
        "Lymphatic compartment as part of the immune and fluid drainage systems",
        "Extracellular fluid compartment (ECF) including blood plasma and interstitial fluid"
      ],
      correctAnswer: 1
    },
    {
      id: 90513,
      question: "Water constitutes 50% to 60% of body weight in an adult.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90514,
      question: "The adequate intake (AI) for total fluid for adult women is 3.7 liters per day.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90515,
      question: "Most sports and energy drinks have a pH below 4, placing them in the acidic range that can contribute to dental erosion.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90516,
      question: "The principal cation in plasma and interstitial fluid is potassium.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90517,
      question: "Iron deficiency can lead to angular cheilosis, pallor of the lips and gingiva, and increased risk of candidiasis.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90518,
      question: "The upper intake level (UL) for zinc for adults is 40 mg/day.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90519,
      question: "Iodine deficiency can cause delayed eruption of both primary and secondary teeth and enlargement of the tongue.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    }
  ],
  "8. Nutrition in Various Stages of Life (Part 1)": [
    {
      id: 90520,
      question: "What is the energy requirement range for infants between 3 and 12 months of age (cal/kg/day)?",
      options: [
        "29 to 37 cal/kg per day, the same as adults",
        "50 to 65 cal/kg per day, reflecting moderate metabolic demands",
        "95 to 83 cal/kg per day, reflecting their higher resting metabolic rate",
        "110 to 120 cal/kg per day, reflecting extremely rapid early growth"
      ],
      correctAnswer: 2
    },
    {
      id: 90521,
      question: "What is the Adequate Intake (AI) for protein in infants from birth to 6 months of age?",
      options: [
        "0.75 g/kg daily, matching the lower bound of adult protein needs",
        "1.52 g/kg daily, supporting rapid early growth demands",
        "2.10 g/kg daily, compensating for immature digestive function",
        "3.00 g/kg daily, reflecting total caloric demands of newborns"
      ],
      correctAnswer: 1
    },
    {
      id: 90522,
      question: "Why should infant protein intake not exceed 20% of total daily caloric intake?",
      options: [
        "High protein leads to excessive weight gain and early childhood obesity",
        "Excess protein causes early-onset dental erosion in primary teeth",
        "Immature renal function is unable to handle higher protein loads",
        "Protein over 20% triggers allergic reactions in most infants"
      ],
      correctAnswer: 2
    },
    {
      id: 90523,
      question: "Which of the following best describes how nutritional deficiency during tooth development affects oral health?",
      options: [
        "It only affects adult teeth, leaving primary dentition largely unaffected",
        "It influences tooth size, formation, eruption timing, and caries susceptibility",
        "It primarily affects gum tissue health but not tooth structure itself",
        "It reduces saliva production but does not alter tooth mineralization"
      ],
      correctAnswer: 1
    },
    {
      id: 90524,
      question: "Mild to moderate malnutrition during the first year of life is associated with which of the following outcomes?",
      options: [
        "Delayed eruption of primary teeth only, with no effect on permanent teeth",
        "Reduced tooth size in primary teeth only, sparing permanent dentition",
        "Increased caries susceptibility in both primary and permanent teeth",
        "Increased risk of bruxism in both primary and permanent dentition"
      ],
      correctAnswer: 2
    },
    {
      id: 90525,
      question: "Approximately how tall do toddlers grow per year, and how much weight do they gain annually?",
      options: [
        "4 to 5 inches per year and approximately 8 lb per year",
        "5 to 6 inches per year and approximately 10 lb per year",
        "2 to 3 inches per year and approximately 5 lb per year",
        "1 to 2 inches per year and 3 lb per year on average"
      ],
      correctAnswer: 2
    },
    {
      id: 90526,
      question: "By what age do toddlers typically achieve half of their adult height?",
      options: [
        "1 to 1.5 years of age, during the most rapid growth phase",
        "4 to 5 years of age, near the end of the preschool period",
        "2.5 to 3 years of age, coinciding with slowed but steady growth",
        "6 to 7 years of age, at the start of school age development"
      ],
      correctAnswer: 2
    },
    {
      id: 90527,
      question: "Which nutrients are most often deficient in toddlers and preschool children?",
      options: [
        "Vitamin C, niacin, phosphorus, and magnesium",
        "Thiamine, riboflavin, copper, and chromium",
        "Iron, zinc, calcium, and vitamin D",
        "Vitamin K, folate, manganese, and selenium"
      ],
      correctAnswer: 2
    },
    {
      id: 90528,
      question: "What is the general formula for estimating caloric needs in toddlers and preschool children?",
      options: [
        "1000 cal plus 100 cal per year of life",
        "500 cal plus 50 cal per year of life beyond infancy",
        "800 cal plus 75 cal per year of life above toddler baseline",
        "1200 cal plus 150 cal per year of life during growth spurts"
      ],
      correctAnswer: 0
    },
    {
      id: 90529,
      question: "According to the slides, when are lifelong food habits and attitudes typically formed?",
      options: [
        "Preschool years, when family influences are most formative",
        "Adolescent years, when peer pressure and media have the greatest influence",
        "School-age years, when children gain independence from parents",
        "Early infancy, when taste preferences for sweet versus savory emerge"
      ],
      correctAnswer: 0
    },
    {
      id: 90530,
      question: "When planning meals for toddlers and preschool children, which approach is recommended for parents?",
      options: [
        "Strictly limit all sweet foods regardless of the child's expressed preferences",
        "Allow children complete freedom to choose whatever foods they prefer",
        "Consider the child's food preferences while maintaining control over available options",
        "Introduce only new foods regularly to expand the child's palate"
      ],
      correctAnswer: 2
    },
    {
      id: 90531,
      question: "At approximately what age can toddlers typically manipulate a cup independently?",
      options: [
        "9 months, coinciding with early solid food introduction",
        "12 months, at the end of the first year of life",
        "18 months, when fine motor coordination is sufficiently developed",
        "15 months, during early walking development phase"
      ],
      correctAnswer: 2
    },
    {
      id: 90532,
      question: "What are \"food jags\" in the context of toddler feeding, and what is the recommended response?",
      options: [
        "Periods of eating only one or few foods; continue offering balanced meals with choices",
        "Allergic reactions to new foods; eliminate the offending food immediately",
        "Overconsumption of one food group; restrict portions at mealtimes accordingly",
        "Periods of refusing all solid foods; reintroduce pureed options temporarily"
      ],
      correctAnswer: 0
    },
    {
      id: 90533,
      question: "Which of the following correctly describes preschool children aged 4 to 6 years regarding feeding behavior?",
      options: [
        "They prefer mixed foods and casseroles over individual food items",
        "They are able to independently feed themselves and prefer foods served separately",
        "They typically refuse finger foods in favor of utensil-based eating methods",
        "They still require adult assistance for all feeding and prefer pureed textures"
      ],
      correctAnswer: 1
    },
    {
      id: 90534,
      question: "How many exposures to a new food may a preschool child need before accepting it?",
      options: [
        "1 to 3 exposures, since children are naturally curious about new flavors",
        "8 to 15 exposures, reflecting typical food neophobia in this age group",
        "5 to 7 exposures, based on classical conditioning research on children",
        "3 to 5 exposures, consistent with short-term food neophobia patterns"
      ],
      correctAnswer: 1
    },
    {
      id: 90535,
      question: "Which of the following oral health concerns is commonly seen in children with cerebral palsy and Down syndrome?",
      options: [
        "Accelerated tooth eruption and enamel hypoplasia",
        "Excessive salivation and premature loss of primary teeth",
        "Bruxism and abnormal sensory input and muscle tone",
        "Rapid caries progression and complete absence of tooth sensitivity"
      ],
      correctAnswer: 2
    },
    {
      id: 90536,
      question: "In children with special needs, tongue thrust is particularly significant because it:",
      options: [
        "Directly destroys tooth enamel through repeated mechanical pressure",
        "Causes permanent damage to the palatal suture and jaw alignment",
        "Eliminates the gag reflex, making solid food introduction dangerous",
        "Jeopardizes nutritional status by interfering with adequate food intake"
      ],
      correctAnswer: 3
    },
    {
      id: 90537,
      question: "What percentage of school-age children (7 to 12 years) consume the recommended 3 servings of vegetables daily?",
      options: [
        "35%, meaning roughly one-third consistently meet vegetable guidelines",
        "12%, indicating widespread vegetable avoidance in this age group",
        "48%, showing nearly half of school-age children meet intake targets",
        "22%, suggesting most children fall short of vegetable recommendations"
      ],
      correctAnswer: 3
    },
    {
      id: 90538,
      question: "What percentage of adolescents are considered to be at nutritional risk due to biological, social, and cognitive changes?",
      options: [
        "17%, reflecting the broad impact of developmental changes on nutrition",
        "5%, representing only severely underweight or undernourished teens",
        "10%, including teens with identified eating disorders or chronic illness",
        "25%, accounting for all teens consuming diets high in processed foods"
      ],
      correctAnswer: 0
    },
    {
      id: 90539,
      question: "Which nutrients are especially important during adolescence due to long bone growth, sexual maturation, and muscle development?",
      options: [
        "Vitamin A, thiamine, and phosphorus for cellular energy metabolism",
        "Calcium, vitamin D, and iron to support rapid physical development",
        "Vitamin C, magnesium, and potassium for cardiovascular development",
        "Zinc, selenium, and riboflavin for hormonal regulation and growth"
      ],
      correctAnswer: 1
    },
    {
      id: 90540,
      question: "What percentage of girls aged 14 to 18 years meet the recommended daily intake of calcium?",
      options: [
        "20%, suggesting one in five adolescent girls gets adequate calcium",
        "31%, matching the figure seen in adolescent boys of the same age",
        "9%, revealing a widespread and significant calcium shortfall in teen girls",
        "45%, representing nearly half of teenage girls with adequate intake"
      ],
      correctAnswer: 2
    },
    {
      id: 90541,
      question: "Which of the following is identified as an external factor influencing adolescent eating habits?",
      options: [
        "Physiological needs driven by growth hormone fluctuations",
        "Body image and self-concept shaping food choices from within",
        "Food preferences developed through personal taste experiences",
        "Mass media, family, and peer pressure shaping food choices"
      ],
      correctAnswer: 3
    },
    {
      id: 90542,
      question: "Approximately what percentage of adolescent kilocalorie intake comes from high-calorie, low-nutrient foods?",
      options: [
        "10%, a small but measurable contribution from discretionary foods",
        "15%, consistent with occasional fast food consumption patterns",
        "25%, representing a substantial portion of daily caloric intake",
        "20%, reflecting weekend and after-school snack consumption habits"
      ],
      correctAnswer: 2
    },
    {
      id: 90543,
      question: "Which of the following is the most effective tactic when providing nutritional advice to adolescents?",
      options: [
        "Listing all nutritional deficiencies and recommending vitamin supplements",
        "Appealing to their physical image or muscular development goals",
        "Emphasizing long-term disease risk from poor dietary choices",
        "Providing detailed written information about recommended daily allowances"
      ],
      correctAnswer: 1
    },
    {
      id: 90544,
      question: "What are the three primary factors for a successful pregnancy outcome?",
      options: [
        "Adequate hydration, prenatal exercise, and regular prenatal checkups",
        "Genetic health of both parents, prenatal vitamins, and reduced stress levels",
        "Prenatal supplements, avoidance of processed foods, and sleep patterns",
        "Nutritional status before conception, appropriate weight gain, and adequate nutrients"
      ],
      correctAnswer: 3
    },
    {
      id: 90545,
      question: "How do caloric needs change during the first trimester of pregnancy?",
      options: [
        "They decrease by approximately 100 cal to prevent excessive early weight gain",
        "They do not increase, as the fetus's energy demands are minimal at this stage",
        "They increase by 200 cal to support early placental and fetal development",
        "They increase by 340 cal immediately upon confirmation of pregnancy"
      ],
      correctAnswer: 1
    },
    {
      id: 90546,
      question: "How many additional calories per day are recommended during the third trimester of pregnancy?",
      options: [
        "452 additional calories to support final fetal and placental development",
        "270 additional calories to match the demands of late fetal growth",
        "200 additional calories above pre-pregnancy baseline intake",
        "340 additional calories, the same increment used in the second trimester"
      ],
      correctAnswer: 0
    },
    {
      id: 90547,
      question: "What is the recommended total daily protein intake during pregnancy?",
      options: [
        "67 g/day, reflecting an additional 21 g above baseline adult needs",
        "56 g/day, a modest increase over baseline adult recommendations",
        "46 g/day, matching the standard non-pregnant adult recommendation",
        "85 g/day, accounting for full protein demands of fetal tissue building"
      ],
      correctAnswer: 0
    },
    {
      id: 90548,
      question: "During pregnancy, why is additional calcium and vitamin D supplementation generally not recommended for most women?",
      options: [
        "Both nutrients are abundantly available in standard prenatal vitamin formulas",
        "Excess calcium and vitamin D can cause fetal skeletal malformation",
        "The fetus synthesizes its own calcium and vitamin D from precursor molecules",
        "Physiological adjustments during pregnancy increase absorption of both nutrients"
      ],
      correctAnswer: 3
    },
    {
      id: 90549,
      question: "What is the Recommended Dietary Allowance (RDA) for folate during pregnancy, and why is it critical?",
      options: [
        "400 µg/day; it supports placental blood vessel growth and maternal circulation",
        "500 µg/day; it prevents gestational diabetes and regulates blood glucose levels",
        "800 µg/day; folate deficiency is the leading cause of premature labor complications",
        "600 µg/day; adequate folate can prevent 50% to 70% of neural tube defects"
      ],
      correctAnswer: 3
    },
    {
      id: 90550,
      question: "What is the RDA for iron during pregnancy, and what is one reason higher iron intake is needed?",
      options: [
        "21 mg/day; needed for fetal brain development and neural pathway formation",
        "27 mg/day; needed for red blood cell production, placenta, and delivery blood loss",
        "18 mg/day; needed to support the increased oxygen demands of maternal muscles",
        "15 mg/day; needed primarily to prevent maternal anemia from blood volume loss"
      ],
      correctAnswer: 1
    },
    {
      id: 90551,
      question: "During pregnancy, iron absorption increases to approximately what level?",
      options: [
        "25%, due to physiological adaptations that enhance gastrointestinal uptake",
        "15%, a modest increase driven by hormonal changes in early pregnancy",
        "10%, remaining the same as the standard baseline absorption rate",
        "20%, reflecting modest physiological adaptation in the first trimester"
      ],
      correctAnswer: 0
    },
    {
      id: 90552,
      question: "According to the Institute of Medicine, which nutrient is the only one warranting universal supplementation during pregnancy?",
      options: [
        "Calcium, because fetal bone development depletes maternal stores rapidly",
        "Iron, as it is the sole nutrient identified for global pregnancy supplementation",
        "Folate, because dietary sources alone rarely meet the elevated pregnancy RDA",
        "Zinc, because pregnancy dramatically increases demand for immune function support"
      ],
      correctAnswer: 1
    },
    {
      id: 90553,
      question: "Which of the following groups is considered high-risk and likely to need additional supplementation during pregnancy?",
      options: [
        "Women who follow a Mediterranean diet and exercise regularly",
        "Women who are over 30 years of age carrying a single fetus",
        "Adolescent mothers, women carrying multiple fetuses, and those using alcohol or drugs",
        "Women who are vegetarian but consume adequate dairy and plant protein"
      ],
      correctAnswer: 2
    },
    {
      id: 90554,
      question: "What is the recommended ideal infant feeding practice according to the lactation content?",
      options: [
        "Exclusive formula feeding for 6 months, then transitioning to breast milk and solids",
        "Starting solid foods at 3 months while continuing breast milk until at least 18 months",
        "Mixed feeding of breast milk and formula from birth to 6 months for nutritional balance",
        "Exclusive breastfeeding for 4 to 6 months, adding complementary foods by 6 months through 12 months"
      ],
      correctAnswer: 3
    },
    {
      id: 90555,
      question: "How many additional daily calories are required during breastfeeding?",
      options: [
        "500 additional calories daily, reflecting approximately 85 cal per 100 mL of milk",
        "300 additional calories daily, based on average milk volume production estimates",
        "400 additional calories daily, accounting for both milk production and recovery",
        "200 additional calories daily, less than the third trimester of pregnancy"
      ],
      correctAnswer: 0
    },
    {
      id: 90556,
      question: "What is the total daily protein recommendation during breastfeeding?",
      options: [
        "46 g/day, returning to pre-pregnancy baseline protein requirements",
        "70 g/day, slightly higher than pregnancy due to milk protein synthesis demands",
        "56 g/day, a modest increase over non-pregnant adult recommendations",
        "67 g/day, matching the protein intake recommended during pregnancy"
      ],
      correctAnswer: 1
    },
    {
      id: 90557,
      question: "Which additional minerals are needed in larger quantities during breastfeeding compared to pregnancy?",
      options: [
        "Calcium, iron, potassium, and magnesium for bone and muscle recovery",
        "Phosphorus, sodium, chloride, and sulfur for fluid balance and tissue repair",
        "Fluoride, manganese, chromium, and molybdenum for dental and immune health",
        "Copper, zinc, iodine, and selenium to support milk composition needs"
      ],
      correctAnswer: 3
    },
    {
      id: 90558,
      question: "How much additional fluid per day is recommended during breastfeeding?",
      options: [
        "1000 mL/day (4 cups), reflecting the volume of fluid used in milk production",
        "250 mL/day (1 cup), a modest increase to compensate for milk losses",
        "500 mL/day (2 cups), balancing maternal hydration and milk production",
        "750 mL/day (3 cups), supporting both maternal circulation and lactation"
      ],
      correctAnswer: 0
    },
    {
      id: 90559,
      question: "Which oral health concern in older adults is described as an indicator of malnutrition risk?",
      options: [
        "Calculus buildup and gingival recession in posterior sextants",
        "Changes in lip morphology leading to mouth breathing and dryness",
        "Tooth discoloration and enamel wear from dietary acid exposure",
        "Chewing problems, swallowing difficulty, and oral pain"
      ],
      correctAnswer: 3
    },
    {
      id: 90560,
      question: "How does xerostomia affect the dietary behavior of older adults?",
      options: [
        "It causes a preference for very cold foods, increasing sugar intake from frozen treats",
        "It leads to avoidance of crunchy, dry, and sticky foods, sometimes replaced with hard candies",
        "It reduces appetite overall, leading to uniform decreases in all food group consumption",
        "It triggers a preference for soft, sweet, acidic foods to stimulate salivary flow"
      ],
      correctAnswer: 1
    },
    {
      id: 90561,
      question: "What does research show about nutrient intake in older adults with fewer than 28 teeth?",
      options: [
        "They consume more dairy products to compensate for lost chewing efficiency",
        "They have elevated cholesterol and triglyceride levels from soft food preferences",
        "They show significantly reduced fruit and vegetable intake and lower serum folate and vitamin C",
        "They tend to eat more frequently throughout the day to compensate for smaller portions"
      ],
      correctAnswer: 2
    },
    {
      id: 90562,
      question: "What is sarcopenia as described in the context of older adult nutrition?",
      options: [
        "Reduced skeletal muscle mass replaced by fat tissue that occurs with aging",
        "A form of malnutrition specific to protein deficiency in institutionalized adults",
        "The accumulation of visceral fat in the abdominal cavity during later adulthood",
        "A condition of excess bone density causing joint pain and restricted movement"
      ],
      correctAnswer: 0
    },
    {
      id: 90563,
      question: "After age 45, lean body mass declines at what rate per year?",
      options: [
        "Up to 0.4% per year, accompanied by a corresponding increase in adipose tissue",
        "Up to 0.1% per year, a minimal decline with limited clinical significance",
        "Up to 0.2% per year, contributing gradually to reduced basal metabolic rate",
        "Up to 0.8% per year, leading to significant strength loss within a decade"
      ],
      correctAnswer: 0
    },
    {
      id: 90564,
      question: "What gastrointestinal change in older adults may impair absorption of calcium, iron, and vitamin B12?",
      options: [
        "Decreased bile acid production, reducing fat-soluble vitamin absorption",
        "Increased intestinal motility, shortening transit time for nutrient uptake",
        "Reduced pancreatic enzyme output, impairing protein and starch digestion",
        "Diminished hydrochloric acid secretion, reducing absorption of key micronutrients"
      ],
      correctAnswer: 3
    },
    {
      id: 90565,
      question: "Which gastrointestinal issue common in older adults benefits from fiber-containing foods, adequate fluid, and physical activity?",
      options: [
        "Acid reflux, which is worsened by low-fiber diets and sedentary behavior",
        "Constipation, resulting from altered gastrointestinal motility in aging",
        "Dysphagia, caused by esophageal motility changes and nerve deterioration",
        "Gastritis, which is linked to H. pylori infection and dietary acid exposure"
      ],
      correctAnswer: 1
    },
    {
      id: 90566,
      question: "What are the recommended daily vitamin D intakes for adults aged 51 to 70 and those aged 70 and older?",
      options: [
        "5 µg for ages 51-70 and 10 µg for ages 70+, based on reduced sun exposure",
        "15 µg for ages 51-70 and 20 µg for ages 70+, reflecting increased needs with age",
        "10 µg for ages 51-70 and 15 µg for ages 70+, reflecting moderate age-related increases",
        "20 µg for ages 51-70 and 25 µg for ages 70+, reflecting maximum tolerable levels"
      ],
      correctAnswer: 1
    },
    {
      id: 90567,
      question: "Why are requirements for folic acid, vitamin B6, and vitamin B12 increased in older adults?",
      options: [
        "To prevent decline in cognitive function and reduce risk for coronary artery disease",
        "To support bone density maintenance and reduce the risk of osteoporotic fractures",
        "To counteract reduced digestive enzyme production and improve nutrient absorption",
        "To maintain skin integrity and prevent age-related dermatological conditions"
      ],
      correctAnswer: 0
    },
    {
      id: 90568,
      question: "How do calorie needs and protein needs change in older adults compared to middle-aged adults?",
      options: [
        "Both calorie and protein needs decrease proportionally with decreased activity",
        "Both calorie and protein needs increase due to reduced absorption efficiency",
        "Protein needs decrease significantly while caloric needs remain relatively stable",
        "Calorie needs decrease with age, but protein needs remain proportional to body weight"
      ],
      correctAnswer: 3
    },
    {
      id: 90569,
      question: "Approximately how much high-quality protein per meal is recommended to maximize muscle protein synthesis in older adults?",
      options: [
        "25 to 30 g per meal to maximize muscle protein synthesis effectively",
        "10 to 15 g per meal to avoid exceeding kidney filtration capacity",
        "15 to 20 g per meal, matching standard adult protein recommendations",
        "20 to 25 g per meal, supporting mild muscle maintenance with minimal excess"
      ],
      correctAnswer: 0
    },
    {
      id: 90570,
      question: "Which of the following best explains why older adults may become dehydrated even without obvious fluid loss?",
      options: [
        "Decreased kidney function causes excessive diuresis, depleting body water rapidly",
        "Elevated basal metabolic rate in older adults increases insensible water losses",
        "Reduced gastric acid production impairs the body's ability to retain ingested fluids",
        "Decreased thirst associated with aging may lead to insufficient fluid intake"
      ],
      correctAnswer: 3
    },
    {
      id: 90571,
      question: "Infants have a higher resting metabolic rate than adults.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90572,
      question: "Infant protein intake should exceed 20% of total daily caloric intake to support rapid growth.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90573,
      question: "Lifelong food habits and attitudes are primarily formed during the adolescent years rather than the preschool years.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90574,
      question: "Preschool children aged 4 to 6 years may need 8 to 15 exposures to a new food before accepting it.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90575,
      question: "Only 9% of girls between the ages of 14 and 18 meet the recommended daily intake of calcium.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90576,
      question: "Caloric needs during the first trimester of pregnancy increase by an additional 340 calories per day.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90577,
      question: "The folate RDA during pregnancy is 600 µg per day, and adequate intake can prevent 50% to 70% of neural tube defects.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90578,
      question: "The Institute of Medicine concluded that calcium is the only nutrient warranting global supplementation during pregnancy.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90579,
      question: "During breastfeeding, protein requirements are slightly higher than during pregnancy, totaling 70 g per day.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90580,
      question: "Sarcopenia refers to increased bone resorption and the development of osteoporosis in older adults.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90581,
      question: "In older adults, calorie needs decrease with age but protein needs remain proportional to body weight and do not decrease.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90582,
      question: "Xerostomia in older adults can increase caries risk because they may choose hard candies to stimulate saliva production.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    }
  ],
  "9. Canada Food Guide to Healthy Eating": [
    {
      id: 90583,
      question: "According to the chapter, food patterns are generally developed during which period of life?",
      options: [
        "Adulthood, when individuals make independent choices",
        "Adolescence, when peer influence is strongest",
        "Childhood, shaped by cultural and environmental influences",
        "Old age, when health concerns drive food decisions"
      ],
      correctAnswer: 2
    },
    {
      id: 90584,
      question: "Which of the following is NOT listed as one of the five major control factors for food safety?",
      options: [
        "Personal hygiene and adequate cooking",
        "Keeping food at safe temperatures",
        "Avoiding foods from unsafe sources",
        "Using chemical preservatives in all food storage"
      ],
      correctAnswer: 3
    },
    {
      id: 90585,
      question: "Which of the following best describes the dental hygienist's recommended approach when counseling patients from diverse ethnic backgrounds?",
      options: [
        "Recommend eliminating all cultural foods and adopting standard North American dietary habits",
        "Avoid discussing food choices to prevent cultural conflict during appointments",
        "Be sensitive to preferences, avoid judgment, and adapt interventions to cultural and ethnic needs",
        "Focus exclusively on caloric intake rather than cultural food traditions"
      ],
      correctAnswer: 2
    },
    {
      id: 90586,
      question: "According to the chapter, what percentage of income may families living at the poverty level spend on food?",
      options: [
        "11%",
        "21%",
        "26%",
        "31%"
      ],
      correctAnswer: 3
    },
    {
      id: 90587,
      question: "Which of the following food groups is promoted as occupying half of the plate in Canada's Eat Well Plate?",
      options: [
        "Whole grain foods such as brown rice and quinoa",
        "Protein foods including both plant and animal sources",
        "Vegetables and fruits high in vitamins, minerals, and fibre",
        "Dairy products and calcium-rich alternatives"
      ],
      correctAnswer: 2
    },
    {
      id: 90588,
      question: "What does the term \"food quackery\" refer to, as defined in this chapter?",
      options: [
        "Exaggerated beliefs about the nutritional value of traditional ethnic foods",
        "Promotion of nutrition-related products or services with questionable safety or effectiveness",
        "The practice of food irradiation without regulatory approval or oversight",
        "Misleading food labeling by major grocery manufacturers"
      ],
      correctAnswer: 1
    },
    {
      id: 90589,
      question: "According to Canada's Food Guide (2019), which beverage is promoted as the drink of choice?",
      options: [
        "Low-fat milk or fortified plant-based beverages",
        "100% fruit juice consumed in moderate amounts",
        "Herbal teas with no added sugars or sweeteners",
        "Water, recommended over all other beverages"
      ],
      correctAnswer: 3
    },
    {
      id: 90590,
      question: "When were the most recent major updates to Canada's Food Guide made, and what was the key structural change?",
      options: [
        "2010; shifted focus to calorie counting and daily serving sizes",
        "2015; introduced the concept of the glycemic index for food ranking",
        "2019; replaced food group servings with proportional eating and behavior-based advice",
        "2022; added a fifth food group for plant-based proteins"
      ],
      correctAnswer: 2
    },
    {
      id: 90591,
      question: "Which of the following is identified as a benefit of food additives in this chapter?",
      options: [
        "Increasing caloric density to meet energy needs in low-income populations",
        "Reducing the need for refrigeration by eliminating all microorganisms",
        "Improving nutritional value through enrichment and maintaining product consistency",
        "Extending shelf life by replacing all natural ingredients with synthetic alternatives"
      ],
      correctAnswer: 2
    },
    {
      id: 90592,
      question: "In the context of food irradiation, which of the following accurately describes its primary purpose?",
      options: [
        "Enhancing the color and flavor of fruits and vegetables for consumer appeal",
        "Treating food with ionized radiation to kill spoilage- and disease-causing bacteria and molds",
        "Removing pesticide residues from conventionally grown produce",
        "Increasing the vitamin and mineral content of processed food products"
      ],
      correctAnswer: 1
    },
    {
      id: 90593,
      question: "What proportion of the plate in Canada's Eat Well Plate should consist of whole grain foods?",
      options: [
        "One half of the plate",
        "One third of the plate",
        "One quarter of the plate",
        "One fifth of the plate"
      ],
      correctAnswer: 2
    },
    {
      id: 90594,
      question: "Which of the following statements about organic foods is supported by this chapter?",
      options: [
        "The USDA confirms organic food is always safer and more nutritious than conventional food",
        "Organic foods are grown without synthetic pesticides, growth hormones, antibiotics, or genetic engineering",
        "Organic foods are priced comparably to conventionally produced foods in most markets",
        "Organic production methods guarantee higher levels of protein and vitamins in all products"
      ],
      correctAnswer: 1
    },
    {
      id: 90595,
      question: "According to the chapter, which of the following best describes how dental hygienists should respond to patients following fad diets?",
      options: [
        "Immediately recommend medically approved weight loss medications as an alternative",
        "Assess nutritional adequacy, provide evidence-based advice, and refer to a dietitian if needed",
        "Discourage all non-traditional diets without providing alternative recommendations",
        "Avoid discussing diet during dental appointments to stay within professional scope"
      ],
      correctAnswer: 1
    },
    {
      id: 90596,
      question: "Which of the following is a key difference between Canada's 2019 Food Guide and earlier versions?",
      options: [
        "It removed all mention of protein foods to promote vegan eating patterns",
        "It introduced mandatory calorie labels for the first time in Canadian history",
        "It moved away from specific serving sizes toward proportional eating and healthy habits",
        "It added a separate food group for dairy, distinguishing it from other protein sources"
      ],
      correctAnswer: 2
    },
    {
      id: 90597,
      question: "Which of the following is described as a barrier to healthy eating in this chapter?",
      options: [
        "Excessive consumption of organic and whole foods",
        "Over-reliance on cooking at home instead of eating out",
        "Food deserts or limited access to healthy foods in rural or low-income communities",
        "Too much nutrition knowledge leading to overly restrictive dietary choices"
      ],
      correctAnswer: 2
    },
    {
      id: 90598,
      question: "According to the chapter, how should cultural food behaviors and traditions be categorized when counseling patients?",
      options: [
        "As either acceptable or unacceptable based on North American dietary standards",
        "As either traditional or modern, with modern practices always preferred",
        "As beneficial, neutral, or potentially harmful, focusing change on harmful behaviors",
        "As nutritionally adequate or inadequate based solely on caloric value"
      ],
      correctAnswer: 2
    },
    {
      id: 90599,
      question: "Which of the following statements about fast food meals is presented in this chapter?",
      options: [
        "Fast food meals typically provide fewer than 500 kcal per serving on average",
        "Sodium content in fast food meals ranges from approximately 1000 to 2515 mg",
        "Fat content in fast food meals is rarely more than 20% of total calories consumed",
        "Mega-sized portions typically stay within recommended daily calorie limits"
      ],
      correctAnswer: 1
    },
    {
      id: 90600,
      question: "What is the \"Eat Well Plate\" primarily designed to represent in Canada's Food Guide?",
      options: [
        "An exact recipe template for a nutritionally complete daily meal",
        "The visual proportions of food groups that should appear on a healthy plate",
        "The minimum serving sizes required for each food group by age group",
        "A ranking system for foods based on caloric density and glycemic load"
      ],
      correctAnswer: 1
    },
    {
      id: 90601,
      question: "According to the chapter, which of the following foods provides the most nutrients relative to cost for low-income households?",
      options: [
        "Packaged cereals, canned soups, and frozen vegetables",
        "Fresh organic produce, lean meats, and whole grain pasta",
        "Beef, fresh potatoes, brown rice, wheat germ, milk, eggs, and peanut butter",
        "Fortified juices, vitamin supplements, and low-fat yogurt products"
      ],
      correctAnswer: 2
    },
    {
      id: 90602,
      question: "Which of the following is an example of a symbolic or religious food restriction mentioned in this chapter?",
      options: [
        "Avoiding gluten due to celiac disease or non-celiac gluten sensitivity",
        "Eliminating red meat to reduce saturated fat intake on medical advice",
        "Choosing organic produce to minimize pesticide exposure in daily meals",
        "Hindu reverence for the cow, influencing avoidance of beef in the diet"
      ],
      correctAnswer: 3
    },
    {
      id: 90603,
      question: "In the SMART goal framework presented in this chapter, which of the following is an example of a \"Time-bound\" goal?",
      options: [
        "Eat vegetables with at least two meals every single day of the week",
        "Cook one homemade meal using only whole foods each weekday",
        "Follow a weekly meal plan consistently for the next four weeks",
        "Prepare overnight oats on two mornings per week as a breakfast habit"
      ],
      correctAnswer: 2
    },
    {
      id: 90604,
      question: "Which of the following best describes the concept of a \"food fad\" as defined in this chapter?",
      options: [
        "A culturally specific eating pattern adopted by immigrant communities adapting to new countries",
        "A diet promoted by registered dietitians based on temporary clinical evidence",
        "A catchall term for nutritional nonsense characterized by exaggerated beliefs about food's role in health",
        "A government-approved dietary pattern that becomes widely popular over a short period"
      ],
      correctAnswer: 2
    },
    {
      id: 90605,
      question: "According to the chapter, which of the following describes how Canada's Food Guide addresses cultural diversity?",
      options: [
        "It promotes one universal eating pattern applicable to all Canadians regardless of background",
        "It is designed to be flexible across cultural and economic contexts, with specific resources for Indigenous peoples",
        "It recommends that all Canadians transition to a primarily plant-based diet within five years",
        "It provides a separate food guide for each major ethnic group represented in Canada"
      ],
      correctAnswer: 1
    },
    {
      id: 90606,
      question: "Which of the following recommendations is made for applying Canada's Food Guide in client dietary counseling?",
      options: [
        "Prescribe exact meal plans and portion sizes based on the national nutrient reference values",
        "Focus on eliminating all processed foods from the client's diet within the first session",
        "Tailor recommendations to age, cultural food practices, and oral health concerns",
        "Avoid using visual tools as they may oversimplify complex dietary recommendations"
      ],
      correctAnswer: 2
    },
    {
      id: 90607,
      question: "Which of the following is stated about convenience foods in this chapter?",
      options: [
        "They are nutritionally superior to home-cooked meals due to fortification requirements",
        "They are popular for saving time but typically contain more preservatives, fat, and sodium",
        "They are recommended as occasional substitutes that maintain full nutrient density",
        "They are regulated to contain no more than 10% of the daily value of sodium per serving"
      ],
      correctAnswer: 1
    },
    {
      id: 90608,
      question: "According to the chapter, a nutrient is considered stable during food processing and storage when what condition is met?",
      options: [
        "At least 70% of the original nutrient level is maintained after processing",
        "At least 75% of the original nutrient level is preserved under refrigerated conditions",
        "At least 80% of the original nutrient level is retained throughout the shelf life",
        "At least 85% of the original nutrient level is retained during processing and storage"
      ],
      correctAnswer: 3
    },
    {
      id: 90609,
      question: "Which eating habit recommendation from Canada's Food Guide focuses on emotional and social well-being?",
      options: [
        "Reading food labels to make more informed choices at the grocery store",
        "Cooking more often at home to increase food skills and reduce processed food intake",
        "Enjoying meals with others to support emotional and social well-being",
        "Being mindful of eating habits by recognizing personal hunger and fullness cues"
      ],
      correctAnswer: 2
    },
    {
      id: 90610,
      question: "What approach is recommended in the chapter when using open-ended questions during nutritional counseling of culturally diverse patients?",
      options: [
        "To compare the patient's dietary choices against the standard North American dietary guidelines",
        "To quickly identify nutritional deficiencies and recommend immediate dietary overhauls",
        "To determine which cultural foods should be immediately eliminated from the patient's diet",
        "To elicit information about the patient's dietary practices in a non-judgmental and respectful manner"
      ],
      correctAnswer: 3
    },
    {
      id: 90611,
      question: "Food patterns developed in childhood are influenced by cultural, socioeconomic, symbolic, geographical, and psychological factors.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90612,
      question: "According to the chapter, the USDA confirms that organic food is both safer and more nutritious than conventionally produced food.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90613,
      question: "Canada's Food Guide recommends that half of every plate should consist of vegetables and fruits.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90614,
      question: "Food quackery refers to the promotion of nutrition-related products or services with questionable safety and/or effectiveness.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90615,
      question: "Cultural food patterns tend to be maintained more consistently by younger family members and second-generation immigrants.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    }
  ],
  "7. Fluids (Part 2)": [
    {
      id: 90701,
      question: "Approximately what percentage of total body weight is water in a healthy adult?",
      options: [
        "50–60%",
        "75–80%",
        "30–40%",
        "65–70%"
      ],
      correctAnswer: 0
    },
    {
      id: 90702,
      question: "Which of the following correctly explains why fat tissue contains less water than muscle tissue?",
      options: [
        "Muscle tissue requires more water to support its metabolic and contractile activity",
        "Fat cells rely on a different chemical structure that displaces intracellular water",
        "Fat cells actively pump water out to maintain energy stores within the cell",
        "Fat tissue breaks down water through oxidation at a higher rate than muscle tissue"
      ],
      correctAnswer: 0
    },
    {
      id: 90703,
      question: "Water moves between intracellular and extracellular compartments primarily through which process?",
      options: [
        "Osmosis, driven by differences in solute concentration across cell membranes",
        "Active transport using ATP-dependent ion pumps located in cell membranes",
        "Diffusion of electrolytes from areas of low to high concentration in tissue",
        "Filtration through capillary walls driven by hydrostatic pressure gradients"
      ],
      correctAnswer: 0
    },
    {
      id: 90704,
      question: "Which of the following is a physiological role of water in the human body?",
      options: [
        "Regulating body temperature through the mechanism of sweating and evaporation",
        "Storing excess energy from macronutrients in the form of glycogen reserves",
        "Synthesizing glucose from amino acids during periods of prolonged fasting",
        "Producing red blood cells in the bone marrow through a hydration-dependent process"
      ],
      correctAnswer: 0
    },
    {
      id: 90705,
      question: "Which of the following is a sign of water deficiency related to the oral cavity?",
      options: [
        "Increased salivary production causing pooling of fluid under the tongue",
        "Swelling and redness of the gingival tissues due to fluid retention",
        "Proliferation of oral mucosa leading to thickening of the buccal lining",
        "Dry, fissured tongue caused by significantly reduced salivary flow"
      ],
      correctAnswer: 3
    },
    {
      id: 90706,
      question: "A patient reports that they feel hungry even after drinking water. This relates to which well-known water deficiency consideration?",
      options: [
        "Thirst being frequently confused with hunger, leading to excess food intake",
        "Increased fat metabolism triggered by dehydration mimicking a fasted state",
        "Reduced gastric acid production during dehydration affecting appetite signals",
        "Impaired glucose metabolism caused by low fluid volume in the blood"
      ],
      correctAnswer: 0
    },
    {
      id: 90707,
      question: "Which of the following correctly describes bottled water in comparison to tap water?",
      options: [
        "Bottled water is always derived from natural springs and contains added minerals",
        "Bottled water is chemically treated to remove all minerals including fluoride",
        "Bottled water contains a higher fluoride concentration than most municipal tap water",
        "Bottled water often comes from the same sources as tap water and frequently lacks fluoride"
      ],
      correctAnswer: 3
    },
    {
      id: 90708,
      question: "What approximate percentage of water is found in fruits and vegetables?",
      options: [
        "30–45%",
        "45–65%",
        "70–80%",
        "80–85%"
      ],
      correctAnswer: 3
    },
    {
      id: 90709,
      question: "Which of the following is classified as a TRACE element according to the lecture?",
      options: [
        "Fluorine",
        "Calcium",
        "Potassium",
        "Magnesium"
      ],
      correctAnswer: 0
    },
    {
      id: 90710,
      question: "Which of the following correctly defines an electrolyte?",
      options: [
        "A compound that becomes positively or negatively charged when dissolved in solution",
        "A mineral that is stored in bone and released when blood levels fall below normal",
        "A vitamin that enhances the absorption of calcium and phosphorus in the intestine",
        "A protein-bound mineral that carries nutrients across the cell membrane"
      ],
      correctAnswer: 0
    },
    {
      id: 90711,
      question: "Why must positive and negative ions be balanced in the body?",
      options: [
        "Imbalanced ions cause vitamin deficiencies by altering enzyme activity in the liver",
        "Ion imbalance leads to excess mineral deposition in the joints and renal tubules",
        "Ion balance prevents the oxidation of lipids in cell membranes during metabolism",
        "Ion balance is essential for regulating the body's overall hydration status"
      ],
      correctAnswer: 3
    },
    {
      id: 90712,
      question: "Which of the following best describes the initial step in the mineralization of dentin, cementum, and bone?",
      options: [
        "Calcium phosphate is deposited directly onto the surface of existing mineral crystals",
        "Hydroxyapatite crystals form spontaneously in the bloodstream before migrating to tissues",
        "A protein matrix or collagen deposition is laid down before mineral accumulation begins",
        "Fluoride ions bind to existing enamel to create a scaffold for further mineralization"
      ],
      correctAnswer: 2
    },
    {
      id: 90713,
      question: "What is apatite, as described in the context of mineralization?",
      options: [
        "A water-soluble protein that transports calcium to bone-forming cells in the periosteum",
        "A calcium phosphate complex that automatically crystallizes next to collagen fibers",
        "A fluoride-rich compound responsible for the acid resistance of mature enamel",
        "An organic matrix component made up of lipids that initiates mineralization in dentin"
      ],
      correctAnswer: 1
    },
    {
      id: 90714,
      question: "Which of the following explains why a lack of calcium is NOT critically important to the erupted tooth?",
      options: [
        "Erupted teeth receive continuous calcium supply through the pulp and periodontal ligament",
        "Enamel is remineralized daily by minerals in saliva, compensating for any dietary shortfall",
        "Enamel and dentin do not contain blood vessels or nerves, so post-eruption supply is limited but not critical",
        "Calcium is only needed during the developmental phase; erupted teeth are self-sustaining"
      ],
      correctAnswer: 2
    },
    {
      id: 90715,
      question: "The dentin in teeth is primarily composed of which of the following?",
      options: [
        "Fluorapatite crystals embedded in a network of elastin and keratin fibers",
        "Hydroxyapatite crystals embedded in collagen, containing calcium, phosphate, oxygen, and hydrogen",
        "Pure calcium carbonate crystals arranged in a layered crystalline matrix",
        "Calcium sulfate crystals reinforced with lipid-based proteins for acid resistance"
      ],
      correctAnswer: 1
    },
    {
      id: 90716,
      question: "How does saliva contribute to the prevention of dental caries, specifically related to calcium?",
      options: [
        "Saliva dilutes dietary sugars before they reach the enamel surface during food clearance",
        "Saliva releases proteolytic enzymes that break down cariogenic bacteria on enamel",
        "Saliva physically washes fermentable carbohydrates off the tooth surface after meals",
        "Saliva is supersaturated with calcium, helping to mineralize demineralized enamel and buffer acids"
      ],
      correctAnswer: 3
    },
    {
      id: 90717,
      question: "During periods of low blood calcium, which cell type breaks down bone to release calcium?",
      options: [
        "Osteoblasts",
        "Fibroblasts",
        "Osteoclasts",
        "Odontoblasts"
      ],
      correctAnswer: 2
    },
    {
      id: 90718,
      question: "What is the recommended daily calcium intake for adults aged 19 to 50 years?",
      options: [
        "500 mg per day",
        "750 mg per day",
        "1000 mg per day",
        "1500 mg per day"
      ],
      correctAnswer: 2
    },
    {
      id: 90719,
      question: "Which of the following is required to INCREASE calcium absorption in the body?",
      options: [
        "Vitamin C and iron taken together with calcium-rich foods at each meal",
        "Vitamin D and phosphorus, which facilitate calcium absorption in the small intestine",
        "Magnesium and zinc, which enhance calcium uptake across the intestinal wall",
        "Vitamin K and potassium, which stimulate calcium-binding proteins in the gut"
      ],
      correctAnswer: 1
    },
    {
      id: 90720,
      question: "Where in the gastrointestinal tract is calcium primarily absorbed?",
      options: [
        "Stomach",
        "Large intestine",
        "Duodenum only",
        "Small intestine"
      ],
      correctAnswer: 3
    },
    {
      id: 90721,
      question: "Which of the following is a symptom of Hypercalcemia mentioned in the lecture?",
      options: [
        "Tetany, muscle spasms, and neuromuscular excitability throughout the body",
        "Rickets, osteoporosis, and widespread hypomineralization of the skeleton",
        "Xerostomia, kidney stones, constipation, and inhibition of iron and zinc absorption",
        "Hypoplastic dentition, reduced alveolar bone density, and enamel mottling"
      ],
      correctAnswer: 2
    },
    {
      id: 90722,
      question: "Hypocalcemia causes a neuromuscular disorder known as:",
      options: [
        "Tetany",
        "Rickets",
        "Fluorosis",
        "Osteopenia"
      ],
      correctAnswer: 0
    },
    {
      id: 90723,
      question: "Which of the following best describes phosphorus in relation to its abundance in the body?",
      options: [
        "It is the most abundant mineral in the body and is found almost exclusively in teeth",
        "It is the second most abundant mineral and is present in all cells of the body",
        "It is a trace element found primarily in soft tissues and has limited systemic functions",
        "It is present only in calcified structures and requires supplementation in most diets"
      ],
      correctAnswer: 1
    },
    {
      id: 90724,
      question: "Which of the following is a role of phosphorus in the body?",
      options: [
        "Regulating blood glucose and facilitating insulin secretion from the pancreas",
        "Binding iron in the bloodstream to prevent oxidative damage to red blood cells",
        "Aiding in acid-base balance, energy transfer, and the composition of DNA and RNA",
        "Stimulating osteoblast activity and promoting collagen synthesis in alveolar bone"
      ],
      correctAnswer: 2
    },
    {
      id: 90725,
      question: "Where is phosphorus primarily absorbed in the gastrointestinal tract?",
      options: [
        "Stomach",
        "Jejunum",
        "Ileum",
        "Large intestine"
      ],
      correctAnswer: 1
    },
    {
      id: 90726,
      question: "A phosphorus deficiency during tooth development may result in which of the following?",
      options: [
        "Excessive enamel formation leading to crowding of teeth in the arch",
        "Incomplete calcification of teeth due to insufficient phosphorus for mineralization",
        "Premature eruption of primary teeth due to accelerated root formation",
        "Abnormal root morphology and increased susceptibility to external root resorption"
      ],
      correctAnswer: 1
    },
    {
      id: 90727,
      question: "Which of the following is correctly identified as a source of phosphorus in the diet?",
      options: [
        "Leafy green vegetables, legumes, and whole grain products",
        "Citrus fruits, berries, and root vegetables",
        "Milk products, meat, and food additives including baking products",
        "Nuts, seeds, and fermented dairy products such as yogurt"
      ],
      correctAnswer: 2
    },
    {
      id: 90728,
      question: "Which of the following best describes the role of magnesium in the body?",
      options: [
        "Magnesium primarily functions to transport oxygen to muscles and regulate iron metabolism",
        "Magnesium serves as the main structural component of tooth enamel and alveolar bone",
        "Magnesium is involved in energy metabolism, insulin activity, glucose use, and blood pressure control",
        "Magnesium functions mainly as an antioxidant protecting cell membranes from oxidative damage"
      ],
      correctAnswer: 2
    },
    {
      id: 90729,
      question: "What is the daily recommended intake of magnesium for adults according to the lecture?",
      options: [
        "About 120 mg per day",
        "About 210 mg per day",
        "About 310 mg per day",
        "About 420 mg per day"
      ],
      correctAnswer: 3
    },
    {
      id: 90730,
      question: "What are the oral implications of a magnesium dietary deficiency?",
      options: [
        "Increased susceptibility to caries due to reduced salivary buffering capacity",
        "Hypoplastic dentition and reduced alveolar bone density",
        "Enamel mottling and white-to-brown staining of the tooth surface",
        "Gingival hyperplasia and delayed eruption of permanent teeth"
      ],
      correctAnswer: 1
    },
    {
      id: 90731,
      question: "Fluoride is absorbed primarily in which part of the gastrointestinal tract?",
      options: [
        "Stomach, with small amounts also absorbed in the intestine",
        "Duodenum, where most mineral absorption occurs in the body",
        "Jejunum, the same site where phosphorus absorption takes place",
        "Large intestine, where water-soluble minerals are reclaimed"
      ],
      correctAnswer: 0
    },
    {
      id: 90732,
      question: "When calcium supplements and fluoride supplements are taken at the same time, what effect occurs?",
      options: [
        "Calcium enhances fluoride absorption, increasing its bioavailability significantly",
        "Fluoride replaces calcium in hydroxyapatite, increasing the rate of bone formation",
        "The two supplements compete for the same absorption pathway, resulting in no effect",
        "Fluoride absorption is inhibited when taken simultaneously with calcium supplements"
      ],
      correctAnswer: 3
    },
    {
      id: 90733,
      question: "What is the tolerable upper intake level of fluoride per day as stated in the lecture?",
      options: [
        "3 mg per day",
        "5 mg per day",
        "7 mg per day",
        "10 mg per day"
      ],
      correctAnswer: 3
    },
    {
      id: 90734,
      question: "How does topical fluoride protect teeth from acid attack?",
      options: [
        "It neutralizes dietary acids directly by raising the pH of the oral environment",
        "It increases salivary flow to dilute and clear acids from the tooth surface faster",
        "It replaces hydroxyl ions in hydroxyapatite to form fluorapatite, which is less soluble",
        "It seals exposed dentinal tubules to prevent acid penetration into the pulp chamber"
      ],
      correctAnswer: 2
    },
    {
      id: 90735,
      question: "Which of the following correctly describes MILD to MODERATE dental fluorosis?",
      options: [
        "Associated with increased caries susceptibility and severe structural pitting of enamel",
        "Associated with caries resistance and characterized by white to brown staining of enamel",
        "Caused by fluoride deficiency during enamel formation and marked by hypoplastic pits",
        "Caused by post-eruptive fluoride exposure and associated with rapid enamel dissolution"
      ],
      correctAnswer: 1
    },
    {
      id: 90736,
      question: "Which of the following correctly describes SEVERE dental fluorosis?",
      options: [
        "Characterized by white chalky spots and associated with strong caries resistance",
        "Presents as mild translucent banding across enamel with no structural involvement",
        "Associated with increased caries risk and characterized by brownish staining and pitting",
        "Results from topical fluoride overexposure after tooth eruption during adulthood"
      ],
      correctAnswer: 2
    },
    {
      id: 90737,
      question: "What is the conclusion drawn in the lecture regarding fluoride's link to diseases such as cancer and Alzheimer's disease?",
      options: [
        "Fluoride has been confirmed as a contributing factor to cancer in high-exposure populations",
        "No negative trends have been identified despite fluoride being one of the most researched health issues",
        "Fluoride's connection to Alzheimer's disease has been confirmed in several longitudinal studies",
        "Research on fluoride and systemic disease remains inconclusive with no peer-reviewed consensus"
      ],
      correctAnswer: 1
    },
    {
      id: 90738,
      question: "Which of the following populations is at HIGHEST risk for osteoporosis according to the lecture?",
      options: [
        "Young physically active males with low calcium intake during adolescence",
        "Obese men over the age of 40 who are sedentary and consume a low-protein diet",
        "Elderly men over the age of 65 and women beginning around the time of menopause",
        "Small, thin women, representing the highest risk group for developing osteoporosis"
      ],
      correctAnswer: 3
    },
    {
      id: 90739,
      question: "Which of the following medications is listed as a treatment for osteoporosis in the lecture?",
      options: [
        "Bisphosphonates and estrogen hormone therapy to slow or stop bone loss progression",
        "Calcium supplements and Vitamin D injections to reverse bone density loss",
        "Probiotic therapy and anti-inflammatory agents to reduce bone resorption rates",
        "Fluoride supplements and magnesium infusions to stimulate new bone formation"
      ],
      correctAnswer: 0
    },
    {
      id: 90740,
      question: "Which of the following oral conditions may be associated with osteoporosis according to the lecture?",
      options: [
        "Dental fluorosis, recurrent aphthous stomatitis, and xerostomia",
        "Tooth mobility or loss, alveolar bone resorption, TMD, and clinical attachment loss",
        "Enamel hypoplasia, halitosis, and increased sensitivity to acidic foods",
        "Gingival hyperplasia, delayed eruption of teeth, and hypercementosis"
      ],
      correctAnswer: 1
    },
    {
      id: 90741,
      question: "Water makes up approximately 75–80% of total body weight in infants but only 50–60% in adults.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90742,
      question: "Calcium and phosphorus in saliva act as buffers and help inhibit the development of dental caries.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90743,
      question: "Sodium fluoride has an absorption rate of approximately 80% and is primarily absorbed in the stomach.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90744,
      question: "Severe dental fluorosis is associated with caries resistance, similar to mild and moderate fluorosis.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
  ],
  "8. Nutrition in Various Stages of Life (Part 2)": [
    {
      id: 90801,
      question: "Which of the following best describes the primary focus of a Dental Hygienist when providing nutritional counselling?",
      options: [
        "Treating the client's systemic disease through dietary modification",
        "Replacing the role of a Registered Dietitian in managing chronic conditions",
        "Identifying harmful dietary habits and focusing on oral manifestations of healthy eating",
        "Prescribing specific diets to manage conditions such as Type II Diabetes"
      ],
      correctAnswer: 2
    },
    {
      id: 90802,
      question: "A Dental Hygienist is reviewing a client with diabetes. Which of the following actions falls WITHIN the DH's scope of practice?",
      options: [
        "Designing a carbohydrate-controlled meal plan to regulate the client's blood glucose levels",
        "Educating the client on oral side effects of their medications and suggesting xylitol gum for xerostomia",
        "Advising the client to stop taking their diabetes medication due to oral side effects",
        "Recommending insulin dosage changes based on the client's observed dietary intake"
      ],
      correctAnswer: 1
    },
    {
      id: 90803,
      question: "A client with lactose intolerance wants to maintain adequate calcium intake. Which of the following is the BEST recommendation?",
      options: [
        "Eliminate all dairy products and rely solely on calcium supplements prescribed by a physician",
        "Drink large amounts of regular milk at once to build lactose tolerance gradually over time",
        "Consume fermented dairy products like yogurt and aged cheese, which contain less lactose and active lactase",
        "Avoid all calcium-containing foods until a specialist has completed a full nutritional assessment"
      ],
      correctAnswer: 2
    },
    {
      id: 90804,
      question: "Which of the following vitamins and minerals may become deficient when a client with lactose intolerance significantly reduces dairy intake?",
      options: [
        "Vitamin D, Calcium, Phosphorus, and Riboflavin",
        "Iron, Zinc, and Vitamin C",
        "Vitamin A, Folate, and Potassium",
        "Thiamin, Niacin, and Vitamin B6"
      ],
      correctAnswer: 0
    },
    {
      id: 90805,
      question: "Which professional should a Dental Hygienist refer a client to when nutritional concerns extend beyond oral health management?",
      options: [
        "Registered Dietitian",
        "Registered Nurse",
        "Occupational Therapist",
        "Physiotherapist"
      ],
      correctAnswer: 0
    },
    {
      id: 90806,
      question: "When counselling an elderly client with limited ability to prepare or obtain food, the Dental Hygienist should recognize that:",
      options: [
        "Elderly clients should be referred to a physician before any nutritional discussion occurs",
        "The DH should provide a complete dietary plan to ensure the client's adequate nutrient intake",
        "Nutritional responsibility may shift to caregivers or family members who assist the client",
        "Elderly clients are fully responsible for their own nutritional choices regardless of circumstance"
      ],
      correctAnswer: 2
    },
    {
      id: 90807,
      question: "According to Canada's Food Guide principles discussed in the lecture, which statement best supports healthy eating habits for children?",
      options: [
        "Children should independently choose all foods from a young age to develop healthy autonomy",
        "Parents serve as role models and shared mealtimes help children develop healthy attitudes toward food",
        "Peer influence is the most important factor shaping a child's food preferences from infancy",
        "Children's food preferences should never be restricted as this may cause long-term psychological harm"
      ],
      correctAnswer: 1
    },
    {
      id: 90808,
      question: "Which food group is the PRIMARY source of Vitamin C according to the Nutrients in Food Groups table?",
      options: [
        "Vegetables and Fruit",
        "Milk and Alternatives",
        "Meat and Alternatives",
        "Grain Products"
      ],
      correctAnswer: 0
    },
    {
      id: 90809,
      question: "Which food group provides BOTH Vitamin B12 and Protein according to the Nutrients in Food Groups table?",
      options: [
        "Grain Products and Vegetables and Fruit combined",
        "Grain Products only",
        "Milk and Alternatives, and Meat and Alternatives",
        "Vegetables and Fruit, and Grain Products combined"
      ],
      correctAnswer: 2
    },
    {
      id: 90810,
      question: "According to the Nutrients in Food Groups table, which nutrient is found in ALL FOUR food groups?",
      options: [
        "Calcium",
        "Magnesium",
        "Vitamin C",
        "Riboflavin"
      ],
      correctAnswer: 1
    },
    {
      id: 90811,
      question: "Which of the following best explains why Canada's Food Guide recommends choosing lower-fat foods?",
      options: [
        "High-fat foods tend to contain more saturated and trans fats rather than healthier unsaturated fats",
        "Lower-fat foods have fewer calories and are more rapidly digested by the body",
        "Fat is not an essential macronutrient and should be minimized in all age groups",
        "All dietary fat is harmful to the body and should be completely eliminated"
      ],
      correctAnswer: 0
    },
    {
      id: 90812,
      question: "Why are high-sugar foods commonly referred to as \"empty calories\"?",
      options: [
        "They are high in calories but very low in nutrients, offering little nutritional value",
        "They are only harmful when consumed in large quantities in a single sitting",
        "They cause weight loss by speeding up the body's overall metabolic processes",
        "They contain no energy and have no effect on body weight or metabolism"
      ],
      correctAnswer: 0
    },
    {
      id: 90813,
      question: "The majority of dietary sodium in the average person's diet comes from:",
      options: [
        "Natural sodium found in fresh vegetables and fruits consumed daily",
        "Salt in packaged and processed foods and meals eaten outside the home",
        "Salt added during home cooking from a shaker at the dinner table",
        "Sodium supplements routinely prescribed by physicians and registered dietitians"
      ],
      correctAnswer: 1
    },
    {
      id: 90814,
      question: "Which of the following is the underlying cause of Lactose Malabsorption?",
      options: [
        "Overproduction of lactase enzyme leading to excessive lactose digestion",
        "Insufficient lactase enzyme, resulting in lactose being fermented by gut bacteria",
        "An autoimmune reaction to dairy proteins triggering intestinal inflammation",
        "A complete absence of gut bacteria needed for absorption of essential nutrients"
      ],
      correctAnswer: 1
    },
    {
      id: 90815,
      question: "Which of the following is NOT a symptom of Lactose Intolerance?",
      options: [
        "Flatulence",
        "Abdominal cramps",
        "Halitosis",
        "Skin rash"
      ],
      correctAnswer: 3
    },
    {
      id: 90816,
      question: "Which of the following is NOT listed as a cause of xerostomia in the lecture?",
      options: [
        "Radiation or chemotherapy",
        "High dietary sugar intake",
        "Tobacco and alcohol use",
        "Medications"
      ],
      correctAnswer: 1
    },
    {
      id: 90817,
      question: "Which of the following is an appropriate Dental Hygienist recommendation for a client experiencing xerostomia?",
      options: [
        "Advise the client to reduce fluid intake to prevent overstimulation of the salivary glands",
        "Prescribe saliva-stimulating medications and adjust the client's current prescriptions accordingly",
        "Suggest the client avoid all carbohydrate foods to reduce caries risk associated with dry mouth",
        "Increase fluid intake with meals, recommend xylitol products, and advise use of fluoride agents"
      ],
      correctAnswer: 3
    },
    {
      id: 90818,
      question: "A client with xerostomia is at increased risk for which of the following oral conditions?",
      options: [
        "Dental caries",
        "Gingival hyperplasia",
        "Dental fluorosis",
        "Enamel hypoplasia"
      ],
      correctAnswer: 0
    },
    {
      id: 90819,
      question: "Which of the following best describes Type II Diabetes Mellitus in terms of its metabolic mechanism?",
      options: [
        "The pancreas produces no insulin, causing blood glucose to drop critically low",
        "Excessive insulin production results in frequent and severe episodes of hypoglycemia",
        "The immune system destroys all insulin produced before it can act on body cells",
        "Insulin is produced normally or in excess, but cells fail to uptake glucose, keeping levels high"
      ],
      correctAnswer: 3
    },
    {
      id: 90820,
      question: "Which of the following is an appropriate Dental Hygienist consideration when managing a client with diabetes?",
      options: [
        "Prescribing a specific meal plan to directly help the client control blood glucose levels",
        "Advising the client to avoid all carbohydrates to maintain stable blood sugar at all times",
        "Monitoring blood glucose at every appointment and referring poorly controlled cases to an MD or dietitian",
        "Managing the client's insulin therapy based on dietary intake observed during dental appointments"
      ],
      correctAnswer: 2
    },
    {
      id: 90821,
      question: "When assessing a client with high caries risk, which of the following dietary factors should the Dental Hygienist evaluate?",
      options: [
        "Daily caloric intake and the fat-to-carbohydrate ratio in the client's meals",
        "Total daily protein intake and the specific type of protein source the client consumes",
        "Vitamin and mineral supplement use and daily hydration levels exclusively",
        "Frequency of fermentable carbohydrate intake, form, time of day, and acidic food consumption"
      ],
      correctAnswer: 3
    },
    {
      id: 90822,
      question: "Which of the following foods is recommended for clients with high caries risk because it can help increase oral pH?",
      options: [
        "Citrus fruits and carbonated water",
        "Milk, yogurt, and aged cheese",
        "White bread and honey",
        "Dried fruits and granola bars"
      ],
      correctAnswer: 1
    },
    {
      id: 90823,
      question: "After consuming acidic foods, what should the Dental Hygienist advise the client to do?",
      options: [
        "Brush teeth immediately to physically remove acid from the enamel surface",
        "Use a whitening toothpaste to counteract and neutralize acid erosion on teeth",
        "Rinse with water to neutralize the acids and wait before brushing the teeth",
        "Consume a sugary snack to help buffer the remaining acidity in the mouth"
      ],
      correctAnswer: 2
    },
    {
      id: 90824,
      question: "Which of the following strategies helps reduce the cariogenic impact of consuming sweets?",
      options: [
        "Eating sweets first thing in the morning on a completely empty stomach",
        "Substituting all sweets with acidic snacks such as citrus fruits and juices",
        "Consuming sweets separately from main meals to avoid interactions with other foods",
        "Eating sweets with meals, since fibre, proteins, and fats have cariostatic properties"
      ],
      correctAnswer: 3
    },
    {
      id: 90825,
      question: "Inadequate protein intake is particularly significant in dental hygiene practice because it:",
      options: [
        "Reduces enamel mineralization by limiting calcium absorption in the GI tract",
        "Leads to Vitamin B12 deficiency, causing glossitis and persistent oral ulcerations",
        "Increases caries risk by directly reducing the buffering capacity of saliva",
        "Impairs the systemic response to inflammation and infection, affecting periodontal healing"
      ],
      correctAnswer: 3
    },
    {
      id: 90826,
      question: "Which dietary pattern includes fish as the only animal protein source?",
      options: [
        "Pescatarian",
        "Pollotarian",
        "Ovovegetarian",
        "Flexitarian"
      ],
      correctAnswer: 0
    },
    {
      id: 90827,
      question: "Which of the following describes a Lacto-Vegetarian dietary pattern?",
      options: [
        "Includes eggs and dairy but excludes all types of meat and fish",
        "Avoids all animal products including all forms of dairy and eggs",
        "Includes dairy products but excludes eggs and all types of meat",
        "Includes fish as the only animal-sourced food consumed"
      ],
      correctAnswer: 2
    },
    {
      id: 90828,
      question: "What is a \"complementary food\" in the context of vegetarian nutrition?",
      options: [
        "A fortified food product fully designed to meet all nutritional needs of vegans",
        "A supplement taken alongside a vegetarian diet to replace animal protein entirely",
        "Any single vegetable that naturally contains all nine essential amino acids on its own",
        "A food eaten together with another to collectively provide all essential amino acids"
      ],
      correctAnswer: 3
    },
    {
      id: 90829,
      question: "What are the oral manifestations of Celiac Disease mentioned in the lecture?",
      options: [
        "Halitosis, gingival hyperplasia, and increased tooth sensitivity",
        "Xerostomia, tooth erosion, and angular cheilitis",
        "Delayed eruption, enamel deficits, and recurrent aphthous stomatitis",
        "Gingival recession, increased tooth mobility, and alveolar bone loss"
      ],
      correctAnswer: 2
    },
    {
      id: 90830,
      question: "How does Celiac Disease affect nutrient absorption?",
      options: [
        "It increases carbohydrate absorption by enhancing enzymatic activity in the stomach",
        "It blocks fat absorption in the large intestine by altering the gut bacteria composition",
        "It prevents protein digestion by significantly reducing the production of stomach acid",
        "It triggers an immune attack on the microvilli in the small intestine, contributing to malabsorption"
      ],
      correctAnswer: 3
    },
    {
      id: 90831,
      question: "Which of the following BEST distinguishes Celiac Disease from Gluten Intolerance?",
      options: [
        "Celiac disease is an autoimmune disorder with intestinal damage; gluten intolerance causes GI symptoms without autoimmune damage",
        "Gluten intolerance leads to microvilli destruction, while celiac disease only causes mild discomfort",
        "Both conditions have identical mechanisms but differ only in the overall severity of symptoms",
        "Celiac disease affects only children, while gluten intolerance is exclusively an adult-onset condition"
      ],
      correctAnswer: 0
    },
    {
      id: 90832,
      question: "A client reports changes in taste and smell affecting their appetite. According to the lecture, which deficiency could contribute to gustatory or olfactory disorders?",
      options: [
        "Vitamin D and Calcium deficiency from reduced dairy intake",
        "Vitamin B12 or Zinc deficiency",
        "Iron and Folate deficiency from low vegetable and grain consumption",
        "Vitamin C and Potassium deficiency from low fruit and vegetable intake"
      ],
      correctAnswer: 1
    },
    {
      id: 90833,
      question: "Why is it clinically important for a Dental Hygienist to consider a client's edentulous status or ill-fitting dentures when assessing nutritional health?",
      options: [
        "Difficulty chewing reduces food variety and impairs digestion if food is not adequately broken down",
        "Ill-fitting dentures increase caries risk by trapping food particles beneath the appliance",
        "Edentulous clients cannot absorb fat-soluble vitamins without the mechanical stimulation of mastication",
        "Edentulous clients require additional protein supplementation to compensate for the loss of teeth"
      ],
      correctAnswer: 0
    },
    {
      id: 90834,
      question: "Acid reflux and chronic vomiting are nutritionally and clinically significant in dental hygiene because they:",
      options: [
        "Increase the risk of periodontal disease by fundamentally altering the pH of the gingival crevice",
        "Lead to Vitamin D and Calcium deficiency by preventing their absorption in the small intestine",
        "Increase salivary flow, which dilutes protective antibodies present in the oral cavity",
        "May cause enamel erosion and sensitivity, and may indicate the presence of an eating disorder"
      ],
      correctAnswer: 3
    },
    {
      id: 90835,
      question: "How do antibiotics affect nutritional absorption, specifically regarding Vitamin K?",
      options: [
        "Antibiotics increase Vitamin K absorption by eliminating all competing gut bacteria",
        "Antibiotics have no effect on vitamin absorption since vitamins are absorbed in the stomach",
        "Antibiotics alter the gut microbiome and may reduce bacterial production of Vitamin K, impairing absorption",
        "Antibiotics directly bind to Vitamin K in the gut and permanently prevent its absorption"
      ],
      correctAnswer: 2
    },
    {
      id: 90836,
      question: "Which clients should consult a dietitian BEFORE using probiotic supplements?",
      options: [
        "Clients who are pregnant or currently breastfeeding",
        "Clients who are taking fluoride supplements or fluoride rinses as part of treatment",
        "Clients who follow a strict vegetarian or vegan dietary lifestyle",
        "Clients who are immunosuppressed"
      ],
      correctAnswer: 3
    },
    {
      id: 90837,
      question: "Which of the following is the most prevalent enzyme deficiency mentioned in the context of bariatric surgery and enzymatic deficiencies in the lecture?",
      options: [
        "Lactase deficiency",
        "Amylase deficiency",
        "Lipase deficiency",
        "Protease deficiency"
      ],
      correctAnswer: 0
    },
    {
      id: 90838,
      question: "Which dietary strategy is recommended in the lecture for clients with new dentures who experience gustatory or olfactory changes?",
      options: [
        "Switching to a completely liquid diet to accommodate taste and texture sensitivities",
        "Experimenting with herbs and spices to reignite interest in food consumption",
        "Eliminating all strong-flavoured foods to avoid overstimulating altered taste receptors",
        "Increasing salt and sugar intake to enhance perceived flavour with reduced taste sensitivity"
      ],
      correctAnswer: 1
    },
    {
      id: 90839,
      question: "A mother is breastfeeding and concerned about her infant's oral health. Which of the following is an appropriate action for a Dental Hygienist?",
      options: [
        "Recommend the mother discontinue breastfeeding due to the cariogenic nature of breast milk",
        "Refer the mother immediately to a dietitian to evaluate the nutritional adequacy of breast milk",
        "Advise the mother to wipe her child's teeth after breastfeeding to reduce the infant's caries risk",
        "Prescribe fluoride supplements to counteract the sugar content present in breast milk"
      ],
      correctAnswer: 2
    },
    {
      id: 90840,
      question: "Which of the following factors should a Dental Hygienist be mindful of when providing dietary counselling to clients from diverse backgrounds?",
      options: [
        "Only the client's clinical diagnosis and currently prescribed medications",
        "Religious dietary guidelines, socioeconomic restrictions, and personal food preferences",
        "The client's age and gender as the primary determinants of their dietary needs",
        "National food guide recommendations applied uniformly without adapting to individual circumstances"
      ],
      correctAnswer: 1
    },
    {
      id: 90841,
      question: "It is within the Dental Hygienist's scope of practice to provide nutritional advice specifically aimed at treating a client's systemic disease.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90842,
      question: "Lactose intolerance generally worsens with age, and all healthy infants can successfully digest lactose in human milk.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90843,
      question: "Fermented dairy products such as yogurt and aged cheese are generally better tolerated by lactose-intolerant individuals because they contain more lactose than regular milk.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90844,
      question: "Celiac disease is an autoimmune disorder in which gluten consumption triggers an immune response that attacks the microvilli in the small intestine.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90845,
      question: "Clients who are immunosuppressed can safely begin probiotic supplementation without first consulting a healthcare professional.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
  ]
};
